export const countryList = [
  {
    num_code: '4',
    alpha_2_code: 'AF',
    alpha_3_code: 'AFG',
    en_short_name: 'Afghanistan',
    nationality: 'Afghan',
    dial_code: '+93',
    nameTranslations: {
      sk: 'Afganistan',
      se: 'Afghanistan',
      pl: 'Afganistan',
      no: 'Afghanistan',
      ja: 'アフガニスタン',
      it: 'Afghanistan',
      zh: '阿富汗',
      nl: 'Afghanistan',
      de: 'Afghanistan',
      fr: 'Afghanistan',
      es: 'Afganistán',
      en: 'Afghanistan',
      pt_BR: 'Afeganistão',
      'sr-Cyrl': 'Авганистан',
      'sr-Latn': 'Avganistan',
      zh_TW: '阿富汗',
      tr: 'Afganistan',
      ro: 'Afganistan',
      ar: 'أفغانستان',
      fa: 'افغانستان',
      yue: '阿富汗',
    },
  },
  {
    num_code: '248',
    alpha_2_code: 'AX',
    alpha_3_code: 'ALA',
    en_short_name: 'Åland Islands',
    nationality: 'Åland Island',
    dial_code: '+358',
    nameTranslations: {
      sk: 'Alandy',
      se: 'Ålánda',
      pl: 'Wyspy Alandzkie',
      no: 'Åland',
      ja: 'オーランド諸島',
      it: 'Isole Åland',
      zh: '奥兰群岛',
      nl: 'Åland',
      de: 'Ålandinseln',
      fr: 'Îles Åland',
      es: 'Islas Åland',
      en: 'Åland Islands',
      pt_BR: 'Ilhas Aland',
      'sr-Cyrl': 'Аландска Острва',
      'sr-Latn': 'Alandska Ostrva',
      zh_TW: '奧蘭群島',
      tr: 'Åland',
      ro: 'Insulele Åland',
      ar: 'جزر أولاند',
      fa: 'جزیره اولاند',
      yue: '奧蘭群島',
    },
  },
  {
    num_code: '8',
    alpha_2_code: 'AL',
    alpha_3_code: 'ALB',
    en_short_name: 'Albania',
    nationality: 'Albanian',
    dial_code: '+355',
    nameTranslations: {
      sk: 'Albánsko',
      se: 'Albánia',
      pl: 'Albania',
      no: 'Albania',
      ja: 'アルバニア',
      it: 'Albania',
      zh: '阿尔巴尼亚',
      nl: 'Albanië',
      de: 'Albanien',
      fr: 'Albanie',
      es: 'Albania',
      en: 'Albania',
      pt_BR: 'Albânia',
      'sr-Cyrl': 'Албанија',
      'sr-Latn': 'Albanija',
      zh_TW: '阿爾巴尼亞',
      tr: 'Arnavutluk',
      ro: 'Albania',
      ar: 'ألبانيا',
      fa: 'آلبانی',
      yue: '阿爾巴尼亞',
    },
  },
  {
    num_code: '12',
    alpha_2_code: 'DZ',
    alpha_3_code: 'DZA',
    en_short_name: 'Algeria',
    nationality: 'Algerian',
    dial_code: '+213',
    nameTranslations: {
      sk: 'Alžírsko',
      se: 'Algeria',
      pl: 'Algieria',
      no: 'Algerie',
      ja: 'アルジェリア',
      it: 'Algeria',
      zh: '阿尔及利亚',
      nl: 'Algerije',
      de: 'Algerien',
      fr: 'Algérie',
      es: 'Argelia',
      en: 'Algeria',
      pt_BR: 'Argélia',
      'sr-Cyrl': 'Аргентина',
      'sr-Latn': 'Argentina',
      zh_TW: '阿爾及利亞',
      tr: 'Cezayir',
      ro: 'Algeria',
      ar: 'الجزائر',
      fa: 'الجزیره',
      yue: '阿爾及利亞',
    },
  },
  {
    num_code: '16',
    alpha_2_code: 'AS',
    alpha_3_code: 'ASM',
    en_short_name: 'American Samoa',
    nationality: 'American Samoan',
    dial_code: '+1684',
    nameTranslations: {
      sk: 'Americká Samoa',
      se: 'Amerihká Samoa',
      pl: 'Samoa Amerykańskie',
      no: 'Amerikansk Samoa',
      ja: '米領サモア',
      it: 'Samoa americane',
      zh: '美属萨摩亚',
      nl: 'Amerikaans-Samoa',
      de: 'Amerikanisch-Samoa',
      fr: 'Samoa américaines',
      es: 'Samoa Americana',
      en: 'American Samoa',
      pt_BR: 'Samoa Americana',
      'sr-Cyrl': 'Америчка Самоа',
      'sr-Latn': 'Američka Samoa',
      zh_TW: '美屬薩摩亞',
      tr: 'Amerikan Samoası',
      ro: 'Samoa Americană',
      ar: 'ساموا الأمريكية',
      fa: 'ساموا آمریکا',
      yue: '美屬薩摩亞',
    },
  },
  {
    num_code: '20',
    alpha_2_code: 'AD',
    alpha_3_code: 'AND',
    en_short_name: 'Andorra',
    nationality: 'Andorran',
    dial_code: '+376',
    nameTranslations: {
      sk: 'Andorra',
      se: 'Andorra',
      pl: 'Andora',
      no: 'Andorra',
      ja: 'アンドラ',
      it: 'Andorra',
      zh: '安道尔',
      nl: 'Andorra',
      de: 'Andorra',
      fr: 'Andorre',
      es: 'Andorra',
      en: 'Andorra',
      pt_BR: 'Andorra',
      'sr-Cyrl': 'Андора',
      'sr-Latn': 'Andora',
      zh_TW: '安道爾',
      tr: 'Andora',
      ro: 'Andorra',
      ar: 'أندورا',
      fa: 'آندورا',
      yue: '安道爾',
    },
  },
  {
    num_code: '24',
    alpha_2_code: 'AO',
    alpha_3_code: 'AGO',
    en_short_name: 'Angola',
    nationality: 'Angolan',
    dial_code: '+244',
    nameTranslations: {
      sk: 'Angola',
      se: 'Angola',
      pl: 'Angola',
      no: 'Angola',
      ja: 'アンゴラ',
      it: 'Angola',
      zh: '安哥拉',
      nl: 'Angola',
      de: 'Angola',
      fr: 'Angola',
      es: 'Angola',
      en: 'Angola',
      pt_BR: 'Angola',
      'sr-Cyrl': 'Ангола',
      'sr-Latn': 'Angola',
      zh_TW: '安哥拉',
      tr: 'Angola',
      ro: 'Angola',
      ar: 'أنغولا',
      fa: 'آنگولا',
      yue: '安哥拉',
    },
  },
  {
    num_code: '660',
    alpha_2_code: 'AI',
    alpha_3_code: 'AIA',
    en_short_name: 'Anguilla',
    nationality: 'Anguillan',
    dial_code: '+1264',
    nameTranslations: {
      sk: 'Anguilla',
      se: 'Anguilla',
      pl: 'Anguilla',
      no: 'Anguilla',
      ja: 'アンギラ',
      it: 'Anguilla',
      zh: '安圭拉',
      nl: 'Anguilla',
      de: 'Anguilla',
      fr: 'Anguilla',
      es: 'Anguila',
      en: 'Anguilla',
      pt_BR: 'Anguilla',
      'sr-Cyrl': 'Ангвила',
      'sr-Latn': 'Angvila',
      zh_TW: '安圭拉',
      tr: 'Anguilla',
      ro: 'Anguilla',
      ar: 'أنغويلا',
      fa: 'آنگولیا',
      yue: '安圭拉',
    },
  },
  {
    num_code: '10',
    alpha_2_code: 'AQ',
    alpha_3_code: 'ATA',
    en_short_name: 'Antarctica',
    nationality: 'Antarctic',
    dial_code: '+672',
    nameTranslations: {
      sk: 'Antarktída',
      se: 'Antárktis',
      pl: 'Antarktyda',
      no: 'Antarktis',
      ja: '南極',
      it: 'Antartide',
      zh: '南极洲',
      nl: 'Antarctica',
      de: 'Antarktis',
      fr: 'Antarctique',
      es: 'Antártida',
      en: 'Antarctica',
      pt_BR: 'Antártica',
      'sr-Cyrl': 'Антарктик',
      'sr-Latn': 'Antarktik',
      zh_TW: '南極',
      tr: 'Antarktika',
      ro: 'Antarctica',
      ar: 'القارة القطبية الجنوبية',
      fa: 'قطب جنوب',
      yue: '南极洲',
    },
  },
  {
    num_code: '28',
    alpha_2_code: 'AG',
    alpha_3_code: 'ATG',
    en_short_name: 'Antigua & Barbuda',
    nationality: 'Antiguan or Barbudan',
    dial_code: '+1268',
    nameTranslations: {
      sk: 'Antigua a Barbuda',
      se: 'Antigua ja Barbuda',
      pl: 'Antigua i Barbuda',
      no: 'Antigua og Barbuda',
      ja: 'アンティグア・バーブーダ',
      it: 'Antigua e Barbuda',
      zh: '安提瓜和巴布达',
      nl: 'Antigua en Barbuda',
      de: 'Antigua und Barbuda',
      fr: 'Antigua-et-Barbuda',
      es: 'Antigua y Barbuda',
      en: 'Antigua & Barbuda',
      pt_BR: 'Antigua e Barbuda',
      'sr-Cyrl': 'Антигва и Барбуда',
      'sr-Latn': 'Antigva i Barbuda',
      zh_TW: '安提瓜和巴布達',
      tr: 'Antigua ve Barbuda',
      ro: 'Antigua şi Barbuda',
      ar: 'أنتيغوا وباربودا',
      fa: 'آنتیگوآ و باربودا',
      yue: '安提瓜同巴布达',
    },
  },
  {
    num_code: '32',
    alpha_2_code: 'AR',
    alpha_3_code: 'ARG',
    en_short_name: 'Argentina',
    nationality: 'Argentine',
    dial_code: '+54',
    nameTranslations: {
      sk: 'Argentína',
      se: 'Argentina',
      pl: 'Argentyna',
      no: 'Argentina',
      ja: 'アルゼンチン',
      it: 'Argentina',
      zh: '阿根廷',
      nl: 'Argentinië',
      de: 'Argentinien',
      fr: 'Argentine',
      es: 'Argentina',
      en: 'Argentina',
      pt_BR: 'Argentina',
      'sr-Cyrl': 'Аргентина',
      'sr-Latn': 'Argentina',
      zh_TW: '阿根廷',
      tr: 'Arjantin',
      ro: 'Argentina',
      ar: 'الأرجنتين',
      fa: 'آرژانتین',
      yue: '阿根廷',
    },
  },
  {
    num_code: '51',
    alpha_2_code: 'AM',
    alpha_3_code: 'ARM',
    en_short_name: 'Armenia',
    nationality: 'Armenian',
    dial_code: '+374',
    nameTranslations: {
      sk: 'Arménsko',
      se: 'Armenia',
      pl: 'Armenia',
      no: 'Armenia',
      ja: 'アルメニア',
      it: 'Armenia',
      zh: '亚美尼亚',
      nl: 'Armenië',
      de: 'Armenien',
      fr: 'Arménie',
      es: 'Armenia',
      en: 'Armenia',
      pt_BR: 'Armênia',
      'sr-Cyrl': 'Јерменија',
      'sr-Latn': 'Jermenija',
      zh_TW: '亞美尼亞',
      tr: 'Ermenistan',
      ro: 'Armenia',
      ar: 'أرمينيا',
      fa: 'ارمنستان',
      yue: '亞美尼亞',
    },
  },
  {
    num_code: '533',
    alpha_2_code: 'AW',
    alpha_3_code: 'ABW',
    en_short_name: 'Aruba',
    nationality: 'Aruban',
    dial_code: '+297',
    nameTranslations: {
      sk: 'Aruba',
      se: 'Aruba',
      pl: 'Aruba',
      no: 'Aruba',
      ja: 'アルバ',
      it: 'Aruba',
      zh: '阿鲁巴',
      nl: 'Aruba',
      de: 'Aruba',
      fr: 'Aruba',
      es: 'Aruba',
      en: 'Aruba',
      pt_BR: 'Aruba',
      'sr-Cyrl': 'Аруба',
      'sr-Latn': 'Aruba',
      zh_TW: '阿魯巴',
      tr: 'Aruba',
      ro: 'Aruba',
      ar: 'أروبا',
      fa: 'آروبا',
      yue: '阿魯巴島',
    },
  },
  {
    num_code: '36',
    alpha_2_code: 'AU',
    alpha_3_code: 'AUS',
    en_short_name: 'Australia',
    nationality: 'Australian',
    dial_code: '+61',
    nameTranslations: {
      sk: 'Austrália',
      se: 'Austrália',
      pl: 'Australia',
      no: 'Australia',
      ja: 'オーストラリア',
      it: 'Australia',
      zh: '澳大利亚',
      nl: 'Australië',
      de: 'Australien',
      fr: 'Australie',
      es: 'Australia',
      en: 'Australia',
      pt_BR: 'Austrália',
      'sr-Cyrl': 'Аустралија',
      'sr-Latn': 'Australija',
      zh_TW: '澳州',
      tr: 'Avustralya',
      ro: 'Australia',
      ar: 'أستراليا',
      fa: 'استرالیا',
      yue: '澳洲',
    },
  },
  {
    num_code: '40',
    alpha_2_code: 'AT',
    alpha_3_code: 'AUT',
    en_short_name: 'Austria',
    nationality: 'Austrian',
    dial_code: '+43',
    nameTranslations: {
      sk: 'Rakúsko',
      se: 'Nuortariika',
      pl: 'Austria',
      no: 'Østerrike',
      ja: 'オーストリア',
      it: 'Austria',
      zh: '奥地利',
      nl: 'Oostenrijk',
      de: 'Österreich',
      fr: 'Autriche',
      es: 'Austria',
      en: 'Austria',
      pt_BR: 'Áustria',
      'sr-Cyrl': 'Аустрија',
      'sr-Latn': 'Austrija',
      zh_TW: '奥地利',
      tr: 'Avusturya',
      ro: 'Austria',
      ar: 'النمسا',
      fa: 'اتریش',
      yue: '奧地利',
    },
  },
  {
    num_code: '31',
    alpha_2_code: 'AZ',
    alpha_3_code: 'AZE',
    en_short_name: 'Azerbaijan',
    nationality: 'Azerbaijani, Azeri',
    dial_code: '+994',
    nameTranslations: {
      sk: 'Azerbajdžan',
      se: 'Aserbaižan',
      pl: 'Azerbejdżan',
      no: 'Aserbajdsjan',
      ja: 'アゼルバイジャン',
      it: 'Azerbaigian',
      zh: '阿塞拜疆',
      nl: 'Azerbeidzjan',
      de: 'Aserbaidschan',
      fr: 'Azerbaïdjan',
      es: 'Azerbaiyán',
      en: 'Azerbaijan',
      pt_BR: 'Azerbaijão',
      'sr-Cyrl': 'Азербејџан',
      'sr-Latn': 'Azerbejdžan',
      zh_TW: '亞塞拜然',
      tr: 'Azerbaycan',
      ro: 'Azerbaidjan',
      ar: 'أذربيجان',
      fa: 'آذربایجان',
      yue: '阿塞拜疆',
    },
  },
  {
    num_code: '44',
    alpha_2_code: 'BS',
    alpha_3_code: 'BHS',
    en_short_name: 'Bahamas',
    nationality: 'Bahamian',
    dial_code: '+1242',
    nameTranslations: {
      sk: 'Bahamy',
      se: 'Bahamas',
      pl: 'Bahamy',
      no: 'Bahamas',
      ja: 'バハマ',
      it: 'Bahamas',
      zh: '巴哈马',
      nl: "Bahama's",
      de: 'Bahamas',
      fr: 'Bahamas',
      es: 'Bahamas',
      en: 'Bahamas',
      pt_BR: 'Bahamas',
      'sr-Cyrl': 'Бахаме',
      'sr-Latn': 'Bahame',
      zh_TW: '巴哈馬',
      tr: 'Bahama',
      ro: 'Bahamas',
      ar: 'باهاماس',
      fa: 'باهاماس',
      yue: '巴哈馬',
    },
  },
  {
    num_code: '48',
    alpha_2_code: 'BH',
    alpha_3_code: 'BHR',
    en_short_name: 'Bahrain',
    nationality: 'Bahraini',
    dial_code: '+973',
    nameTranslations: {
      sk: 'Bahrajn',
      se: 'Bahrain',
      pl: 'Bahrajn',
      no: 'Bahrain',
      ja: 'バーレーン',
      it: 'Bahrein',
      zh: '巴林',
      nl: 'Bahrein',
      de: 'Bahrain',
      fr: 'Bahreïn',
      es: 'Baréin',
      en: 'Bahrain',
      pt_BR: 'Bahrain',
      'sr-Cyrl': 'Бахреин',
      'sr-Latn': 'Bahrein',
      zh_TW: '巴林',
      tr: 'Bahreyn',
      ro: 'Bahrein',
      ar: 'البحرين',
      fa: 'بحرین',
      yue: '巴林',
    },
  },
  {
    num_code: '50',
    alpha_2_code: 'BD',
    alpha_3_code: 'BGD',
    en_short_name: 'Bangladesh',
    nationality: 'Bangladeshi',
    dial_code: '+880',
    nameTranslations: {
      sk: 'Bangladéš',
      se: 'Bangladesh',
      pl: 'Bangladesz',
      no: 'Bangladesh',
      ja: 'バングラデシュ',
      it: 'Bangladesh',
      zh: '孟加拉国',
      nl: 'Bangladesh',
      de: 'Bangladesch',
      fr: 'Bangladesh',
      es: 'Bangladés',
      en: 'Bangladesh',
      pt_BR: 'Bangladesh',
      'sr-Cyrl': 'Бангладеш',
      'sr-Latn': 'Bangladeš',
      zh_TW: '孟加拉',
      tr: 'Bangladeş',
      ro: 'Bangladesh',
      ar: 'بنغلاديش',
      fa: 'بنگلادش',
      yue: '孟加拉囯',
    },
  },
  {
    num_code: '52',
    alpha_2_code: 'BB',
    alpha_3_code: 'BRB',
    en_short_name: 'Barbados',
    nationality: 'Barbadian',
    dial_code: '+1246',
    nameTranslations: {
      sk: 'Barbados',
      se: 'Barbados',
      pl: 'Barbados',
      no: 'Barbados',
      ja: 'バルバドス',
      it: 'Barbados',
      zh: '巴巴多斯',
      nl: 'Barbados',
      de: 'Barbados',
      fr: 'Barbade',
      es: 'Barbados',
      en: 'Barbados',
      pt_BR: 'Barbados',
      'sr-Cyrl': 'Барбадос',
      'sr-Latn': 'Barbados',
      zh_TW: '巴巴多斯',
      tr: 'Barbados',
      ro: 'Barbados',
      ar: 'باربادوس',
      fa: 'باربادوس',
      yue: '巴巴多斯',
    },
  },
  {
    num_code: '112',
    alpha_2_code: 'BY',
    alpha_3_code: 'BLR',
    en_short_name: 'Belarus',
    nationality: 'Belarusian',
    dial_code: '+375',
    nameTranslations: {
      sk: 'Bielorusko',
      se: 'Vilges-Ruošša',
      pl: 'Białoruś',
      no: 'Hviterussland',
      ja: 'ベラルーシ',
      it: 'Bielorussia',
      zh: '白俄罗斯',
      nl: 'Belarus',
      de: 'Belarus',
      fr: 'Biélorussie',
      es: 'Bielorrusia',
      en: 'Belarus',
      pt_BR: 'Bielo-Rússia',
      'sr-Cyrl': 'Белорусија',
      'sr-Latn': 'Belorusija',
      zh_TW: '白俄羅斯',
      tr: 'Belarus',
      ro: 'Belarus',
      ar: 'بيلاروس',
      fa: 'بلاروس',
      yue: '白俄羅斯',
    },
  },
  {
    num_code: '56',
    alpha_2_code: 'BE',
    alpha_3_code: 'BEL',
    en_short_name: 'Belgium',
    nationality: 'Belgian',
    dial_code: '+32',
    nameTranslations: {
      sk: 'Belgicko',
      se: 'Belgia',
      pl: 'Belgia',
      no: 'Belgia',
      ja: 'ベルギー',
      it: 'Belgio',
      zh: '比利时',
      nl: 'België',
      de: 'Belgien',
      fr: 'Belgique',
      es: 'Bélgica',
      en: 'Belgium',
      pt_BR: 'Bélgica',
      'sr-Cyrl': 'Белгија',
      'sr-Latn': 'Belgija',
      zh_TW: '比利時',
      tr: 'Belçika',
      ro: 'Belgia',
      ar: 'بلجيكا',
      fa: 'بلژیک',
      yue: '比利時',
    },
  },
  {
    num_code: '84',
    alpha_2_code: 'BZ',
    alpha_3_code: 'BLZ',
    en_short_name: 'Belize',
    nationality: 'Belizean',
    dial_code: '+501',
    nameTranslations: {
      sk: 'Belize',
      se: 'Belize',
      pl: 'Belize',
      no: 'Belize',
      ja: 'ベリーズ',
      it: 'Belize',
      zh: '伯利兹',
      nl: 'Belize',
      de: 'Belize',
      fr: 'Belize',
      es: 'Belice',
      en: 'Belize',
      pt_BR: 'Belize',
      'sr-Cyrl': 'Белизе',
      'sr-Latn': 'Belize',
      zh_TW: '伯利茲',
      tr: 'Belize',
      ro: 'Belize',
      ar: 'بليز',
      fa: 'بليز',
      yue: '伯利茲',
    },
  },
  {
    num_code: '204',
    alpha_2_code: 'BJ',
    alpha_3_code: 'BEN',
    en_short_name: 'Benin',
    nationality: 'Beninese, Beninois',
    dial_code: '+229',
    nameTranslations: {
      sk: 'Benin',
      se: 'Benin',
      pl: 'Benin',
      no: 'Benin',
      ja: 'ベナン',
      it: 'Benin',
      zh: '贝宁',
      nl: 'Benin',
      de: 'Benin',
      fr: 'Bénin',
      es: 'Benín',
      en: 'Benin',
      pt_BR: 'Benin',
      'sr-Cyrl': 'Бенин',
      'sr-Latn': 'Benin',
      zh_TW: '貝南',
      tr: 'Benin',
      ro: 'Benin',
      ar: 'بنين',
      fa: 'بنين',
      yue: '貝寧',
    },
  },
  {
    num_code: '60',
    alpha_2_code: 'BM',
    alpha_3_code: 'BMU',
    en_short_name: 'Bermuda',
    nationality: 'Bermudian, Bermudan',
    dial_code: '+1441',
    nameTranslations: {
      sk: 'Bermudy',
      se: 'Bermuda',
      pl: 'Bermudy',
      no: 'Bermuda',
      ja: 'バミューダ',
      it: 'Bermuda',
      zh: '百慕大',
      nl: 'Bermuda',
      de: 'Bermuda',
      fr: 'Bermudes',
      es: 'Bermudas',
      en: 'Bermuda',
      pt_BR: 'Bermudas',
      'sr-Cyrl': 'Бермуда',
      'sr-Latn': 'Bermuda',
      zh_TW: '百慕達',
      tr: 'Bermuda',
      ro: 'Insulele Bermude',
      ar: 'برمودا',
      fa: 'برمودا',
      yue: '百慕大',
    },
  },
  {
    num_code: '64',
    alpha_2_code: 'BT',
    alpha_3_code: 'BTN',
    en_short_name: 'Bhutan',
    nationality: 'Bhutanese',
    dial_code: '+975',
    nameTranslations: {
      sk: 'Bhután',
      se: 'Bhutan',
      pl: 'Bhutan',
      no: 'Bhutan',
      ja: 'ブータン',
      it: 'Bhutan',
      zh: '不丹',
      nl: 'Bhutan',
      de: 'Bhutan',
      fr: 'Bhoutan',
      es: 'Bután',
      en: 'Bhutan',
      pt_BR: 'Butão',
      'sr-Cyrl': 'Бутан',
      'sr-Latn': 'Butan',
      zh_TW: '不丹',
      tr: 'Bhutan',
      ro: 'Bhutan',
      ar: 'بوتان',
      fa: 'بوتان',
      yue: '不丹',
    },
  },
  {
    num_code: '68',
    alpha_2_code: 'BO',
    alpha_3_code: 'BOL',
    en_short_name: 'Bolivia',
    nationality: 'Bolivian',
    dial_code: '+591',
    nameTranslations: {
      sk: 'Bolívia',
      se: 'Bolivia',
      pl: 'Boliwia',
      no: 'Bolivia',
      ja: 'ボリビア',
      it: 'Bolivia',
      zh: '玻利维亚',
      nl: 'Bolivia',
      de: 'Bolivien',
      fr: 'Bolivie',
      es: 'Bolivia',
      en: 'Bolivia',
      pt_BR: 'Bolívia',
      'sr-Cyrl': 'Боливија',
      'sr-Latn': 'Bolivija',
      zh_TW: '玻利維亞',
      tr: 'Bolivya',
      ro: 'Bolivia',
      ar: 'بوليفيا',
      fa: 'بولیوی',
      yue: '玻利維亞（多民族國家）',
    },
  },
  {
    num_code: '70',
    alpha_2_code: 'BA',
    alpha_3_code: 'BIH',
    en_short_name: 'Bosnia & Herzegovina',
    nationality: 'Bosnian or Herzegovinian',
    dial_code: '+387',
    nameTranslations: {
      sk: 'Bosna a Hercegovina',
      se: 'Bosnia-Hercegovina',
      pl: 'Bośnia i Hercegowina',
      no: 'Bosnia-Hercegovina',
      ja: 'ボスニア・ヘルツェゴビナ',
      it: 'Bosnia ed Erzegovina',
      zh: '波斯尼亚和黑塞哥维那',
      nl: 'Bosnië en Herzegovina',
      de: 'Bosnien und Herzegowina',
      fr: 'Bosnie-Herzégovine',
      es: 'Bosnia y Herzegovina',
      en: 'Bosnia & Herzegovina',
      pt_BR: 'Bósnia e Herzegovina',
      'sr-Cyrl': 'Босна и Херцеговина',
      'sr-Latn': 'Bosna i Hercegovina',
      zh_TW: '波士尼亞和黑塞哥維那',
      tr: 'Bosna Hersek',
      ro: 'Bosnia și Herțegovina',
      ar: 'البوسنة والهرسك',
      fa: 'بوسنی و هرزگوین',
      yue: '波斯尼亞黑塞哥維那',
    },
  },
  {
    num_code: '72',
    alpha_2_code: 'BW',
    alpha_3_code: 'BWA',
    en_short_name: 'Botswana',
    nationality: 'Motswana, Botswanan',
    dial_code: '+267',
    nameTranslations: {
      sk: 'Botswana',
      se: 'Botswana',
      pl: 'Botswana',
      no: 'Botswana',
      ja: 'ボツワナ',
      it: 'Botswana',
      zh: '博茨瓦纳',
      nl: 'Botswana',
      de: 'Botsuana',
      fr: 'Botswana',
      es: 'Botsuana',
      en: 'Botswana',
      pt_BR: 'Botswana',
      'sr-Cyrl': 'Боцвана',
      'sr-Latn': 'Bocvana',
      zh_TW: '博茨瓦納',
      tr: 'Botsvana',
      ro: 'Botswana',
      ar: 'بوتسوانا',
      fa: 'بوتسوانا',
      yue: '博茨瓦納',
    },
  },
  {
    num_code: '74',
    alpha_2_code: 'BV',
    alpha_3_code: 'BVT',
    en_short_name: 'Bouvet Island',
    nationality: 'Bouvet Island',
    dial_code: '+47',
    nameTranslations: {
      sk: 'Bouvetov ostrov',
      se: 'Bouvet-sullot',
      pl: 'Wyspa Bouveta',
      no: 'Bouvetøya',
      ja: 'ブーベ島',
      it: 'Isola Bouvet',
      zh: '布韦岛',
      nl: 'Bouveteiland',
      de: 'Bouvetinsel',
      fr: 'Île Bouvet',
      es: 'Isla Bouvet',
      en: 'Bouvet Island',
      pt_BR: 'Ilha Bouvet',
      'sr-Cyrl': 'Острво Буве',
      'sr-Latn': 'Ostrvo Buve',
      zh_TW: '布維特島',
      tr: 'Bouvet Adası',
      ro: 'Insula Bouvet',
      ar: 'جزيرة بوفيه',
      fa: 'جزیره بووه',
      yue: '布维特岛',
    },
  },
  {
    num_code: '76',
    alpha_2_code: 'BR',
    alpha_3_code: 'BRA',
    en_short_name: 'Brazil',
    nationality: 'Brazilian',
    dial_code: '+55',
    nameTranslations: {
      sk: 'Brazília',
      se: 'Brasil',
      pl: 'Brazylia',
      no: 'Brasil',
      ja: 'ブラジル',
      it: 'Brasile',
      zh: '巴西',
      nl: 'Brazilië',
      de: 'Brasilien',
      fr: 'Brésil',
      es: 'Brasil',
      en: 'Brazil',
      pt_BR: 'Brasil',
      'sr-Cyrl': 'Бразил',
      'sr-Latn': 'Brazil',
      zh_TW: '巴西',
      tr: 'Brezilya',
      ro: 'Brazilia',
      ar: 'البرازيل',
      fa: 'برزیل',
      yue: '巴西',
    },
  },
  {
    num_code: '86',
    alpha_2_code: 'IO',
    alpha_3_code: 'IOT',
    en_short_name: 'British Indian Ocean Territory',
    nationality: 'BIOT',
    dial_code: '+246',
    nameTranslations: {
      sk: 'Britské indickooceánske územie',
      se: 'British Indian Ocean Territory',
      pl: 'Brytyjskie Terytorium Oceanu Indyjskiego',
      no: 'Det britiske territoriet i Indiahavet',
      ja: '英領インド洋地域',
      it: "Territorio britannico dell'Oceano Indiano",
      zh: '英属印度洋领地',
      nl: 'Brits Indische Oceaanterritorium',
      de: 'Britisches Territorium im Indischen Ozean',
      fr: "Territoire britannique de l'océan Indien",
      es: 'Territorio Británico del Océano Índico',
      en: 'British Indian Ocean Territory',
      pt_BR: 'Território Britânico do Oceano Índico',
      'sr-Cyrl': 'Британска територија Индијског океана',
      'sr-Latn': 'Britanska teritorija Indijskog okeana',
      zh_TW: '英屬印度洋領地',
      tr: 'Britanya Hint Okyanusu Toprakları',
      ro: 'Teritoriul Britanic din Oceanul Indian',
      ar: 'إقليم المحيط الهندي البريطاني',
      fa: 'سرزمین دریایی هند - بریتانیا',
      yue: '英屬印度洋領土',
    },
  },
  {
    num_code: '96',
    alpha_2_code: 'BN',
    alpha_3_code: 'BRN',
    en_short_name: 'Brunei',
    nationality: 'Bruneian',
    dial_code: '+673',
    nameTranslations: {
      sk: 'Brunej',
      se: 'Brunei',
      pl: 'Brunei',
      no: 'Brunei',
      ja: 'ブルネイ',
      it: 'Brunei',
      zh: '文莱',
      nl: 'Brunei',
      de: 'Brunei Darussalam',
      fr: 'Brunéi Darussalam',
      es: 'Brunéi',
      en: 'Brunei',
      pt_BR: 'Brunei',
      'sr-Cyrl': 'Брунеј',
      'sr-Latn': 'Brunej',
      zh_TW: '汶萊',
      tr: 'Bruney',
      ro: 'Brunei',
      ar: 'بروناي',
      fa: 'برونئی',
      yue: '文萊達魯薩蘭國',
    },
  },
  {
    num_code: '100',
    alpha_2_code: 'BG',
    alpha_3_code: 'BGR',
    en_short_name: 'Bulgaria',
    nationality: 'Bulgarian',
    dial_code: '+359',
    nameTranslations: {
      sk: 'Bulharsko',
      se: 'Bulgária',
      pl: 'Bułgaria',
      no: 'Bulgaria',
      ja: 'ブルガリア',
      it: 'Bulgaria',
      zh: '保加利亚',
      nl: 'Bulgarije',
      de: 'Bulgarien',
      fr: 'Bulgarie',
      es: 'Bulgaria',
      en: 'Bulgaria',
      pt_BR: 'Bulgária',
      'sr-Cyrl': 'Бугарска',
      'sr-Latn': 'Bugarska',
      zh_TW: '保加利亞',
      tr: 'Bulgaristan',
      ro: 'Bulgaria',
      ar: 'بلغاريا',
      fa: 'بلغارستان',
      yue: '保加利亞',
    },
  },
  {
    num_code: '854',
    alpha_2_code: 'BF',
    alpha_3_code: 'BFA',
    en_short_name: 'Burkina Faso',
    nationality: 'Burkinabé',
    dial_code: '+226',
    nameTranslations: {
      sk: 'Burkina Faso',
      se: 'Burkina Faso',
      pl: 'Burkina Faso',
      no: 'Burkina Faso',
      ja: 'ブルキナファソ',
      it: 'Burkina Faso',
      zh: '布基纳法索',
      nl: 'Burkina Faso',
      de: 'Burkina Faso',
      fr: 'Burkina Faso',
      es: 'Burkina Faso',
      en: 'Burkina Faso',
      pt_BR: 'Burkina Faso',
      'sr-Cyrl': 'Буркина Фасо',
      'sr-Latn': 'Burkina Faso',
      zh_TW: '布吉納法索',
      tr: 'Burkina Faso',
      ro: 'Burkina Faso',
      ar: 'بوركينا فاسو',
      fa: 'بورکینافاسو',
      yue: '布基納法索',
    },
  },
  {
    num_code: '108',
    alpha_2_code: 'BI',
    alpha_3_code: 'BDI',
    en_short_name: 'Burundi',
    nationality: 'Burundian',
    dial_code: '+257',
    nameTranslations: {
      sk: 'Burundi',
      se: 'Burundi',
      pl: 'Burundi',
      no: 'Burundi',
      ja: 'ブルンジ',
      it: 'Burundi',
      zh: '布隆迪',
      nl: 'Burundi',
      de: 'Burundi',
      fr: 'Burundi',
      es: 'Burundi',
      en: 'Burundi',
      pt_BR: 'Burundi',
      'sr-Cyrl': 'Бурунди',
      'sr-Latn': 'Burundi',
      zh_TW: '蒲隆地',
      tr: 'Burundi',
      ro: 'Burundi',
      ar: 'بوروندي',
      fa: 'بوروندی',
      yue: '蒲隆地',
    },
  },
  {
    num_code: '132',
    alpha_2_code: 'CV',
    alpha_3_code: 'CPV',
    en_short_name: 'Cape Verde',
    nationality: 'Cabo Verdean',
    dial_code: '+238',
    nameTranslations: {
      sk: 'Kapverdy',
      se: 'Kap Verde',
      pl: 'Republika Zielonego Przylądka',
      no: 'Kapp Verde',
      ja: 'カーボベルデ',
      it: 'Capo Verde',
      zh: '佛得角',
      nl: 'Kaapverdië',
      de: 'Cabo Verde',
      fr: 'Cap-Vert',
      es: 'Cabo Verde',
      en: 'Cape Verde',
      pt_BR: 'cabo Verde',
      'sr-Cyrl': 'Зеленортска Острва',
      'sr-Latn': 'Zalanortska Ostrva',
      zh_TW: '佛得角',
      tr: 'Kabo Verde',
      ro: 'Capul Verde',
      ar: 'الرأس الأخضر',
      fa: 'دماغه سبز',
      yue: '卡波维德',
    },
  },
  {
    num_code: '116',
    alpha_2_code: 'KH',
    alpha_3_code: 'KHM',
    en_short_name: 'Cambodia',
    nationality: 'Cambodian',
    dial_code: '+855',
    nameTranslations: {
      sk: 'Kambodža',
      se: 'Kambodža',
      pl: 'Kambodża',
      no: 'Kambodsja',
      ja: 'カンボジア',
      it: 'Cambogia',
      zh: '柬埔寨',
      nl: 'Cambodja',
      de: 'Kambodscha',
      fr: 'Cambodge',
      es: 'Camboya',
      en: 'Cambodia',
      pt_BR: 'Camboja',
      'sr-Cyrl': 'Камбоџа',
      'sr-Latn': 'Kambodža',
      zh_TW: '柬埔寨',
      tr: 'Kamboçya',
      ro: 'Cambogia',
      ar: 'كمبوديا',
      fa: 'کامبوج',
      yue: '柬埔寨',
    },
  },
  {
    num_code: '120',
    alpha_2_code: 'CM',
    alpha_3_code: 'CMR',
    en_short_name: 'Cameroon',
    nationality: 'Cameroonian',
    dial_code: '+237',
    nameTranslations: {
      sk: 'Kamerun',
      se: 'Kamerun',
      pl: 'Kamerun',
      no: 'Kamerun',
      ja: 'カメルーン',
      it: 'Camerun',
      zh: '喀麦隆',
      nl: 'Kameroen',
      de: 'Kamerun',
      fr: 'Cameroun',
      es: 'Camerún',
      en: 'Cameroon',
      pt_BR: 'Camarões',
      'sr-Cyrl': 'Камерун',
      'sr-Latn': 'Kamerun',
      zh_TW: '喀麥隆',
      tr: 'Kamerun',
      ro: 'Camerun',
      ar: 'الكاميرون',
      fa: 'کامرون',
      yue: '喀 麥 隆',
    },
  },
  {
    num_code: '124',
    alpha_2_code: 'CA',
    alpha_3_code: 'CAN',
    en_short_name: 'Canada',
    nationality: 'Canadian',
    dial_code: '+1',
    nameTranslations: {
      sk: 'Kanada',
      se: 'Kanáda',
      pl: 'Kanada',
      no: 'Canada',
      ja: 'カナダ',
      it: 'Canada',
      zh: '加拿大',
      nl: 'Canada',
      de: 'Kanada',
      fr: 'Canada',
      es: 'Canadá',
      en: 'Canada',
      pt_BR: 'Canadá',
      'sr-Cyrl': 'Канада',
      'sr-Latn': 'Kanada',
      zh_TW: '加拿大',
      tr: 'Kanada',
      ro: 'Canada',
      ar: 'كندا',
      fa: 'کانادا',
      yue: '加拿大',
    },
  },
  {
    num_code: '136',
    alpha_2_code: 'KY',
    alpha_3_code: 'CYM',
    en_short_name: 'Cayman Islands',
    nationality: 'Caymanian',
    dial_code: '+1345',
    nameTranslations: {
      sk: 'Kajmanie ostrovy',
      se: 'Cayman-sullot',
      pl: 'Kajmany',
      no: 'Caymanøyene',
      ja: 'ケイマン諸島',
      it: 'Isole Cayman',
      zh: '开曼群岛',
      nl: 'Kaaimaneilanden',
      de: 'Kaimaninseln',
      fr: 'Îles Caïmans',
      es: 'Islas Caimán',
      en: 'Cayman Islands',
      pt_BR: 'Ilhas Cayman',
      'sr-Cyrl': 'Кајманска Острва',
      'sr-Latn': 'Kajmanska Ostrva',
      zh_TW: '開曼群島',
      tr: 'Cayman Adaları',
      ro: 'Insulele Cayman',
      ar: 'جزر كايمان',
      fa: 'جزایر کیمن',
      yue: '開曼群島',
    },
  },
  {
    num_code: '140',
    alpha_2_code: 'CF',
    alpha_3_code: 'CAF',
    en_short_name: 'Central African Republic',
    nationality: 'Central African',
    dial_code: '+236',
    nameTranslations: {
      sk: 'Stredoafrická republika',
      se: 'Gaska-Afrihká dásseváldi',
      pl: 'Republika Środkowoafrykańska',
      no: 'Den sentralafrikanske republikk',
      ja: '中央アフリカ共和国',
      it: 'Repubblica Centrafricana',
      zh: '中非共和国',
      nl: 'Centraal-Afrikaanse Republiek',
      de: 'Zentralafrikanische Republik',
      fr: 'République centrafricaine',
      es: 'República Centroafricana',
      en: 'Central African Republic',
      pt_BR: 'República Centro-Africana',
      'sr-Cyrl': 'Централноафричка Република',
      'sr-Latn': 'Centralnoafrička Republika',
      zh_TW: '中非共和國',
      tr: 'Orta Afrika Cumhuriyeti',
      ro: 'Republica Centrafricană',
      ar: 'جمهورية أفريقيا الوسطى',
      fa: 'جمهوری افریقای مرکزی',
      yue: '中非共和國',
    },
  },
  {
    num_code: '148',
    alpha_2_code: 'TD',
    alpha_3_code: 'TCD',
    en_short_name: 'Chad',
    nationality: 'Chadian',
    dial_code: '+235',
    nameTranslations: {
      sk: 'Čad',
      se: 'Tčad',
      pl: 'Czad',
      no: 'Tsjad',
      ja: 'チャド',
      it: 'Ciad',
      zh: '乍得',
      nl: 'Tsjaad',
      de: 'Tschad',
      fr: 'Tchad',
      es: 'Chad',
      en: 'Chad',
      pt_BR: 'Chade',
      'sr-Cyrl': 'Чад',
      'sr-Latn': 'Čad',
      zh_TW: '查德',
      tr: 'Çad',
      ro: 'Ciad',
      ar: 'تشاد',
      fa: 'چاد',
      yue: '乍得',
    },
  },
  {
    num_code: '152',
    alpha_2_code: 'CL',
    alpha_3_code: 'CHL',
    en_short_name: 'Chile',
    nationality: 'Chilean',
    dial_code: '+56',
    nameTranslations: {
      sk: 'Čile',
      se: 'Čiile',
      pl: 'Chile',
      no: 'Chile',
      ja: 'チリ',
      it: 'Cile',
      zh: '智利',
      nl: 'Chili',
      de: 'Chile',
      fr: 'Chili',
      es: 'Chile',
      en: 'Chile',
      pt_BR: 'Chile',
      'sr-Cyrl': 'Чиле',
      'sr-Latn': 'Čile',
      zh_TW: '智利',
      tr: 'Şili',
      ro: 'Chile',
      ar: 'تشيلي',
      fa: 'شیلی',
      yue: '智利',
    },
  },
  {
    num_code: '156',
    alpha_2_code: 'CN',
    alpha_3_code: 'CHN',
    en_short_name: 'China',
    nationality: 'Chinese',
    dial_code: '+86',
    nameTranslations: {
      sk: 'Čína',
      se: 'Kiinná',
      pl: 'Chiny',
      no: 'Kina',
      ja: '中国',
      it: 'Cina',
      zh: '中国',
      nl: 'China',
      de: 'China',
      fr: 'Chine',
      es: 'China',
      en: 'China',
      pt_BR: 'China',
      'sr-Cyrl': 'Кина',
      'sr-Latn': 'Kina',
      zh_TW: '中國',
      tr: 'Çin',
      ro: 'China',
      ar: 'الصين',
      fa: 'چین',
      yue: '中國',
    },
  },
  {
    num_code: '162',
    alpha_2_code: 'CX',
    alpha_3_code: 'CXR',
    en_short_name: 'Christmas Island',
    nationality: 'Christmas Island',
    dial_code: '+61',
    nameTranslations: {
      sk: 'Vianočný ostrov',
      se: 'Juovllat-sullot',
      pl: 'Wyspa Bożego Narodzenia',
      no: 'Christmasøya',
      ja: 'クリスマス島',
      it: 'Isola Christmas',
      zh: '圣诞岛',
      nl: 'Christmaseiland',
      de: 'Weihnachtsinsel',
      fr: 'Île Christmas',
      es: 'Isla de Navidad',
      en: 'Christmas Island',
      pt_BR: 'Ilha do Natal',
      'sr-Cyrl': 'Ускршња Острва',
      'sr-Latn': 'Uskršnja Ostrva',
      zh_TW: '聖誕島',
      tr: 'Christmas Adası',
      ro: 'Insula Crăciunului',
      ar: 'جزيرة عيد الميلاد',
      fa: 'جزیره کریسمس',
      yue: '聖誕島',
    },
  },
  {
    num_code: '166',
    alpha_2_code: 'CC',
    alpha_3_code: 'CCK',
    en_short_name: 'Cocos (Keeling) Islands',
    nationality: 'Cocos Island',
    dial_code: '+61',
    nameTranslations: {
      sk: 'Kokosové ostrovy',
      se: 'Cocos-sullot',
      pl: 'Wyspy Kokosowe',
      no: 'Kokosøyene',
      ja: 'ココス(キーリング)諸島',
      it: 'Isole Cocos (Keeling)',
      zh: '科科斯（基林）群岛',
      nl: 'Cocoseilanden',
      de: 'Kokosinseln',
      fr: 'Îles Cocos',
      es: 'Islas Cocos',
      en: 'Cocos (Keeling) Islands',
      pt_BR: 'Ilhas Cocos (Keeling)',
      'sr-Cyrl': 'Кокосова Острва',
      'sr-Latn': 'Kokosova Ostrva',
      zh_TW: '科科斯（基林）群島',
      tr: 'Cocos (Keyling) Adaları',
      ro: 'Insulele Cocos',
      ar: 'جزر كوكوس',
      fa: 'جزایر کوکوس',
      yue: '可可島（基林）群島',
    },
  },
  {
    num_code: '170',
    alpha_2_code: 'CO',
    alpha_3_code: 'COL',
    en_short_name: 'Colombia',
    nationality: 'Colombian',
    dial_code: '+57',
    nameTranslations: {
      sk: 'Kolumbia',
      se: 'Kolombia',
      pl: 'Kolumbia',
      no: 'Colombia',
      ja: 'コロンビア',
      it: 'Colombia',
      zh: '哥伦比亚',
      nl: 'Colombia',
      de: 'Kolumbien',
      fr: 'Colombie',
      es: 'Colombia',
      en: 'Colombia',
      pt_BR: 'Colômbia',
      'sr-Cyrl': 'Колумбија',
      'sr-Latn': 'Kolumbija',
      zh_TW: '哥倫比亞',
      tr: 'Kolombiya',
      ro: 'Columbia',
      ar: 'كولومبيا',
      fa: 'کلمبیا',
      yue: '哥倫比亞',
    },
  },
  {
    num_code: '174',
    alpha_2_code: 'KM',
    alpha_3_code: 'COM',
    en_short_name: 'Comoros',
    nationality: 'Comoran, Comorian',
    dial_code: '+269',
    nameTranslations: {
      sk: 'Komory',
      se: 'Komoros',
      pl: 'Komory',
      no: 'Komorene',
      ja: 'コモロ',
      it: 'Comore',
      zh: '科摩罗',
      nl: 'Comoren',
      de: 'Komoren',
      fr: 'Comores',
      es: 'Comoras',
      en: 'Comoros',
      pt_BR: 'Comores',
      'sr-Cyrl': 'Комори',
      'sr-Latn': 'Komori',
      zh_TW: '科摩羅',
      tr: 'Komor Adaları',
      ro: 'Comore',
      ar: 'جزر القمر',
      fa: 'جزیره کومور',
      yue: '科摩羅',
    },
  },
  {
    num_code: '178',
    alpha_2_code: 'CG',
    alpha_3_code: 'COG',
    en_short_name: 'Congo - Brazzaville',
    nationality: 'Congolese',
    dial_code: '+242',
    nameTranslations: {
      sk: 'Konžská republika',
      se: 'Kongo-Brazzaville',
      pl: 'Kongo',
      no: 'Kongo-Brazzaville',
      ja: 'コンゴ共和国(ブラザビル)',
      it: 'Congo-Brazzaville',
      zh: '刚果（布）',
      nl: 'Congo-Brazzaville',
      de: 'Kongo-Brazzaville',
      fr: 'Congo-Brazzaville',
      es: 'Congo',
      en: 'Congo - Brazzaville',
      pt_BR: 'República do Congo',
      'sr-Cyrl': 'Република Конго',
      'sr-Latn': 'Republika Kongo',
      zh_TW: '剛果共和國（布拉柴維爾）',
      tr: 'Kongo Cumhuriyeti',
      ro: 'Republica Congo',
      ar: 'جمهورية الكونغو',
      fa: 'جمهوری کنگو',
      yue: '剛果（共和國）',
    },
  },
  {
    num_code: '180',
    alpha_2_code: 'CD',
    alpha_3_code: 'COD',
    en_short_name: 'Congo - Kinshasa',
    nationality: 'Congolese',
    dial_code: '+243',
    nameTranslations: {
      sk: 'Konžská demokratická republika',
      se: 'Kongo-Kinshasa',
      pl: 'Demokratyczna Republika Konga',
      no: 'Kongo-Kinshasa',
      ja: 'コンゴ民主共和国(キンシャサ)',
      it: 'Congo - Kinshasa',
      zh: '刚果（金）',
      nl: 'Congo-Kinshasa',
      de: 'Kongo-Kinshasa',
      fr: 'Congo-Kinshasa',
      es: 'República Democrática del Congo',
      en: 'Congo - Kinshasa',
      pt_BR: 'República Democrática do Congo',
      'sr-Cyrl': 'Демократска Република Конго',
      'sr-Latn': 'Demokratska Republika Kongo',
      zh_TW: '剛果民主共和國（金沙薩）',
      tr: 'Kongo Demokratik Cumhuriyeti',
      ro: 'Republica Democrată Congo',
      ar: 'جمهورية الكونغو الديمقراطية',
      fa: 'جمهوری دموکراتیک کنگو',
      yue: '剛果（金）',
    },
  },
  {
    num_code: '184',
    alpha_2_code: 'CK',
    alpha_3_code: 'COK',
    en_short_name: 'Cook Islands',
    nationality: 'Cook Island',
    dial_code: '+682',
    nameTranslations: {
      sk: 'Cookove ostrovy',
      se: 'Cook-sullot',
      pl: 'Wyspy Cooka',
      no: 'Cookøyene',
      ja: 'クック諸島',
      it: 'Isole Cook',
      zh: '库克群岛',
      nl: 'Cookeilanden',
      de: 'Cookinseln',
      fr: 'Îles Cook',
      es: 'Islas Cook',
      en: 'Cook Islands',
      pt_BR: 'Ilhas Cook',
      'sr-Cyrl': 'Кукова Острва',
      'sr-Latn': 'Kukova Ostrva',
      zh_TW: '庫克群島',
      tr: 'Cook Adaları',
      ro: 'Insulele Cook',
      ar: 'جزر كوك',
      fa: 'جزایر کوک',
      yue: '庫克群島',
    },
  },
  {
    num_code: '188',
    alpha_2_code: 'CR',
    alpha_3_code: 'CRI',
    en_short_name: 'Costa Rica',
    nationality: 'Costa Rican',
    dial_code: '+506',
    nameTranslations: {
      sk: 'Kostarika',
      se: 'Costa Rica',
      pl: 'Kostaryka',
      no: 'Costa Rica',
      ja: 'コスタリカ',
      it: 'Costa Rica',
      zh: '哥斯达黎加',
      nl: 'Costa Rica',
      de: 'Costa Rica',
      fr: 'Costa Rica',
      es: 'Costa Rica',
      en: 'Costa Rica',
      pt_BR: 'Costa Rica',
      'sr-Cyrl': 'Коста Рика',
      'sr-Latn': 'Kosta Rika',
      zh_TW: '哥斯大黎加',
      tr: 'Kosta Rika',
      ro: 'Costa Rica',
      ar: 'كوستاريكا',
      fa: 'کاستاریکا',
      yue: '哥斯達黎加',
    },
  },
  {
    num_code: '384',
    alpha_2_code: 'CI',
    alpha_3_code: 'CIV',
    en_short_name: "Côte d'Ivoire",
    nationality: 'Ivorian',
    dial_code: '+225',
    nameTranslations: {
      sk: 'Pobrežie Slonoviny',
      se: 'Elfenbenariddu',
      pl: "Côte d'Ivoire",
      no: 'Elfenbenskysten',
      ja: 'コートジボワール',
      it: "Costa d'Avorio",
      zh: '科特迪瓦',
      nl: 'Ivoorkust',
      de: "Côte d'Ivoire",
      fr: "Côte d'Ivoire",
      es: "Côte d'Ivoire",
      en: "Côte d'Ivoire",
      pt_BR: "Côte d'Ivoire",
      'sr-Cyrl': 'Обала Слоноваче',
      'sr-Latn': 'Obala Slonovače',
      zh_TW: '象牙海岸',
      tr: 'Fildişi Kıyısı',
      ro: 'Coasta de fildeș',
      ar: 'ساحل العاج',
      fa: 'ساحل عاج',
      yue: '科特迪瓦',
    },
  },
  {
    num_code: '191',
    alpha_2_code: 'HR',
    alpha_3_code: 'HRV',
    en_short_name: 'Croatia',
    nationality: 'Croatian',
    dial_code: '+385',
    nameTranslations: {
      sk: 'Chorvátsko',
      se: 'Kroátia',
      pl: 'Chorwacja',
      no: 'Kroatia',
      ja: 'クロアチア',
      it: 'Croazia',
      zh: '克罗地亚',
      nl: 'Kroatië',
      de: 'Kroatien',
      fr: 'Croatie',
      es: 'Croacia',
      en: 'Croatia',
      pt_BR: 'Croácia',
      'sr-Cyrl': 'Хрватска',
      'sr-Latn': 'Hrvatska',
      zh_TW: '克羅埃西亞',
      tr: 'Hırvatistan',
      ro: 'Croația',
      ar: 'كرواتيا',
      fa: 'کرواسی',
      yue: '克羅地亞',
    },
  },
  {
    num_code: '192',
    alpha_2_code: 'CU',
    alpha_3_code: 'CUB',
    en_short_name: 'Cuba',
    nationality: 'Cuban',
    dial_code: '+53',
    nameTranslations: {
      sk: 'Kuba',
      se: 'Kuba',
      pl: 'Kuba',
      no: 'Cuba',
      ja: 'キューバ',
      it: 'Cuba',
      zh: '古巴',
      nl: 'Cuba',
      de: 'Kuba',
      fr: 'Cuba',
      es: 'Cuba',
      en: 'Cuba',
      pt_BR: 'Cuba',
      'sr-Cyrl': 'Куба',
      'sr-Latn': 'Kuba',
      zh_TW: '古巴',
      tr: 'Küba',
      ro: 'Cuba',
      ar: 'كوبا',
      fa: 'كوبا',
      yue: '古巴',
    },
  },
  {
    num_code: '196',
    alpha_2_code: 'CY',
    alpha_3_code: 'CYP',
    en_short_name: 'Cyprus',
    nationality: 'Cypriot',
    dial_code: '+357',
    nameTranslations: {
      sk: 'Cyprus',
      se: 'Kypros',
      pl: 'Cypr',
      no: 'Kypros',
      ja: 'キプロス',
      it: 'Cipro',
      zh: '塞浦路斯',
      nl: 'Cyprus',
      de: 'Zypern',
      fr: 'Chypre',
      es: 'Chipre',
      en: 'Cyprus',
      pt_BR: 'Chipre',
      'sr-Cyrl': 'Кипар',
      'sr-Latn': 'Kipar',
      zh_TW: '塞普勒斯',
      tr: 'Kıbrıs',
      ro: 'Cipru',
      ar: 'قبرص',
      fa: 'قبرس',
      yue: '塞浦路斯',
    },
  },
  {
    num_code: '203',
    alpha_2_code: 'CZ',
    alpha_3_code: 'CZE',
    en_short_name: 'Czech Republic',
    nationality: 'Czech',
    dial_code: '+420',
    nameTranslations: {
      sk: 'Česko',
      se: 'Čeahkka',
      pl: 'Czechy',
      no: 'Tsjekkia',
      ja: 'チェコ',
      it: 'Cechia',
      zh: '捷克',
      nl: 'Tsjechië',
      de: 'Tschechien',
      fr: 'Tchéquie',
      es: 'Chequia',
      en: 'Czech Republic',
      pt_BR: 'Czechia',
      'sr-Cyrl': 'Чешка',
      'sr-Latn': 'Češka',
      zh_TW: '捷克',
      tr: 'Çek Cumhuriyeti',
      ro: 'Cehia',
      ar: 'جمهورية التشيك',
      fa: 'جمهوری چک',
      yue: '捷克共和國',
    },
  },
  {
    num_code: '208',
    alpha_2_code: 'DK',
    alpha_3_code: 'DNK',
    en_short_name: 'Denmark',
    nationality: 'Danish',
    dial_code: '+45',
    nameTranslations: {
      sk: 'Dánsko',
      se: 'Dánmárku',
      pl: 'Dania',
      no: 'Danmark',
      ja: 'デンマーク',
      it: 'Danimarca',
      zh: '丹麦',
      nl: 'Denemarken',
      de: 'Dänemark',
      fr: 'Danemark',
      es: 'Dinamarca',
      en: 'Denmark',
      pt_BR: 'Dinamarca',
      'sr-Cyrl': 'Данска',
      'sr-Latn': 'Danska',
      zh_TW: '丹麥',
      tr: 'Danimarka',
      ro: 'Danemarca',
      ar: 'الدنمارك',
      fa: 'دانمارک',
      yue: '丹麥',
    },
  },
  {
    num_code: '262',
    alpha_2_code: 'DJ',
    alpha_3_code: 'DJI',
    en_short_name: 'Djibouti',
    nationality: 'Djiboutian',
    dial_code: '+253',
    nameTranslations: {
      sk: 'Džibutsko',
      se: 'Djibouti',
      pl: 'Dżibuti',
      no: 'Djibouti',
      ja: 'ジブチ',
      it: 'Gibuti',
      zh: '吉布提',
      nl: 'Djibouti',
      de: 'Dschibuti',
      fr: 'Djibouti',
      es: 'Yibuti',
      en: 'Djibouti',
      pt_BR: 'Djibouti',
      'sr-Cyrl': 'Џибути',
      'sr-Latn': 'Džibuti',
      zh_TW: '吉布地',
      tr: 'Cibuti',
      ro: 'Djibouti',
      ar: 'جيبوتي',
      fa: 'جیبوتی',
      yue: '吉布提',
    },
  },
  {
    num_code: '212',
    alpha_2_code: 'DM',
    alpha_3_code: 'DMA',
    en_short_name: 'Dominica',
    nationality: 'Dominican',
    dial_code: '+1767',
    nameTranslations: {
      sk: 'Dominika',
      se: 'Dominica',
      pl: 'Dominika',
      no: 'Dominica',
      ja: 'ドミニカ国',
      it: 'Dominica',
      zh: '多米尼克',
      nl: 'Dominica',
      de: 'Dominica',
      fr: 'Dominique',
      es: 'Dominica',
      en: 'Dominica',
      pt_BR: 'Dominica',
      'sr-Cyrl': 'Доминика',
      'sr-Latn': 'Dominika',
      zh_TW: '多明尼加',
      tr: 'Dominika',
      ro: 'Dominica',
      ar: 'دومينيكا',
      fa: 'دومينيكا',
      yue: '多米尼加',
    },
  },
  {
    num_code: '214',
    alpha_2_code: 'DO',
    alpha_3_code: 'DOM',
    en_short_name: 'Dominican Republic',
    nationality: 'Dominican',
    dial_code: '+1',
    nameTranslations: {
      sk: 'Dominikánska republika',
      se: 'Dominikána dásseváldi',
      pl: 'Dominikana',
      no: 'Den dominikanske republikk',
      ja: 'ドミニカ共和国',
      it: 'Repubblica Dominicana',
      zh: '多米尼加共和国',
      nl: 'Dominicaanse Republiek',
      de: 'Dominikanische Republik',
      fr: 'République dominicaine',
      es: 'República Dominicana',
      en: 'Dominican Republic',
      pt_BR: 'República Dominicana',
      'sr-Cyrl': 'Доминиканска Република',
      'sr-Latn': 'Dominikanska Republika',
      zh_TW: '多明尼加共和國',
      tr: 'Dominik Cumhuriyeti',
      ro: 'Republica Dominicană',
      ar: 'جمهورية الدومينيكان',
      fa: 'جمهوری دومنیکن',
      yue: '多明尼加共和國',
    },
  },
  {
    num_code: '218',
    alpha_2_code: 'EC',
    alpha_3_code: 'ECU',
    en_short_name: 'Ecuador',
    nationality: 'Ecuadorian',
    dial_code: '+593',
    nameTranslations: {
      sk: 'Ekvádor',
      se: 'Ecuador',
      pl: 'Ekwador',
      no: 'Ecuador',
      ja: 'エクアドル',
      it: 'Ecuador',
      zh: '厄瓜多尔',
      nl: 'Ecuador',
      de: 'Ecuador',
      fr: 'Équateur',
      es: 'Ecuador',
      en: 'Ecuador',
      pt_BR: 'Equador',
      'sr-Cyrl': 'Еквадор',
      'sr-Latn': 'Ekvador',
      zh_TW: '厄瓜多',
      tr: 'Ekvador',
      ro: 'Ecuador',
      ar: 'الإكوادور',
      fa: 'اكوادور',
      yue: '厄瓜多爾',
    },
  },
  {
    num_code: '818',
    alpha_2_code: 'EG',
    alpha_3_code: 'EGY',
    en_short_name: 'Egypt',
    nationality: 'Egypt',
    dial_code: '+20',
    nameTranslations: {
      sk: 'Egypt',
      se: 'Egypt',
      pl: 'Egipt',
      no: 'Egypt',
      ja: 'エジプト',
      it: 'Egitto',
      zh: '埃及',
      nl: 'Egypt',
      de: 'Ägypt',
      fr: 'Égypte',
      es: 'Egipt',
      en: 'Egypt',
      pt_BR: 'Egito',
      'sr-Cyrl': 'Египат',
      'sr-Latn': 'Egipat',
      zh_TW: '埃及',
      tr: 'Mısır',
      ro: 'Egipt',
      ar: 'مصر',
      fa: 'مصر',
      yue: '埃及',
    },
  },
  {
    num_code: '222',
    alpha_2_code: 'SV',
    alpha_3_code: 'SLV',
    en_short_name: 'El Salvador',
    nationality: 'Salvadoran',
    dial_code: '+503',
    nameTranslations: {
      sk: 'Salvádor',
      se: 'El Salvador',
      pl: 'Salwador',
      no: 'El Salvador',
      ja: 'エルサルバドル',
      it: 'El Salvador',
      zh: '萨尔瓦多',
      nl: 'El Salvador',
      de: 'El Salvador',
      fr: 'Salvador',
      es: 'El Salvador',
      en: 'El Salvador',
      pt_BR: 'El Salvador',
      'sr-Cyrl': 'Салвадор',
      'sr-Latn': 'Salvador',
      zh_TW: '薩爾瓦多',
      tr: 'El Salvador',
      ro: 'Salvador',
      ar: 'السلفادور',
      fa: 'ال سالوادور',
      yue: '薩爾瓦多',
    },
  },
  {
    num_code: '226',
    alpha_2_code: 'GQ',
    alpha_3_code: 'GNQ',
    en_short_name: 'Equatorial Guinea',
    nationality: 'Equatorial Guinean, Equatoguinean',
    dial_code: '+240',
    nameTranslations: {
      sk: 'Rovníková Guinea',
      se: 'Ekvatoriála Guinea',
      pl: 'Gwinea Równikowa',
      no: 'Ekvatorial-Guinea',
      ja: '赤道ギニア',
      it: 'Guinea Equatoriale',
      zh: '赤道几内亚',
      nl: 'Equatoriaal-Guinea',
      de: 'Äquatorialguinea',
      fr: 'Guinée équatoriale',
      es: 'Guinea Ecuatorial',
      en: 'Equatorial Guinea',
      pt_BR: 'Guiné Equatorial',
      'sr-Cyrl': 'Екваторијална Гвинеја',
      'sr-Latn': 'Ekvatorijalna Gvineja',
      zh_TW: '赤道幾內亞',
      tr: 'Ekvator Ginesi',
      ro: 'Guineea Ecuatorială',
      ar: 'غينيا الاستوائية',
      fa: 'گینه استوایی',
      yue: '赤道幾內亞',
    },
  },
  {
    num_code: '232',
    alpha_2_code: 'ER',
    alpha_3_code: 'ERI',
    en_short_name: 'Eritrea',
    nationality: 'Eritrean',
    dial_code: '+291',
    nameTranslations: {
      sk: 'Eritrea',
      se: 'Eritrea',
      pl: 'Erytrea',
      no: 'Eritrea',
      ja: 'エリトリア',
      it: 'Eritrea',
      zh: '厄立特里亚',
      nl: 'Eritrea',
      de: 'Eritrea',
      fr: 'Érythrée',
      es: 'Eritrea',
      en: 'Eritrea',
      pt_BR: 'Eritreia',
      'sr-Cyrl': 'Еритреја',
      'sr-Latn': 'Eritreja',
      zh_TW: '厄立特裡亞',
      tr: 'Eritre',
      ro: 'Eritreea',
      ar: 'إريتريا',
      fa: 'اریتره',
      yue: '厄立特里亞',
    },
  },
  {
    num_code: '233',
    alpha_2_code: 'EE',
    alpha_3_code: 'EST',
    en_short_name: 'Estonia',
    nationality: 'Estonian',
    dial_code: '+372',
    nameTranslations: {
      sk: 'Estónsko',
      se: 'Estlánda',
      pl: 'Estonia',
      no: 'Estland',
      ja: 'エストニア',
      it: 'Estonia',
      zh: '爱沙尼亚',
      nl: 'Estland',
      de: 'Estland',
      fr: 'Estonie',
      es: 'Estonia',
      en: 'Estonia',
      pt_BR: 'Estônia',
      'sr-Cyrl': 'Естонија',
      'sr-Latn': 'Estonija',
      zh_TW: '愛沙尼亞',
      tr: 'Estonya',
      ro: 'Estonia',
      ar: 'إستونيا',
      fa: 'استونی',
      yue: '愛沙尼亞',
    },
  },
  {
    num_code: '231',
    alpha_2_code: 'ET',
    alpha_3_code: 'ETH',
    en_short_name: 'Ethiopia',
    nationality: 'Ethiopian',
    dial_code: '+251',
    nameTranslations: {
      sk: 'Etiópia',
      se: 'Etiopia',
      pl: 'Etiopia',
      no: 'Etiopia',
      ja: 'エチオピア',
      it: 'Etiopia',
      zh: '埃塞俄比亚',
      nl: 'Ethiopië',
      de: 'Äthiopien',
      fr: 'Éthiopie',
      es: 'Etiopía',
      en: 'Ethiopia',
      pt_BR: 'Etiópia',
      'sr-Cyrl': 'Етиопија',
      'sr-Latn': 'Etiopija',
      zh_TW: '伊索比亞',
      tr: 'Etiyopya',
      ro: 'Etiopia',
      ar: 'إثيوبيا',
      fa: 'اتیوپی',
      yue: '埃塞俄比亞',
    },
  },
  {
    num_code: '238',
    alpha_2_code: 'FK',
    alpha_3_code: 'FLK',
    en_short_name: 'Falkland Islands',
    nationality: 'Falkland Island',
    dial_code: '+500',
    nameTranslations: {
      sk: 'Falklandy',
      se: 'Falklandsullot',
      pl: 'Falklandy',
      no: 'Falklandsøyene',
      ja: 'フォークランド諸島',
      it: 'Isole Falkland',
      zh: '福克兰群岛',
      nl: 'Falklandeilanden',
      de: 'Falklandinseln',
      fr: 'Îles Malouines',
      es: 'Islas Malvinas',
      en: 'Falkland Islands',
      pt_BR: 'Ilhas Falkland',
      'sr-Cyrl': 'Фокландска Острва',
      'sr-Latn': 'Foklandska Ostrva',
      zh_TW: '福克蘭群島',
      tr: 'Falkland Adaları',
      ro: 'Insulele Falklands',
      ar: 'جزر فوكلاند',
      fa: 'جزایر فالکلند',
      yue: '福克蘭群島（馬爾維納斯群島）',
    },
  },
  {
    num_code: '234',
    alpha_2_code: 'FO',
    alpha_3_code: 'FRO',
    en_short_name: 'Faroe Islands',
    nationality: 'Faroese',
    dial_code: '+298',
    nameTranslations: {
      sk: 'Faerské ostrovy',
      se: 'Fearsullot',
      pl: 'Wyspy Owcze',
      no: 'Færøyene',
      ja: 'フェロー諸島',
      it: 'Isole Fær Øer',
      zh: '法罗群岛',
      nl: 'Faeröer',
      de: 'Färöer',
      fr: 'Îles Féroé',
      es: 'Islas Feroe',
      en: 'Faroe Islands',
      pt_BR: 'ilhas Faroe',
      'sr-Cyrl': 'Фарска Острва',
      'sr-Latn': 'Farska Ostrva',
      zh_TW: '法羅群島',
      tr: 'Faroe Adaları',
      ro: 'Insulele Feroe',
      ar: 'جزر فارو',
      fa: 'جزایر فارو',
      yue: '法羅群島',
    },
  },
  {
    num_code: '242',
    alpha_2_code: 'FJ',
    alpha_3_code: 'FJI',
    en_short_name: 'Fiji',
    nationality: 'Fijian',
    dial_code: '+679',
    nameTranslations: {
      sk: 'Fidži',
      se: 'Fijisullot',
      pl: 'Fidżi',
      no: 'Fiji',
      ja: 'フィジー',
      it: 'Figi',
      zh: '斐济',
      nl: 'Fiji',
      de: 'Fidschi',
      fr: 'Fidji',
      es: 'Fiyi',
      en: 'Fiji',
      pt_BR: 'Fiji',
      'sr-Cyrl': 'Фиџи',
      'sr-Latn': 'Fidži',
      zh_TW: '斐濟',
      tr: 'Fiji',
      ro: 'Fiji',
      ar: 'فيجي',
      fa: 'فيجي',
      yue: '斐濟',
    },
  },
  {
    num_code: '246',
    alpha_2_code: 'FI',
    alpha_3_code: 'FIN',
    en_short_name: 'Finland',
    nationality: 'Finnish',
    dial_code: '+358',
    nameTranslations: {
      sk: 'Fínsko',
      se: 'Suopma',
      pl: 'Finlandia',
      no: 'Finland',
      ja: 'フィンランド',
      it: 'Finlandia',
      zh: '芬兰',
      nl: 'Finland',
      de: 'Finnland',
      fr: 'Finlande',
      es: 'Finlandia',
      en: 'Finland',
      pt_BR: 'Finlândia',
      'sr-Cyrl': 'Финска',
      'sr-Latn': 'Finska',
      zh_TW: '芬蘭',
      tr: 'Finlandiya',
      ro: 'Finlanda',
      ar: 'فنلندا',
      fa: 'فنلاند',
      yue: '芬蘭',
    },
  },
  {
    num_code: '250',
    alpha_2_code: 'FR',
    alpha_3_code: 'FRA',
    en_short_name: 'France',
    nationality: 'French',
    dial_code: '+33',
    nameTranslations: {
      sk: 'Francúzsko',
      se: 'Frankriika',
      pl: 'Francja',
      no: 'Frankrike',
      ja: 'フランス',
      it: 'Francia',
      zh: '法国',
      nl: 'Frankrijk',
      de: 'Frankreich',
      fr: 'France',
      es: 'Francia',
      en: 'France',
      pt_BR: 'França',
      'sr-Cyrl': 'Француска',
      'sr-Latn': 'Francuska',
      zh_TW: '法國',
      tr: 'Fransa',
      ro: 'Franța',
      ar: 'فرنسا',
      fa: 'فرانسه',
      yue: '法國',
    },
  },
  {
    num_code: '254',
    alpha_2_code: 'GF',
    alpha_3_code: 'GUF',
    en_short_name: 'French Guiana',
    nationality: 'French Guianese',
    dial_code: '+594',
    nameTranslations: {
      sk: 'Francúzska Guyana',
      se: 'Frankriikka Guayana',
      pl: 'Gujana Francuska',
      no: 'Fransk Guyana',
      ja: '仏領ギアナ',
      it: 'Guyana francese',
      zh: '法属圭亚那',
      nl: 'Frans-Guyana',
      de: 'Französisch-Guayana',
      fr: 'Guyane française',
      es: 'Guayana Francesa',
      en: 'French Guiana',
      pt_BR: 'Guiana Francesa',
      'sr-Cyrl': 'Француска Гвајана',
      'sr-Latn': 'Francuska Gvajana',
      zh_TW: '法屬蓋亞那',
      tr: 'Fransız Guyanası',
      ro: 'Guiana Franceză',
      ar: 'غويانا الفرنسية',
      fa: 'گویان فرانسه',
      yue: '法屬圭亞那',
    },
  },
  {
    num_code: '258',
    alpha_2_code: 'PF',
    alpha_3_code: 'PYF',
    en_short_name: 'French Polynesia',
    nationality: 'French Polynesian',
    dial_code: '+689',
    nameTranslations: {
      sk: 'Francúzska Polynézia',
      se: 'Frankriikka Polynesia',
      pl: 'Polinezja Francuska',
      no: 'Fransk Polynesia',
      ja: '仏領ポリネシア',
      it: 'Polinesia francese',
      zh: '法属波利尼西亚',
      nl: 'Frans-Polynesië',
      de: 'Französisch-Polynesien',
      fr: 'Polynésie française',
      es: 'Polinesia Francesa',
      en: 'French Polynesia',
      pt_BR: 'Polinésia Francesa',
      'sr-Cyrl': 'Француска Полинезија',
      'sr-Latn': 'Francuska Polinezija',
      zh_TW: '法屬玻里尼西亞',
      tr: 'Fransız Polinezyası',
      ro: 'Polinezia Franceză',
      ar: 'بولينزيا الفرنسية',
      fa: 'پلی‌نزی فرانسه',
      yue: '法屬波利尼西亞',
    },
  },
  {
    num_code: '260',
    alpha_2_code: 'TF',
    alpha_3_code: 'ATF',
    en_short_name: 'French Southern Territories',
    nationality: 'French Southern Territories',
    dial_code: '+262',
    nameTranslations: {
      sk: 'Francúzske južné a antarktické územia',
      se: 'French Southern Territories',
      pl: 'Francuskie Terytoria Południowe i Antarktyczne',
      no: 'De franske sørterritorier',
      ja: '仏領極南諸島',
      it: 'Terre australi francesi',
      zh: '法属南部领地',
      nl: 'Franse Gebieden in de zuidelijke Indische Oceaan',
      de: 'Französische Süd- und Antarktisgebiete',
      fr: 'Terres australes françaises',
      es: 'Territorios Australes Franceses',
      en: 'French Southern Territories',
      pt_BR: 'Territórios Franceses do Sul',
      'sr-Cyrl': 'Француске јужне и антарктичке земље',
      'sr-Latn': 'Francuske južne i antarktičke zemlje',
      zh_TW: '法屬南部屬地',
      tr: 'Fransız Güney ve Antarktika Toprakları',
      ro: 'Teritoriile australe și antarctice franceze',
      ar: 'أراض فرنسية جنوبية وأنتارتيكية',
      fa: 'سرزمین‌های جنوبی فرانسه',
      yue: '法國南部領土',
    },
  },
  {
    num_code: '266',
    alpha_2_code: 'GA',
    alpha_3_code: 'GAB',
    en_short_name: 'Gabon',
    nationality: 'Gabonese',
    dial_code: '+241',
    nameTranslations: {
      sk: 'Gabon',
      se: 'Gabon',
      pl: 'Gabon',
      no: 'Gabon',
      ja: 'ガボン',
      it: 'Gabon',
      zh: '加蓬',
      nl: 'Gabon',
      de: 'Gabun',
      fr: 'Gabon',
      es: 'Gabón',
      en: 'Gabon',
      pt_BR: 'Gabão',
      'sr-Cyrl': 'Габон',
      'sr-Latn': 'Gabon',
      zh_TW: '加彭',
      tr: 'Gabon',
      ro: 'Gabon',
      ar: 'الغابون',
      fa: 'گابن',
      yue: '加蓬',
    },
  },
  {
    num_code: '270',
    alpha_2_code: 'GM',
    alpha_3_code: 'GMB',
    en_short_name: 'Gambia',
    nationality: 'Gambian',
    dial_code: '+220',
    nameTranslations: {
      sk: 'Gambia',
      se: 'Gámbia',
      pl: 'Gambia',
      no: 'Gambia',
      ja: 'ガンビア',
      it: 'Gambia',
      zh: '冈比亚',
      nl: 'Gambia',
      de: 'Gambia',
      fr: 'Gambie',
      es: 'Gambia',
      en: 'Gambia',
      pt_BR: 'Gâmbia',
      'sr-Cyrl': 'Гамбија',
      'sr-Latn': 'Gambija',
      zh_TW: '岡比亞',
      tr: 'Gambiya',
      ro: 'Gambia',
      ar: 'غامبيا',
      fa: 'گامبیا',
      yue: '岡比亞',
    },
  },
  {
    num_code: '268',
    alpha_2_code: 'GE',
    alpha_3_code: 'GEO',
    en_short_name: 'Georgia',
    nationality: 'Georgian',
    dial_code: '+995',
    nameTranslations: {
      sk: 'Gruzínsko',
      se: 'Georgia',
      pl: 'Gruzja',
      no: 'Georgia',
      ja: 'ジョージア',
      it: 'Georgia',
      zh: '格鲁吉亚',
      nl: 'Georgië',
      de: 'Georgien',
      fr: 'Géorgie',
      es: 'Georgia',
      en: 'Georgia',
      pt_BR: 'Georgia',
      'sr-Cyrl': 'Грузија',
      'sr-Latn': 'Gruzija',
      zh_TW: '喬治亞',
      tr: 'Gürcistan',
      ro: 'Georgia',
      ar: 'جورجيا',
      fa: 'گرجستان',
      yue: '格魯吉亞',
    },
  },
  {
    num_code: '276',
    alpha_2_code: 'DE',
    alpha_3_code: 'DEU',
    en_short_name: 'Germany',
    nationality: 'German',
    dial_code: '+49',
    nameTranslations: {
      sk: 'Nemecko',
      se: 'Duiska',
      pl: 'Niemcy',
      no: 'Tyskland',
      ja: 'ドイツ',
      it: 'Germania',
      zh: '德国',
      nl: 'Duitsland',
      de: 'Deutschland',
      fr: 'Allemagne',
      es: 'Alemania',
      en: 'Germany',
      pt_BR: 'Alemanha',
      'sr-Cyrl': 'Немачка',
      'sr-Latn': 'Nemačka',
      zh_TW: '德國',
      tr: 'Almanya',
      ro: 'Germania',
      ar: 'ألمانيا',
      fa: 'آلمان',
      yue: '德國',
    },
  },
  {
    num_code: '288',
    alpha_2_code: 'GH',
    alpha_3_code: 'GHA',
    en_short_name: 'Ghana',
    nationality: 'Ghanaian',
    dial_code: '+233',
    nameTranslations: {
      sk: 'Ghana',
      se: 'Ghana',
      pl: 'Ghana',
      no: 'Ghana',
      ja: 'ガーナ',
      it: 'Ghana',
      zh: '加纳',
      nl: 'Ghana',
      de: 'Ghana',
      fr: 'Ghana',
      es: 'Ghana',
      en: 'Ghana',
      pt_BR: 'Gana',
      'sr-Cyrl': 'Гана',
      'sr-Latn': 'Gana',
      zh_TW: '迦納',
      tr: 'Gana',
      ro: 'Ghana',
      ar: 'غانا',
      fa: 'غنا',
      yue: '加納',
    },
  },
  {
    num_code: '292',
    alpha_2_code: 'GI',
    alpha_3_code: 'GIB',
    en_short_name: 'Gibraltar',
    nationality: 'Gibraltar',
    dial_code: '+350',
    nameTranslations: {
      sk: 'Gibraltár',
      se: 'Gibraltar',
      pl: 'Gibraltar',
      no: 'Gibraltar',
      ja: 'ジブラルタル',
      it: 'Gibilterra',
      zh: '直布罗陀',
      nl: 'Gibraltar',
      de: 'Gibraltar',
      fr: 'Gibraltar',
      es: 'Gibraltar',
      en: 'Gibraltar',
      pt_BR: 'Gibraltar',
      'sr-Cyrl': 'Гибралтар',
      'sr-Latn': 'Gibraltar',
      zh_TW: '直布羅陀',
      tr: 'Cebelitarık',
      ro: 'Gibraltar',
      ar: 'جبل طارق',
      fa: 'جبل الطارق',
      yue: '直布羅陀',
    },
  },
  {
    num_code: '300',
    alpha_2_code: 'GR',
    alpha_3_code: 'GRC',
    en_short_name: 'Greece',
    nationality: 'Greek, Hellenic',
    dial_code: '+30',
    nameTranslations: {
      sk: 'Grécko',
      se: 'Greika',
      pl: 'Grecja',
      no: 'Hellas',
      ja: 'ギリシャ',
      it: 'Grecia',
      zh: '希腊',
      nl: 'Griekenland',
      de: 'Griechenland',
      fr: 'Grèce',
      es: 'Grecia',
      en: 'Greece',
      pt_BR: 'Grécia',
      'sr-Cyrl': 'Грчка',
      'sr-Latn': 'Grčka',
      zh_TW: '希臘',
      tr: 'Yunanistan',
      ro: 'Grecia',
      ar: 'اليونان',
      fa: 'یونان',
      yue: '希臘',
    },
  },
  {
    num_code: '304',
    alpha_2_code: 'GL',
    alpha_3_code: 'GRL',
    en_short_name: 'Greenland',
    nationality: 'Greenlandic',
    dial_code: '+299',
    nameTranslations: {
      sk: 'Grónsko',
      se: 'Kalaallit Nunaat',
      pl: 'Grenlandia',
      no: 'Grønland',
      ja: 'グリーンランド',
      it: 'Groenlandia',
      zh: '格陵兰',
      nl: 'Groenland',
      de: 'Grönland',
      fr: 'Groenland',
      es: 'Groenlandia',
      en: 'Greenland',
      pt_BR: 'Groenlândia',
      'sr-Cyrl': 'Гренланд',
      'sr-Latn': 'Grenland',
      zh_TW: '格陵蘭',
      tr: 'Grönland',
      ro: 'Groenlanda',
      ar: 'جرينلاند',
      fa: 'گرینلند',
      yue: '格陵蘭',
    },
  },
  {
    num_code: '308',
    alpha_2_code: 'GD',
    alpha_3_code: 'GRD',
    en_short_name: 'Grenada',
    nationality: 'Grenadian',
    dial_code: '+1473',
    nameTranslations: {
      sk: 'Grenada',
      se: 'Grenada',
      pl: 'Grenada',
      no: 'Grenada',
      ja: 'グレナダ',
      it: 'Grenada',
      zh: '格林纳达',
      nl: 'Grenada',
      de: 'Grenada',
      fr: 'Grenade',
      es: 'Granada',
      en: 'Grenada',
      pt_BR: 'Grenada',
      'sr-Cyrl': 'Гренада',
      'sr-Latn': 'Grenada',
      zh_TW: '格林納達',
      tr: 'Grenada',
      ro: 'Grenada',
      ar: 'غرينادا',
      fa: 'گرنادا',
      yue: '格林納達',
    },
  },
  {
    num_code: '312',
    alpha_2_code: 'GP',
    alpha_3_code: 'GLP',
    en_short_name: 'Guadeloupe',
    nationality: 'Guadeloupe',
    dial_code: '+590',
    nameTranslations: {
      sk: 'Guadeloupe',
      se: 'Guadeloupe',
      pl: 'Gwadelupa',
      no: 'Guadeloupe',
      ja: 'グアドループ',
      it: 'Guadalupa',
      zh: '瓜德罗普',
      nl: 'Guadeloupe',
      de: 'Guadeloupe',
      fr: 'Guadeloupe',
      es: 'Guadalupe',
      en: 'Guadeloupe',
      pt_BR: 'Guadalupe',
      'sr-Cyrl': 'Гваделуп',
      'sr-Latn': 'Gvadelup',
      zh_TW: '瓜地洛普',
      tr: 'Guadeloupe',
      ro: 'Guadelupa',
      ar: 'غوادلوب',
      fa: 'گوادلوپ',
      yue: '瓜德罗普',
    },
  },
  {
    num_code: '316',
    alpha_2_code: 'GU',
    alpha_3_code: 'GUM',
    en_short_name: 'Guam',
    nationality: 'Guamanian, Guambat',
    dial_code: '+1671',
    nameTranslations: {
      sk: 'Guam',
      se: 'Guam',
      pl: 'Guam',
      no: 'Guam',
      ja: 'グアム',
      it: 'Guam',
      zh: '关岛',
      nl: 'Guam',
      de: 'Guam',
      fr: 'Guam',
      es: 'Guam',
      en: 'Guam',
      pt_BR: 'Guam',
      'sr-Cyrl': 'Гвам',
      'sr-Latn': 'Gvam',
      zh_TW: '關島',
      tr: 'Guam',
      ro: 'Guam',
      ar: 'غوام',
      fa: 'گوام',
      yue: '關島',
    },
  },
  {
    num_code: '320',
    alpha_2_code: 'GT',
    alpha_3_code: 'GTM',
    en_short_name: 'Guatemala',
    nationality: 'Guatemalan',
    dial_code: '+502',
    nameTranslations: {
      sk: 'Guatemala',
      se: 'Guatemala',
      pl: 'Gwatemala',
      no: 'Guatemala',
      ja: 'グアテマラ',
      it: 'Guatemala',
      zh: '危地马拉',
      nl: 'Guatemala',
      de: 'Guatemala',
      fr: 'Guatemala',
      es: 'Guatemala',
      en: 'Guatemala',
      pt_BR: 'Guatemala',
      'sr-Cyrl': 'Гватемала',
      'sr-Latn': 'Gvatemala',
      zh_TW: '瓜地馬拉',
      tr: 'Guatemala',
      ro: 'Guatemala',
      ar: 'غواتيمالا',
      fa: 'گواتمالا',
      yue: '危地馬拉',
    },
  },
  {
    num_code: '831',
    alpha_2_code: 'GG',
    alpha_3_code: 'GGY',
    en_short_name: 'Guernsey',
    nationality: 'Channel Island',
    dial_code: '+44',
    nameTranslations: {
      sk: 'Guernsey',
      se: 'Guernsey',
      pl: 'Guernsey',
      no: 'Guernsey',
      ja: 'ガーンジー',
      it: 'Guernsey',
      zh: '根西岛',
      nl: 'Guernsey',
      de: 'Guernsey',
      fr: 'Guernesey',
      es: 'Guernsey',
      en: 'Guernsey',
      pt_BR: 'Guernsey',
      'sr-Cyrl': 'Гернзи',
      'sr-Latn': 'Gernzi',
      zh_TW: '根息島',
      tr: 'Guernsey',
      ro: 'Guernsey',
      ar: 'غيرنزي',
      fa: 'گرنزی',
      yue: '格恩西島',
    },
  },
  {
    num_code: '324',
    alpha_2_code: 'GN',
    alpha_3_code: 'GIN',
    en_short_name: 'Guinea',
    nationality: 'Guinean',
    dial_code: '+224',
    nameTranslations: {
      sk: 'Guinea',
      se: 'Guinea',
      pl: 'Gwinea',
      no: 'Guinea',
      ja: 'ギニア',
      it: 'Guinea',
      zh: '几内亚',
      nl: 'Guinee',
      de: 'Guinea',
      fr: 'Guinée',
      es: 'Guinea',
      en: 'Guinea',
      pt_BR: 'Guiné',
      'sr-Cyrl': 'Гвинеја',
      'sr-Latn': 'Gvineja',
      zh_TW: '幾內亞',
      tr: 'Gine',
      ro: 'Guinea',
      ar: 'غينيا',
      fa: 'گینه',
      yue: '幾內亞',
    },
  },
  {
    num_code: '624',
    alpha_2_code: 'GW',
    alpha_3_code: 'GNB',
    en_short_name: 'Guinea-Bissau',
    nationality: 'Bissau-Guinean',
    dial_code: '+245',
    nameTranslations: {
      sk: 'Guinea-Bissau',
      se: 'Guinea-Bissau',
      pl: 'Gwinea Bissau',
      no: 'Guinea-Bissau',
      ja: 'ギニアビサウ',
      it: 'Guinea-Bissau',
      zh: '几内亚比绍',
      nl: 'Guinee-Bissau',
      de: 'Guinea-Bissau',
      fr: 'Guinée-Bissau',
      es: 'Guinea-Bisáu',
      en: 'Guinea-Bissau',
      pt_BR: 'Guiné-bissau',
      'sr-Cyrl': 'Гвинеја Бисао',
      'sr-Latn': 'Gvineja Bisao',
      zh_TW: '幾內亞比索',
      tr: 'Gine-Bissau',
      ro: 'Guineea-Bissau',
      ar: 'غينيا بيساو',
      fa: 'گینه بیسائو',
      yue: '幾內亞比紹',
    },
  },
  {
    num_code: '328',
    alpha_2_code: 'GY',
    alpha_3_code: 'GUY',
    en_short_name: 'Guyana',
    nationality: 'Guyanese',
    dial_code: '+592',
    nameTranslations: {
      sk: 'Guyana',
      se: 'Guyana',
      pl: 'Gujana',
      no: 'Guyana',
      ja: 'ガイアナ',
      it: 'Guyana',
      zh: '圭亚那',
      nl: 'Guyana',
      de: 'Guyana',
      fr: 'Guyana',
      es: 'Guyana',
      en: 'Guyana',
      pt_BR: 'Guiana',
      'sr-Cyrl': 'Гвајана',
      'sr-Latn': 'Gvajana',
      zh_TW: '蓋亞那',
      tr: 'Guyana',
      ro: 'Guyana',
      ar: 'غيانا',
      fa: 'گویان',
      yue: '圭亞那',
    },
  },
  {
    num_code: '332',
    alpha_2_code: 'HT',
    alpha_3_code: 'HTI',
    en_short_name: 'Haiti',
    nationality: 'Haitian',
    dial_code: '+509',
    nameTranslations: {
      sk: 'Haiti',
      se: 'Haiti',
      pl: 'Haiti',
      no: 'Haiti',
      ja: 'ハイチ',
      it: 'Haiti',
      zh: '海地',
      nl: 'Haïti',
      de: 'Haiti',
      fr: 'Haïti',
      es: 'Haití',
      en: 'Haiti',
      pt_BR: 'Haiti',
      'sr-Cyrl': 'Хаити',
      'sr-Latn': 'Haiti',
      zh_TW: '海地',
      tr: 'Haiti',
      ro: 'Haiti',
      ar: 'هايتي',
      fa: 'هائیتی',
      yue: '海地',
    },
  },
  {
    num_code: '334',
    alpha_2_code: 'HM',
    alpha_3_code: 'HMD',
    en_short_name: 'Heard & McDonald Islands',
    nationality: 'Heard Island or McDonald Islands',
    dial_code: '+0',
    nameTranslations: {
      sk: 'Heardov ostrov a Macdonaldove ostrovy',
      se: 'Heard- ja McDonald-sullot',
      pl: 'Wyspy Heard i McDonalda',
      no: 'Heard- og McDonaldøyene',
      ja: 'ハード島・マクドナルド諸島',
      it: 'Isole Heard e McDonald',
      zh: '赫德岛和麦克唐纳群岛',
      nl: 'Heard en McDonaldeilanden',
      de: 'Heard und McDonaldinseln',
      fr: 'Îles Heard et McDonald',
      es: 'Islas Heard y McDonald',
      en: 'Heard & McDonald Islands',
      pt_BR: 'Ilhas Heard e McDonald',
      'sr-Cyrl': 'Острва Херд и Макдоналд',
      'sr-Latn': 'Ostrva Herd i Makdonald',
      zh_TW: '赫德暨麥當勞群島',
      tr: 'Heard Adası ve McDonald Adaları',
      ro: 'Insula Heard și Insulele McDonald',
      ar: 'جزيرة هيرد وجزر ماكدونالد',
      fa: 'جزیره هرد و جزایر مک‌دونالد',
      yue: '赫德岛同麦克唐纳群岛',
    },
  },
  {
    num_code: '336',
    alpha_2_code: 'VA',
    alpha_3_code: 'VAT',
    en_short_name: 'Vatican City',
    nationality: 'Vatican',
    dial_code: '+379',
    nameTranslations: {
      sk: 'Vatikán',
      se: 'Vatikána',
      pl: 'Watykan',
      no: 'Vatikanstaten',
      ja: 'バチカン市国',
      it: 'Città del Vaticano',
      zh: '梵蒂冈',
      nl: 'Vaticaanstad',
      de: 'Vatikanstadt',
      fr: 'État de la Cité du Vatican',
      es: 'Ciudad del Vaticano',
      en: 'Vatican City',
      pt_BR: 'Cidade do Vaticano',
      'sr-Cyrl': 'Ватикан',
      'sr-Latn': 'Vatikan',
      zh_TW: '梵蒂岡',
      tr: 'Vatikan',
      ro: 'Vatican',
      ar: 'الفاتيكان',
      fa: 'واتیکان',
      yue: '梵蒂岡城國',
    },
  },
  {
    num_code: '340',
    alpha_2_code: 'HN',
    alpha_3_code: 'HND',
    en_short_name: 'Honduras',
    nationality: 'Honduran',
    dial_code: '+504',
    nameTranslations: {
      sk: 'Honduras',
      se: 'Honduras',
      pl: 'Honduras',
      no: 'Honduras',
      ja: 'ホンジュラス',
      it: 'Honduras',
      zh: '洪都拉斯',
      nl: 'Honduras',
      de: 'Honduras',
      fr: 'Honduras',
      es: 'Honduras',
      en: 'Honduras',
      pt_BR: 'Honduras',
      'sr-Cyrl': 'Хондурас',
      'sr-Latn': 'Honduras',
      zh_TW: '宏都拉斯',
      tr: 'Honduras',
      ro: 'Honduras',
      ar: 'هندوراس',
      fa: 'هندوراس',
      yue: '洪都拉斯',
    },
  },
  {
    num_code: '344',
    alpha_2_code: 'HK',
    alpha_3_code: 'HKG',
    en_short_name: 'Hong Kong SAR China',
    nationality: 'Hong Kong, Hong Kongese',
    dial_code: '+852',
    nameTranslations: {
      sk: 'Hongkong – OAO Číny',
      se: 'Hongkong',
      pl: 'SRA Hongkong (Chiny)',
      no: 'Hongkong S.A.R. Kina',
      ja: '中華人民共和国香港特別行政区',
      it: 'RAS di Hong Kong',
      zh: '中国香港特别行政区',
      nl: 'Hongkong SAR van China',
      de: 'Sonderverwaltungsregion Hongkong',
      fr: 'R.A.S. chinoise de Hong Kong',
      es: 'RAE de Hong Kong (China)',
      en: 'Hong Kong SAR China',
      pt_BR: 'RAE de Hong Kong China',
      'sr-Cyrl': 'Хонг Конг',
      'sr-Latn': 'Hong Kong',
      zh_TW: '香港',
      tr: 'Hong Kong',
      ro: 'Hong Kong',
      ar: 'هونغ كونغ',
      fa: 'هنگ کنگ',
      yue: '香港',
    },
  },
  {
    num_code: '348',
    alpha_2_code: 'HU',
    alpha_3_code: 'HUN',
    en_short_name: 'Hungary',
    nationality: 'Hungarian, Magyar',
    dial_code: '+36',
    nameTranslations: {
      sk: 'Maďarsko',
      se: 'Ungár',
      pl: 'Węgry',
      no: 'Ungarn',
      ja: 'ハンガリー',
      it: 'Ungheria',
      zh: '匈牙利',
      nl: 'Hongarije',
      de: 'Ungarn',
      fr: 'Hongrie',
      es: 'Hungría',
      en: 'Hungary',
      pt_BR: 'Hungria',
      'sr-Cyrl': 'Мађарска',
      'sr-Latn': 'Mađarska',
      zh_TW: '匈牙利',
      tr: 'Macaristan',
      ro: 'Ungaria',
      ar: 'المجر',
      fa: 'مجارستان',
      yue: '匈牙利',
    },
  },
  {
    num_code: '352',
    alpha_2_code: 'IS',
    alpha_3_code: 'ISL',
    en_short_name: 'Iceland',
    nationality: 'Icelandic',
    dial_code: '+354',
    nameTranslations: {
      sk: 'Island',
      se: 'Islánda',
      pl: 'Islandia',
      no: 'Island',
      ja: 'アイスランド',
      it: 'Islanda',
      zh: '冰岛',
      nl: 'IJsland',
      de: 'Island',
      fr: 'Islande',
      es: 'Islandia',
      en: 'Iceland',
      pt_BR: 'Islândia',
      'sr-Cyrl': 'Исланд',
      'sr-Latn': 'Island',
      zh_TW: '冰島',
      tr: 'İzlanda',
      ro: 'Islanda',
      ar: 'آيسلندا',
      fa: 'ایسلند',
      yue: '冰島',
    },
  },
  {
    num_code: '356',
    alpha_2_code: 'IN',
    alpha_3_code: 'IND',
    en_short_name: 'India',
    nationality: 'Indian',
    dial_code: '+91',
    nameTranslations: {
      sk: 'India',
      se: 'India',
      pl: 'Indie',
      no: 'India',
      ja: 'インド',
      it: 'India',
      zh: '印度',
      nl: 'India',
      de: 'Indien',
      fr: 'Inde',
      es: 'India',
      en: 'India',
      pt_BR: 'Índia',
      'sr-Cyrl': 'Индија',
      'sr-Latn': 'Indija',
      zh_TW: '印度',
      tr: 'Hindistan',
      ro: 'India',
      ar: 'الهند',
      fa: 'هند',
      yue: '印度',
    },
  },
  {
    num_code: '360',
    alpha_2_code: 'ID',
    alpha_3_code: 'IDN',
    en_short_name: 'Indonesia',
    nationality: 'Indonesian',
    dial_code: '+62',
    nameTranslations: {
      sk: 'Indonézia',
      se: 'Indonesia',
      pl: 'Indonezja',
      no: 'Indonesia',
      ja: 'インドネシア',
      it: 'Indonesia',
      zh: '印度尼西亚',
      nl: 'Indonesië',
      de: 'Indonesien',
      fr: 'Indonésie',
      es: 'Indonesia',
      en: 'Indonesia',
      pt_BR: 'Indonésia',
      'sr-Cyrl': 'Индонезија',
      'sr-Latn': 'Indonezija',
      zh_TW: '印尼',
      tr: 'Endonezya',
      ro: 'Indonezia',
      ar: 'إندونيسيا',
      fa: 'اندونزی',
      yue: '印尼',
    },
  },
  {
    num_code: '364',
    alpha_2_code: 'IR',
    alpha_3_code: 'IRN',
    en_short_name: 'Iran',
    nationality: 'Iranian, Persian',
    dial_code: '+98',
    nameTranslations: {
      sk: 'Irán',
      se: 'Iran',
      pl: 'Iran',
      no: 'Iran',
      ja: 'イラン',
      it: 'Iran',
      zh: '伊朗',
      nl: 'Iran',
      de: 'Iran',
      fr: 'Iran',
      es: 'Irán',
      en: 'Iran',
      pt_BR: 'Irã',
      'sr-Cyrl': 'Иран',
      'sr-Latn': 'Iran',
      zh_TW: '伊朗',
      tr: 'İran',
      ro: 'Iran',
      ar: 'إيران',
      fa: 'ایران',
      yue: '伊朗',
    },
  },
  {
    num_code: '368',
    alpha_2_code: 'IQ',
    alpha_3_code: 'IRQ',
    en_short_name: 'Iraq',
    nationality: 'Iraqi',
    dial_code: '+964',
    nameTranslations: {
      sk: 'Irak',
      se: 'Irak',
      pl: 'Irak',
      no: 'Irak',
      ja: 'イラク',
      it: 'Iraq',
      zh: '伊拉克',
      nl: 'Irak',
      de: 'Irak',
      fr: 'Irak',
      es: 'Irak',
      en: 'Iraq',
      pt_BR: 'Iraque',
      'sr-Cyrl': 'Ирак',
      'sr-Latn': 'Irak',
      zh_TW: '伊拉克',
      tr: 'Irak',
      ro: 'Irak',
      ar: 'العراق',
      fa: 'عراق',
      yue: '伊拉克',
    },
  },
  {
    num_code: '372',
    alpha_2_code: 'IE',
    alpha_3_code: 'IRL',
    en_short_name: 'Ireland',
    nationality: 'Irish',
    dial_code: '+353',
    nameTranslations: {
      sk: 'Írsko',
      se: 'Irlánda',
      pl: 'Irlandia',
      no: 'Irland',
      ja: 'アイルランド',
      it: 'Irlanda',
      zh: '爱尔兰',
      nl: 'Ierland',
      de: 'Irland',
      fr: 'Irlande',
      es: 'Irlanda',
      en: 'Ireland',
      pt_BR: 'Irlanda',
      'sr-Cyrl': 'Ирска',
      'sr-Latn': 'Irska',
      zh_TW: '愛爾蘭',
      tr: 'İrlanda',
      ro: 'Irlanda',
      ar: 'أيرلندا',
      fa: 'ایرلند',
      yue: '愛爾蘭',
    },
  },
  {
    num_code: '833',
    alpha_2_code: 'IM',
    alpha_3_code: 'IMN',
    en_short_name: 'Isle of Man',
    nationality: 'Manx',
    dial_code: '+44',
    nameTranslations: {
      sk: 'Ostrov Man',
      se: 'Mann-sullot',
      pl: 'Wyspa Man',
      no: 'Man',
      ja: 'マン島',
      it: 'Isola di Man',
      zh: '马恩岛',
      nl: 'Isle of Man',
      de: 'Isle of Man',
      fr: 'Île de Man',
      es: 'Isla de Man',
      en: 'Isle of Man',
      pt_BR: 'Ilha de Man',
      'sr-Cyrl': 'Острво Мен',
      'sr-Latn': 'Ostrvo Men',
      zh_TW: '曼島',
      tr: 'Man Adası',
      ro: 'Insula Man',
      ar: 'جزيرة مان',
      fa: 'جزیره مان',
      yue: '马伊岛',
    },
  },
  {
    num_code: '376',
    alpha_2_code: 'IL',
    alpha_3_code: 'ISR',
    en_short_name: 'Israel',
    nationality: 'Israeli',
    dial_code: '+972',
    nameTranslations: {
      sk: 'Izrael',
      se: 'Israel',
      pl: 'Izrael',
      no: 'Israel',
      ja: 'イスラエル',
      it: 'Israele',
      zh: '以色列',
      nl: 'Israël',
      de: 'Israel',
      fr: 'Israël',
      es: 'Israel',
      en: 'Israel',
      pt_BR: 'Israel',
      'sr-Cyrl': 'Израел',
      'sr-Latn': 'Izrael',
      zh_TW: '以色列',
      tr: 'İsrail',
      ro: 'Israel',
      ar: 'إسرائيل',
      fa: 'إسرائيل',
      yue: '以色列',
    },
  },
  {
    num_code: '380',
    alpha_2_code: 'IT',
    alpha_3_code: 'ITA',
    en_short_name: 'Italy',
    nationality: 'Italian',
    dial_code: '+39',
    nameTranslations: {
      sk: 'Taliansko',
      se: 'Itália',
      pl: 'Włochy',
      no: 'Italia',
      ja: 'イタリア',
      it: 'Italia',
      zh: '意大利',
      nl: 'Italië',
      de: 'Italien',
      fr: 'Italie',
      es: 'Italia',
      en: 'Italy',
      pt_BR: 'Itália',
      'sr-Cyrl': 'Италија',
      'sr-Latn': 'Italija',
      zh_TW: '義大利',
      tr: 'İtalya',
      ro: 'Italia',
      ar: 'إيطاليا',
      fa: 'ایتالیا',
      yue: '意大利',
    },
  },
  {
    num_code: '388',
    alpha_2_code: 'JM',
    alpha_3_code: 'JAM',
    en_short_name: 'Jamaica',
    nationality: 'Jamaican',
    dial_code: '+1876',
    nameTranslations: {
      sk: 'Jamajka',
      se: 'Jamaica',
      pl: 'Jamajka',
      no: 'Jamaica',
      ja: 'ジャマイカ',
      it: 'Giamaica',
      zh: '牙买加',
      nl: 'Jamaica',
      de: 'Jamaika',
      fr: 'Jamaïque',
      es: 'Jamaica',
      en: 'Jamaica',
      pt_BR: 'Jamaica',
      'sr-Cyrl': 'Јамајка',
      'sr-Latn': 'Jamajka',
      zh_TW: '牙買加',
      tr: 'Jamaika',
      ro: 'Jamaica',
      ar: 'جامايكا',
      fa: 'جامائیکا',
      yue: '牙買加',
    },
  },
  {
    num_code: '392',
    alpha_2_code: 'JP',
    alpha_3_code: 'JPN',
    en_short_name: 'Japan',
    nationality: 'Japanese',
    dial_code: '+81',
    nameTranslations: {
      sk: 'Japonsko',
      se: 'Japána',
      pl: 'Japonia',
      no: 'Japan',
      ja: '日本',
      it: 'Giappone',
      zh: '日本',
      nl: 'Japan',
      de: 'Japan',
      fr: 'Japon',
      es: 'Japón',
      en: 'Japan',
      pt_BR: 'Japão',
      'sr-Cyrl': 'Јапан',
      'sr-Latn': 'Japan',
      zh_TW: '日本',
      tr: 'Japonya',
      ro: 'Japonia',
      ar: 'اليابان',
      fa: 'ژاپن',
      yue: '日本',
    },
  },
  {
    num_code: '832',
    alpha_2_code: 'JE',
    alpha_3_code: 'JEY',
    en_short_name: 'Jersey',
    nationality: 'Channel Island',
    dial_code: '+44',
    nameTranslations: {
      sk: 'Jersey',
      se: 'Jersey',
      pl: 'Jersey',
      no: 'Jersey',
      ja: 'ジャージー',
      it: 'Jersey',
      zh: '泽西岛',
      nl: 'Jersey',
      de: 'Jersey',
      fr: 'Jersey',
      es: 'Jersey',
      en: 'Jersey',
      pt_BR: 'Jersey',
      'sr-Cyrl': 'Џерзи',
      'sr-Latn': 'Džerzi',
      zh_TW: '澤西',
      tr: 'Jersey',
      ro: 'Jersey',
      ar: 'جيرزي',
      fa: 'جرزی',
      yue: '澤西',
    },
  },
  {
    num_code: '400',
    alpha_2_code: 'JO',
    alpha_3_code: 'JOR',
    en_short_name: 'Jordan',
    nationality: 'Jordanian',
    dial_code: '+962',
    nameTranslations: {
      sk: 'Jordánsko',
      se: 'Jordánia',
      pl: 'Jordania',
      no: 'Jordan',
      ja: 'ヨルダン',
      it: 'Giordania',
      zh: '约旦',
      nl: 'Jordanië',
      de: 'Jordanien',
      fr: 'Jordanie',
      es: 'Jordania',
      en: 'Jordan',
      pt_BR: 'Jordânia',
      'sr-Cyrl': 'Јордан',
      'sr-Latn': 'Jordan',
      zh_TW: '約旦',
      tr: 'Mavera-i Ürdün',
      ro: 'Iordania',
      ar: 'الأردن',
      fa: 'اردن',
      yue: '約旦',
    },
  },
  {
    num_code: '398',
    alpha_2_code: 'KZ',
    alpha_3_code: 'KAZ',
    en_short_name: 'Kazakhstan',
    nationality: 'Kazakhstani, Kazakh',
    dial_code: '+7',
    nameTranslations: {
      sk: 'Kazachstan',
      se: 'Kasakstan',
      pl: 'Kazachstan',
      no: 'Kasakhstan',
      ja: 'カザフスタン',
      it: 'Kazakistan',
      zh: '哈萨克斯坦',
      nl: 'Kazachstan',
      de: 'Kasachstan',
      fr: 'Kazakhstan',
      es: 'Kazajistán',
      en: 'Kazakhstan',
      pt_BR: 'Cazaquistão',
      'sr-Cyrl': 'Казахстан',
      'sr-Latn': 'Kazahstan',
      zh_TW: '哈薩克',
      tr: 'Kazakistan',
      ro: 'Kazahstan',
      ar: 'كازاخستان',
      fa: 'قزاقستان',
      yue: '哈薩克斯坦',
    },
  },
  {
    num_code: '404',
    alpha_2_code: 'KE',
    alpha_3_code: 'KEN',
    en_short_name: 'Kenya',
    nationality: 'Kenyan',
    dial_code: '+254',
    nameTranslations: {
      sk: 'Keňa',
      se: 'Kenia',
      pl: 'Kenia',
      no: 'Kenya',
      ja: 'ケニア',
      it: 'Kenya',
      zh: '肯尼亚',
      nl: 'Kenia',
      de: 'Kenia',
      fr: 'Kenya',
      es: 'Kenia',
      en: 'Kenya',
      pt_BR: 'Quênia',
      'sr-Cyrl': 'Кенија',
      'sr-Latn': 'Kenija',
      zh_TW: '肯亞',
      tr: 'Kenya',
      ro: 'Kenya',
      ar: 'كينيا',
      fa: 'كنيا',
      yue: '肯雅',
    },
  },
  {
    num_code: '296',
    alpha_2_code: 'KI',
    alpha_3_code: 'KIR',
    en_short_name: 'Kiribati',
    nationality: 'I-Kiribati',
    dial_code: '+686',
    nameTranslations: {
      sk: 'Kiribati',
      se: 'Kiribati',
      pl: 'Kiribati',
      no: 'Kiribati',
      ja: 'キリバス',
      it: 'Kiribati',
      zh: '基里巴斯',
      nl: 'Kiribati',
      de: 'Kiribati',
      fr: 'Kiribati',
      es: 'Kiribati',
      en: 'Kiribati',
      pt_BR: 'Kiribati',
      'sr-Cyrl': 'Кирибати',
      'sr-Latn': 'Kiribati',
      zh_TW: '吉里巴斯',
      tr: 'Kiribati',
      ro: 'Kiribati',
      ar: 'كيريباتي',
      fa: 'کیریباتی',
      yue: '基里巴斯',
    },
  },
  {
    num_code: '408',
    alpha_2_code: 'KP',
    alpha_3_code: 'PRK',
    en_short_name: 'North Korea',
    nationality: 'North Korean',
    dial_code: '+850',
    nameTranslations: {
      sk: 'Severná Kórea',
      se: 'Davvi-Korea',
      pl: 'Korea Północna',
      no: 'Nord-Korea',
      ja: '北朝鮮',
      it: 'Corea del Nord',
      zh: '朝鲜',
      nl: 'Noord-Korea',
      de: 'Nordkorea',
      fr: 'Corée du Nord',
      es: 'Corea del Norte',
      en: 'North Korea',
      pt_BR: 'Coreia do Norte',
      'sr-Cyrl': 'Северна Кореја',
      'sr-Latn': 'Severna Koreja',
      zh_TW: '北韓',
      tr: 'Kuzey Kore',
      ro: 'Coreea de Nord',
      ar: 'كوريا الشمالية',
      fa: 'کره شمالی',
      yue: '朝鮮（朝鮮民主主義人民共咊囯）',
    },
  },
  {
    num_code: '410',
    alpha_2_code: 'KR',
    alpha_3_code: 'KOR',
    en_short_name: 'South Korea',
    nationality: 'South Korean',
    dial_code: '+82',
    nameTranslations: {
      sk: 'Južná Kórea',
      se: 'Mátta-Korea',
      pl: 'Korea Południowa',
      no: 'Sør-Korea',
      ja: '韓国',
      it: 'Corea del Sud',
      zh: '韩国',
      nl: 'Zuid-Korea',
      de: 'Südkorea',
      fr: 'Corée du Sud',
      es: 'Corea del Sur',
      en: 'South Korea',
      pt_BR: 'Coreia do Sul',
      'sr-Cyrl': 'Јужна Кореја',
      'sr-Latn': 'Južna Koreja',
      zh_TW: '南韓',
      tr: 'Güney Kore',
      ro: 'Coreea de Sud',
      ar: 'كوريا الجنوبية',
      fa: 'کره جنوبی',
      yue: '韓國（大韓民國）',
    },
  },
  {
    num_code: '414',
    alpha_2_code: 'KW',
    alpha_3_code: 'KWT',
    en_short_name: 'Kuwait',
    nationality: 'Kuwaiti',
    dial_code: '+965',
    nameTranslations: {
      sk: 'Kuvajt',
      se: 'Kuwait',
      pl: 'Kuwejt',
      no: 'Kuwait',
      ja: 'クウェート',
      it: 'Kuwait',
      zh: '科威特',
      nl: 'Koeweit',
      de: 'Kuwait',
      fr: 'Koweït',
      es: 'Kuwait',
      en: 'Kuwait',
      pt_BR: 'Kuwait',
      'sr-Cyrl': 'Кувајт',
      'sr-Latn': 'Kuvajt',
      zh_TW: '科威特',
      tr: 'Kuveyt',
      ro: 'Kuweit',
      ar: 'الكويت',
      fa: 'کویت',
      yue: '科威特',
    },
  },
  {
    num_code: '417',
    alpha_2_code: 'KG',
    alpha_3_code: 'KGZ',
    en_short_name: 'Kyrgyzstan',
    nationality: 'Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz',
    dial_code: '+996',
    nameTranslations: {
      sk: 'Kirgizsko',
      se: 'Kirgisistan',
      pl: 'Kirgistan',
      no: 'Kirgisistan',
      ja: 'キルギス',
      it: 'Kirghizistan',
      zh: '吉尔吉斯斯坦',
      nl: 'Kirgizië',
      de: 'Kirgisistan',
      fr: 'Kirghizistan',
      es: 'Kirguistán',
      en: 'Kyrgyzstan',
      pt_BR: 'Quirguistão',
      'sr-Cyrl': 'Киргистан',
      'sr-Latn': 'Kirgistan',
      zh_TW: '吉爾吉斯',
      tr: 'Kırgızistan',
      ro: 'Kîrgîzstan',
      ar: 'قيرغيزستان',
      fa: 'قرقیزستان',
      yue: '吉爾吉斯斯坦',
    },
  },
  {
    num_code: '418',
    alpha_2_code: 'LA',
    alpha_3_code: 'LAO',
    en_short_name: 'Laos',
    nationality: 'Lao, Laotian',
    dial_code: '+856',
    nameTranslations: {
      sk: 'Laos',
      se: 'Laos',
      pl: 'Laos',
      no: 'Laos',
      ja: 'ラオス',
      it: 'Laos',
      zh: '老挝',
      nl: 'Laos',
      de: 'Laos',
      fr: 'Laos',
      es: 'Laos',
      en: 'Laos',
      pt_BR: 'Laos',
      'sr-Cyrl': 'Лаос',
      'sr-Latn': 'Laos',
      zh_TW: '寮國',
      tr: 'Laos',
      ro: 'Laos',
      ar: 'لاوس',
      fa: 'لائوس',
      yue: '老撾人民民主共和國',
    },
  },
  {
    num_code: '428',
    alpha_2_code: 'LV',
    alpha_3_code: 'LVA',
    en_short_name: 'Latvia',
    nationality: 'Latvian',
    dial_code: '+371',
    nameTranslations: {
      sk: 'Lotyšsko',
      se: 'Látvia',
      pl: 'Łotwa',
      no: 'Latvia',
      ja: 'ラトビア',
      it: 'Lettonia',
      zh: '拉脱维亚',
      nl: 'Letland',
      de: 'Lettland',
      fr: 'Lettonie',
      es: 'Letonia',
      en: 'Latvia',
      pt_BR: 'Letônia',
      'sr-Cyrl': 'Летонија',
      'sr-Latn': 'Letonija',
      zh_TW: '拉托維亞',
      tr: 'Letonya',
      ro: 'Letonia',
      ar: 'لاتفيا',
      fa: 'لتونی',
      yue: '拉脫維亞',
    },
  },
  {
    num_code: '422',
    alpha_2_code: 'LB',
    alpha_3_code: 'LBN',
    en_short_name: 'Lebanon',
    nationality: 'Lebanese',
    dial_code: '+961',
    nameTranslations: {
      sk: 'Libanon',
      se: 'Libanon',
      pl: 'Liban',
      no: 'Libanon',
      ja: 'レバノン',
      it: 'Libano',
      zh: '黎巴嫩',
      nl: 'Libanon',
      de: 'Libanon',
      fr: 'Liban',
      es: 'Líbano',
      en: 'Lebanon',
      pt_BR: 'Líbano',
      'sr-Cyrl': 'Либан',
      'sr-Latn': 'Liban',
      zh_TW: '黎巴嫩',
      tr: 'Lübnan',
      ro: 'Liban',
      ar: 'لبنان',
      fa: 'لبنان',
      yue: '黎巴嫩',
    },
  },
  {
    num_code: '426',
    alpha_2_code: 'LS',
    alpha_3_code: 'LSO',
    en_short_name: 'Lesotho',
    nationality: 'Basotho',
    dial_code: '+266',
    nameTranslations: {
      sk: 'Lesotho',
      se: 'Lesotho',
      pl: 'Lesotho',
      no: 'Lesotho',
      ja: 'レソト',
      it: 'Lesotho',
      zh: '莱索托',
      nl: 'Lesotho',
      de: 'Lesotho',
      fr: 'Lesotho',
      es: 'Lesoto',
      en: 'Lesotho',
      pt_BR: 'Lesoto',
      'sr-Cyrl': 'Лесото',
      'sr-Latn': 'Lesoto',
      zh_TW: '賴索托',
      tr: 'Lesotho',
      ro: 'Lesotho',
      ar: 'ليسوتو',
      fa: 'لسوتو',
      yue: '萊索托',
    },
  },
  {
    num_code: '430',
    alpha_2_code: 'LR',
    alpha_3_code: 'LBR',
    en_short_name: 'Liberia',
    nationality: 'Liberian',
    dial_code: '+231',
    nameTranslations: {
      sk: 'Libéria',
      se: 'Liberia',
      pl: 'Liberia',
      no: 'Liberia',
      ja: 'リベリア',
      it: 'Liberia',
      zh: '利比里亚',
      nl: 'Liberia',
      de: 'Liberia',
      fr: 'Libéria',
      es: 'Liberia',
      en: 'Liberia',
      pt_BR: 'Libéria',
      'sr-Cyrl': 'Либерија',
      'sr-Latn': 'Liberija',
      zh_TW: '賴比瑞亞',
      tr: 'Liberya',
      ro: 'Liberia',
      ar: 'ليبيريا',
      fa: 'لیبریا',
      yue: '利比里亞',
    },
  },
  {
    num_code: '434',
    alpha_2_code: 'LY',
    alpha_3_code: 'LBY',
    en_short_name: 'Libya',
    nationality: 'Libyan',
    dial_code: '+218',
    nameTranslations: {
      sk: 'Líbya',
      se: 'Libya',
      pl: 'Libia',
      no: 'Libya',
      ja: 'リビア',
      it: 'Libia',
      zh: '利比亚',
      nl: 'Libië',
      de: 'Libyen',
      fr: 'Libye',
      es: 'Libia',
      en: 'Libya',
      pt_BR: 'Líbia',
      'sr-Cyrl': 'Либија',
      'sr-Latn': 'Libija',
      zh_TW: '利比亞',
      tr: 'Libya',
      ro: 'Libia',
      ar: 'ليبيا',
      fa: 'لیبی',
      yue: '利比亞',
    },
  },
  {
    num_code: '438',
    alpha_2_code: 'LI',
    alpha_3_code: 'LIE',
    en_short_name: 'Liechtenstein',
    nationality: 'Liechtenstein',
    dial_code: '+423',
    nameTranslations: {
      sk: 'Lichtenštajnsko',
      se: 'Liechtenstein',
      pl: 'Liechtenstein',
      no: 'Liechtenstein',
      ja: 'リヒテンシュタイン',
      it: 'Liechtenstein',
      zh: '列支敦士登',
      nl: 'Liechtenstein',
      de: 'Liechtenstein',
      fr: 'Liechtenstein',
      es: 'Liechtenstein',
      en: 'Liechtenstein',
      pt_BR: 'Liechtenstein',
      'sr-Cyrl': 'Лихтенштајн',
      'sr-Latn': 'Lihtenštajn',
      zh_TW: '列支敦斯登',
      tr: 'Lihtenştayn',
      ro: 'Liechtenstein',
      ar: 'ليختنشتاين',
      fa: 'لیختن‌اشتاین',
      yue: '列支敦士登',
    },
  },
  {
    num_code: '440',
    alpha_2_code: 'LT',
    alpha_3_code: 'LTU',
    en_short_name: 'Lithuania',
    nationality: 'Lithuanian',
    dial_code: '+370',
    nameTranslations: {
      sk: 'Litva',
      se: 'Lietuva',
      pl: 'Litwa',
      no: 'Litauen',
      ja: 'リトアニア',
      it: 'Lituania',
      zh: '立陶宛',
      nl: 'Litouwen',
      de: 'Litauen',
      fr: 'Lituanie',
      es: 'Lituania',
      en: 'Lithuania',
      pt_BR: 'Lituânia',
      'sr-Cyrl': 'Литванија',
      'sr-Latn': 'Litvanija',
      zh_TW: '立陶宛',
      tr: 'Litvanya',
      ro: 'Lituania',
      ar: 'ليتوانيا',
      fa: 'لیتوانی',
      yue: '立陶宛',
    },
  },
  {
    num_code: '442',
    alpha_2_code: 'LU',
    alpha_3_code: 'LUX',
    en_short_name: 'Luxembourg',
    nationality: 'Luxembourg, Luxembourgish',
    dial_code: '+352',
    nameTranslations: {
      sk: 'Luxembursko',
      se: 'Luxembourg',
      pl: 'Luksemburg',
      no: 'Luxemburg',
      ja: 'ルクセンブルク',
      it: 'Lussemburgo',
      zh: '卢森堡',
      nl: 'Luxemburg',
      de: 'Luxemburg',
      fr: 'Luxembourg',
      es: 'Luxemburgo',
      en: 'Luxembourg',
      pt_BR: 'Luxemburgo',
      'sr-Cyrl': 'Луксенбург',
      'sr-Latn': 'Luksenburg',
      zh_TW: '盧森堡',
      tr: 'Lüksemburg',
      ro: 'Luxemburg',
      ar: 'لوكسمبورغ',
      fa: 'لوکزامبورگ',
      yue: '盧森堡',
    },
  },
  {
    num_code: '446',
    alpha_2_code: 'MO',
    alpha_3_code: 'MAC',
    en_short_name: 'Macao SAR China',
    nationality: 'Macanese, Chinese',
    dial_code: '+853',
    nameTranslations: {
      sk: 'Macao – OAO Číny',
      se: 'Makáo',
      pl: 'SRA Makau (Chiny)',
      no: 'Macao S.A.R. Kina',
      ja: '中華人民共和国マカオ特別行政区',
      it: 'RAS di Macao',
      zh: '中国澳门特别行政区',
      nl: 'Macau SAR van China',
      de: 'Sonderverwaltungsregion Macau',
      fr: 'R.A.S. chinoise de Macao',
      es: 'RAE de Macao (China)',
      en: 'Macao SAR China',
      pt_BR: 'RAE de Macau China',
      'sr-Cyrl': 'Макао',
      'sr-Latn': 'Makao',
      zh_TW: '澳門',
      tr: 'Makao',
      ro: 'Macao',
      ar: 'ماكاو',
      fa: 'ماكائو',
      yue: '澳門',
    },
  },
  {
    num_code: '807',
    alpha_2_code: 'MK',
    alpha_3_code: 'MKD',
    en_short_name: 'North Macedonia',
    nationality: 'Macedonian',
    dial_code: '+389',
    nameTranslations: {
      sk: 'Severné Macedónsko',
      se: 'North Macedonia',
      pl: 'Macedonia Północna',
      no: 'Nord-Makedonia',
      ja: '北マケドニア',
      it: 'Macedonia del Nord',
      zh: '北马其顿',
      nl: 'Noord-Macedonië',
      de: 'Nordmazedonien',
      fr: 'Macédoine du Nord',
      es: 'Macedonia del Norte',
      en: 'North Macedonia',
      pt_BR: 'Macedônia do Norte',
      'sr-Cyrl': 'Северна Македонија',
      'sr-Latn': 'Severna Makedonija',
      zh_TW: '北馬其頓',
      tr: 'Kuzey Makedonya',
      ro: 'Macedonia de Nord',
      ar: 'مقدونيا',
      fa: 'مقدونیه',
      yue: '馬其頓（前南斯拉夫共和國）',
    },
  },
  {
    num_code: '450',
    alpha_2_code: 'MG',
    alpha_3_code: 'MDG',
    en_short_name: 'Madagascar',
    nationality: 'Malagasy',
    dial_code: '+261',
    nameTranslations: {
      sk: 'Madagaskar',
      se: 'Madagaskar',
      pl: 'Madagaskar',
      no: 'Madagaskar',
      ja: 'マダガスカル',
      it: 'Madagascar',
      zh: '马达加斯加',
      nl: 'Madagaskar',
      de: 'Madagaskar',
      fr: 'Madagascar',
      es: 'Madagascar',
      en: 'Madagascar',
      pt_BR: 'Madagáscar',
      'sr-Cyrl': 'Мадагаскар',
      'sr-Latn': 'Madagaskar',
      zh_TW: '馬達加斯加',
      tr: 'Madagaskar',
      ro: 'Madagascar',
      ar: 'مدغشقر',
      fa: 'ماداگاسکار',
      yue: '馬達加斯加',
    },
  },
  {
    num_code: '454',
    alpha_2_code: 'MW',
    alpha_3_code: 'MWI',
    en_short_name: 'Malawi',
    nationality: 'Malawian',
    dial_code: '+265',
    nameTranslations: {
      sk: 'Malawi',
      se: 'Malawi',
      pl: 'Malawi',
      no: 'Malawi',
      ja: 'マラウイ',
      it: 'Malawi',
      zh: '马拉维',
      nl: 'Malawi',
      de: 'Malawi',
      fr: 'Malawi',
      es: 'Malaui',
      en: 'Malawi',
      pt_BR: 'Malawi',
      'sr-Cyrl': 'Малави',
      'sr-Latn': 'Malavi',
      zh_TW: '馬拉威',
      tr: 'Malavi',
      ro: 'Malawi',
      ar: 'مالاوي',
      fa: 'مالاوی',
      yue: '馬拉維',
    },
  },
  {
    num_code: '458',
    alpha_2_code: 'MY',
    alpha_3_code: 'MYS',
    en_short_name: 'Malaysia',
    nationality: 'Malaysian',
    dial_code: '+60',
    nameTranslations: {
      sk: 'Malajzia',
      se: 'Malesia',
      pl: 'Malezja',
      no: 'Malaysia',
      ja: 'マレーシア',
      it: 'Malaysia',
      zh: '马来西亚',
      nl: 'Maleisië',
      de: 'Malaysia',
      fr: 'Malaisie',
      es: 'Malasia',
      en: 'Malaysia',
      pt_BR: 'Malásia',
      'sr-Cyrl': 'Малезија',
      'sr-Latn': 'Malezija',
      zh_TW: '馬來西亞',
      tr: 'Malezya',
      ro: 'Malaezia',
      ar: 'ماليزيا',
      fa: 'مالزی',
      yue: '馬來西亞',
    },
  },
  {
    num_code: '462',
    alpha_2_code: 'MV',
    alpha_3_code: 'MDV',
    en_short_name: 'Maldives',
    nationality: 'Maldivian',
    dial_code: '+960',
    nameTranslations: {
      sk: 'Maldivy',
      se: 'Malediivvat',
      pl: 'Malediwy',
      no: 'Maldivene',
      ja: 'モルディブ',
      it: 'Maldive',
      zh: '马尔代夫',
      nl: 'Maldiven',
      de: 'Malediven',
      fr: 'Maldives',
      es: 'Maldivas',
      en: 'Maldives',
      pt_BR: 'Maldivas',
      'sr-Cyrl': 'Малдиви',
      'sr-Latn': 'Maldivi',
      zh_TW: '馬爾地夫',
      tr: 'Maldivler',
      ro: 'Maldive',
      ar: 'جزر المالديف',
      fa: 'مالدیو',
      yue: '馬爾代夫',
    },
  },
  {
    num_code: '466',
    alpha_2_code: 'ML',
    alpha_3_code: 'MLI',
    en_short_name: 'Mali',
    nationality: 'Malian, Malinese',
    dial_code: '+223',
    nameTranslations: {
      sk: 'Mali',
      se: 'Mali',
      pl: 'Mali',
      no: 'Mali',
      ja: 'マリ',
      it: 'Mali',
      zh: '马里',
      nl: 'Mali',
      de: 'Mali',
      fr: 'Mali',
      es: 'Mali',
      en: 'Mali',
      pt_BR: 'Mali',
      'sr-Cyrl': 'Мали',
      'sr-Latn': 'Mali',
      zh_TW: '馬里',
      tr: 'Mali',
      ro: 'Mali',
      ar: 'مالي',
      fa: 'مالی',
      yue: '馬里',
    },
  },
  {
    num_code: '470',
    alpha_2_code: 'MT',
    alpha_3_code: 'MLT',
    en_short_name: 'Malta',
    nationality: 'Maltese',
    dial_code: '+356',
    nameTranslations: {
      sk: 'Malta',
      se: 'Málta',
      pl: 'Malta',
      no: 'Malta',
      ja: 'マルタ',
      it: 'Malta',
      zh: '马耳他',
      nl: 'Malta',
      de: 'Malta',
      fr: 'Malte',
      es: 'Malta',
      en: 'Malta',
      pt_BR: 'Malta',
      'sr-Cyrl': 'Малта',
      'sr-Latn': 'Malta',
      zh_TW: '馬爾他',
      tr: 'Malta',
      ro: 'Malta',
      ar: 'مالطا',
      fa: 'مالت',
      yue: '馬耳他',
    },
  },
  {
    num_code: '584',
    alpha_2_code: 'MH',
    alpha_3_code: 'MHL',
    en_short_name: 'Marshall Islands',
    nationality: 'Marshallese',
    dial_code: '+692',
    nameTranslations: {
      sk: 'Marshallove ostrovy',
      se: 'Marshallsullot',
      pl: 'Wyspy Marshalla',
      no: 'Marshalløyene',
      ja: 'マーシャル諸島',
      it: 'Isole Marshall',
      zh: '马绍尔群岛',
      nl: 'Marshalleilanden',
      de: 'Marshallinseln',
      fr: 'Îles Marshall',
      es: 'Islas Marshall',
      en: 'Marshall Islands',
      pt_BR: 'Ilhas Marshall',
      'sr-Cyrl': 'Маршалска Острва',
      'sr-Latn': 'Maršalska Ostrva',
      zh_TW: '馬紹爾群島',
      tr: 'Marshall Adaları',
      ro: 'Insulele Marshall',
      ar: 'جزر مارشال',
      fa: 'جزایر مارشال',
      yue: '馬紹爾群島',
    },
  },
  {
    num_code: '474',
    alpha_2_code: 'MQ',
    alpha_3_code: 'MTQ',
    en_short_name: 'Martinique',
    nationality: 'Martiniquais, Martinican',
    dial_code: '+596',
    nameTranslations: {
      sk: 'Martinik',
      se: 'Martinique',
      pl: 'Martynika',
      no: 'Martinique',
      ja: 'マルティニーク',
      it: 'Martinica',
      zh: '马提尼克',
      nl: 'Martinique',
      de: 'Martinique',
      fr: 'Martinique',
      es: 'Martinica',
      en: 'Martinique',
      pt_BR: 'Martinica',
      'sr-Cyrl': 'Мартиник',
      'sr-Latn': 'Martinik',
      zh_TW: '馬丁尼克',
      tr: 'Martinique',
      ro: 'Martinica',
      ar: 'مارتينيك',
      fa: 'مارتینیک',
      yue: '马提尼克',
    },
  },
  {
    num_code: '478',
    alpha_2_code: 'MR',
    alpha_3_code: 'MRT',
    en_short_name: 'Mauritania',
    nationality: 'Mauritanian',
    dial_code: '+222',
    nameTranslations: {
      sk: 'Mauritánia',
      se: 'Mauretánia',
      pl: 'Mauretania',
      no: 'Mauritania',
      ja: 'モーリタニア',
      it: 'Mauritania',
      zh: '毛里塔尼亚',
      nl: 'Mauritanië',
      de: 'Mauretanien',
      fr: 'Mauritanie',
      es: 'Mauritania',
      en: 'Mauritania',
      pt_BR: 'Mauritânia',
      'sr-Cyrl': 'Мауританија',
      'sr-Latn': 'Mauritanija',
      zh_TW: '茅利塔尼亞',
      tr: 'Moritanya',
      ro: 'Mauritania',
      ar: 'موريتانيا',
      fa: 'موریتانی',
      yue: '毛里塔尼亞',
    },
  },
  {
    num_code: '480',
    alpha_2_code: 'MU',
    alpha_3_code: 'MUS',
    en_short_name: 'Mauritius',
    nationality: 'Mauritian',
    dial_code: '+230',
    nameTranslations: {
      sk: 'Maurícius',
      se: 'Mauritius',
      pl: 'Mauritius',
      no: 'Mauritius',
      ja: 'モーリシャス',
      it: 'Mauritius',
      zh: '毛里求斯',
      nl: 'Mauritius',
      de: 'Mauritius',
      fr: 'Maurice',
      es: 'Mauricio',
      en: 'Mauritius',
      pt_BR: 'Maurício',
      'sr-Cyrl': 'Маурицијус',
      'sr-Latn': 'Mauricijus',
      zh_TW: '模里西斯',
      tr: 'Mauritius',
      ro: 'Mauritius',
      ar: 'موريشيوس',
      fa: 'موریس',
      yue: '毛里求斯',
    },
  },
  {
    num_code: '175',
    alpha_2_code: 'YT',
    alpha_3_code: 'MYT',
    en_short_name: 'Mayotte',
    nationality: 'Mahoran',
    dial_code: '+262',
    nameTranslations: {
      sk: 'Mayotte',
      se: 'Mayotte',
      pl: 'Majotta',
      no: 'Mayotte',
      ja: 'マヨット',
      it: 'Mayotte',
      zh: '马约特',
      nl: 'Mayotte',
      de: 'Mayotte',
      fr: 'Mayotte',
      es: 'Mayotte',
      en: 'Mayotte',
      pt_BR: 'Mayotte',
      'sr-Cyrl': 'Мајота',
      'sr-Latn': 'Majota',
      zh_TW: '馬約特',
      tr: 'Mayotte',
      ro: 'Mayotte',
      ar: 'مايوت',
      fa: 'مایوت',
      yue: '馬約特',
    },
  },
  {
    num_code: '484',
    alpha_2_code: 'MX',
    alpha_3_code: 'MEX',
    en_short_name: 'Mexico',
    nationality: 'Mexican',
    dial_code: '+52',
    nameTranslations: {
      sk: 'Mexiko',
      se: 'Meksiko',
      pl: 'Meksyk',
      no: 'Mexico',
      ja: 'メキシコ',
      it: 'Messico',
      zh: '墨西哥',
      nl: 'Mexico',
      de: 'Mexiko',
      fr: 'Mexique',
      es: 'México',
      en: 'Mexico',
      pt_BR: 'México',
      'sr-Cyrl': 'Мексико',
      'sr-Latn': 'Meksiko',
      zh_TW: '墨西哥',
      tr: 'Meksika',
      ro: 'Mexic',
      ar: 'المكسيك',
      fa: 'مکزیک',
      yue: '墨西哥',
    },
  },
  {
    num_code: '583',
    alpha_2_code: 'FM',
    alpha_3_code: 'FSM',
    en_short_name: 'Micronesia',
    nationality: 'Micronesian',
    dial_code: '+691',
    nameTranslations: {
      sk: 'Mikronézia',
      se: 'Mikronesia',
      pl: 'Mikronezja',
      no: 'Mikronesiaføderasjonen',
      ja: 'ミクロネシア連邦',
      it: 'Micronesia',
      zh: '密克罗尼西亚',
      nl: 'Micronesia',
      de: 'Mikronesien',
      fr: 'États fédérés de Micronésie',
      es: 'Micronesia',
      en: 'Micronesia',
      pt_BR: 'Micronésia',
      'sr-Cyrl': 'Микронезија',
      'sr-Latn': 'Mikronezija',
      zh_TW: '密克羅尼西亞',
      tr: 'Mikronezya',
      ro: 'Micronezia',
      ar: 'ولايات ميكرونيسيا المتحدة',
      fa: 'ایالات فدرال میکرونزی',
      yue: '密克罗尼西亚（聯邦）',
    },
  },
  {
    num_code: '498',
    alpha_2_code: 'MD',
    alpha_3_code: 'MDA',
    en_short_name: 'Moldova',
    nationality: 'Moldovan',
    dial_code: '+373',
    nameTranslations: {
      sk: 'Moldavsko',
      se: 'Moldávia',
      pl: 'Mołdawia',
      no: 'Moldova',
      ja: 'モルドバ',
      it: 'Moldavia',
      zh: '摩尔多瓦',
      nl: 'Moldavië',
      de: 'Republik Moldau',
      fr: 'Moldavie',
      es: 'Moldavia',
      en: 'Moldova',
      pt_BR: 'Moldova',
      'sr-Cyrl': 'Молдавија',
      'sr-Latn': 'Moldavija',
      zh_TW: '摩爾多瓦',
      tr: 'Moldova',
      ro: 'Moldova',
      ar: 'مولدوفا',
      fa: 'مولداوی',
      yue: '摩爾多瓦（共和國）',
    },
  },
  {
    num_code: '492',
    alpha_2_code: 'MC',
    alpha_3_code: 'MCO',
    en_short_name: 'Monaco',
    nationality: 'Monégasque, Monacan',
    dial_code: '+377',
    nameTranslations: {
      sk: 'Monako',
      se: 'Monaco',
      pl: 'Monako',
      no: 'Monaco',
      ja: 'モナコ',
      it: 'Monaco',
      zh: '摩纳哥',
      nl: 'Monaco',
      de: 'Monaco',
      fr: 'Monaco',
      es: 'Mónaco',
      en: 'Monaco',
      pt_BR: 'Mônaco',
      'sr-Cyrl': 'Монако',
      'sr-Latn': 'Monako',
      zh_TW: '摩納哥',
      tr: 'Monako',
      ro: 'Monaco',
      ar: 'موناكو',
      fa: 'موناكو',
      yue: '摩納哥',
    },
  },
  {
    num_code: '496',
    alpha_2_code: 'MN',
    alpha_3_code: 'MNG',
    en_short_name: 'Mongolia',
    nationality: 'Mongolian',
    dial_code: '+976',
    nameTranslations: {
      sk: 'Mongolsko',
      se: 'Mongolia',
      pl: 'Mongolia',
      no: 'Mongolia',
      ja: 'モンゴル',
      it: 'Mongolia',
      zh: '蒙古',
      nl: 'Mongolië',
      de: 'Mongolei',
      fr: 'Mongolie',
      es: 'Mongolia',
      en: 'Mongolia',
      pt_BR: 'Mongólia',
      'sr-Cyrl': 'Монголија',
      'sr-Latn': 'Mongolija',
      zh_TW: '蒙古',
      tr: 'Moğolistan',
      ro: 'Mongolia',
      ar: 'منغوليا',
      fa: 'مغولستان',
      yue: '蒙古',
    },
  },
  {
    num_code: '499',
    alpha_2_code: 'ME',
    alpha_3_code: 'MNE',
    en_short_name: 'Montenegro',
    nationality: 'Montenegrin',
    dial_code: '+382',
    nameTranslations: {
      sk: 'Čierna Hora',
      se: 'Montenegro',
      pl: 'Czarnogóra',
      no: 'Montenegro',
      ja: 'モンテネグロ',
      it: 'Montenegro',
      zh: '黑山',
      nl: 'Montenegro',
      de: 'Montenegro',
      fr: 'Monténégro',
      es: 'Montenegro',
      en: 'Montenegro',
      pt_BR: 'Montenegro',
      'sr-Cyrl': 'Црна Гора',
      'sr-Latn': 'Crna Gora',
      zh_TW: '蒙特內哥羅',
      tr: 'Karadağ',
      ro: 'Muntenegru',
      ar: 'الجبل الأسود',
      fa: 'مونته‌نگرو',
      yue: '黑山',
    },
  },
  {
    num_code: '500',
    alpha_2_code: 'MS',
    alpha_3_code: 'MSR',
    en_short_name: 'Montserrat',
    nationality: 'Montserratian',
    dial_code: '+1664',
    nameTranslations: {
      sk: 'Montserrat',
      se: 'Montserrat',
      pl: 'Montserrat',
      no: 'Montserrat',
      ja: 'モントセラト',
      it: 'Montserrat',
      zh: '蒙特塞拉特',
      nl: 'Montserrat',
      de: 'Montserrat',
      fr: 'Montserrat',
      es: 'Montserrat',
      en: 'Montserrat',
      pt_BR: 'Montserrat',
      'sr-Cyrl': 'Монтсерат',
      'sr-Latn': 'Montserat',
      zh_TW: '蒙哲臘',
      tr: 'Montserrat',
      ro: 'Montserrat',
      ar: 'مونتسرات',
      fa: 'مونتسرات',
      yue: '蒙特塞拉特',
    },
  },
  {
    num_code: '504',
    alpha_2_code: 'MA',
    alpha_3_code: 'MAR',
    en_short_name: 'Morocco',
    nationality: 'Moroccan',
    dial_code: '+212',
    nameTranslations: {
      sk: 'Maroko',
      se: 'Marokko',
      pl: 'Maroko',
      no: 'Marokko',
      ja: 'モロッコ',
      it: 'Marocco',
      zh: '摩洛哥',
      nl: 'Marokko',
      de: 'Marokko',
      fr: 'Maroc',
      es: 'Marruecos',
      en: 'Morocco',
      pt_BR: 'Marrocos',
      'sr-Cyrl': 'Мароко',
      'sr-Latn': 'Maroko',
      zh_TW: '摩洛哥',
      tr: 'Fas',
      ro: 'Maroc',
      ar: 'المغرب',
      fa: 'مراکش',
      yue: '摩洛哥',
    },
  },
  {
    num_code: '508',
    alpha_2_code: 'MZ',
    alpha_3_code: 'MOZ',
    en_short_name: 'Mozambique',
    nationality: 'Mozambican',
    dial_code: '+258',
    nameTranslations: {
      sk: 'Mozambik',
      se: 'Mosambik',
      pl: 'Mozambik',
      no: 'Mosambik',
      ja: 'モザンビーク',
      it: 'Mozambico',
      zh: '莫桑比克',
      nl: 'Mozambique',
      de: 'Mosambik',
      fr: 'Mozambique',
      es: 'Mozambique',
      en: 'Mozambique',
      pt_BR: 'Moçambique',
      'sr-Cyrl': 'Мозамбик',
      'sr-Latn': 'Mozambik',
      zh_TW: '莫三比克',
      tr: 'Mozambik',
      ro: 'Mozambic',
      ar: 'موزمبيق',
      fa: 'موزامبیک',
      yue: '莫桑比克',
    },
  },
  {
    num_code: '104',
    alpha_2_code: 'MM',
    alpha_3_code: 'MMR',
    en_short_name: 'Myanmar (Burma)',
    nationality: 'Burmese',
    dial_code: '+95',
    nameTranslations: {
      sk: 'Mjanmarsko',
      se: 'Burma',
      pl: 'Mjanma (Birma)',
      no: 'Myanmar (Burma)',
      ja: 'ミャンマー (ビルマ)',
      it: 'Myanmar (Birmania)',
      zh: '缅甸',
      nl: 'Myanmar (Birma)',
      de: 'Myanmar',
      fr: 'Myanmar (Birmanie)',
      es: 'Myanmar (Birmania)',
      en: 'Myanmar (Burma)',
      pt_BR: 'Mianmar (Birmânia)',
      'sr-Cyrl': 'Мјанмар (Бурма)',
      'sr-Latn': 'Mjanmar (Burma)',
      zh_TW: '緬甸',
      tr: 'Myanmar',
      ro: 'Myanmar',
      ar: 'ميانمار',
      fa: 'میانمار',
      yue: '緬甸',
    },
  },
  {
    num_code: '516',
    alpha_2_code: 'NA',
    alpha_3_code: 'NAM',
    en_short_name: 'Namibia',
    nationality: 'Namibian',
    dial_code: '+264',
    nameTranslations: {
      sk: 'Namíbia',
      se: 'Namibia',
      pl: 'Namibia',
      no: 'Namibia',
      ja: 'ナミビア',
      it: 'Namibia',
      zh: '纳米比亚',
      nl: 'Namibië',
      de: 'Namibia',
      fr: 'Namibie',
      es: 'Namibia',
      en: 'Namibia',
      pt_BR: 'Namibia',
      'sr-Cyrl': 'Намибија',
      'sr-Latn': 'Namibija',
      zh_TW: '納米比亞',
      tr: 'Namibya',
      ro: 'Namibia',
      ar: 'ناميبيا',
      fa: 'نامیبیا',
      yue: '納米比亞',
    },
  },
  {
    num_code: '520',
    alpha_2_code: 'NR',
    alpha_3_code: 'NRU',
    en_short_name: 'Nauru',
    nationality: 'Nauruan',
    dial_code: '+674',
    nameTranslations: {
      sk: 'Nauru',
      se: 'Nauru',
      pl: 'Nauru',
      no: 'Nauru',
      ja: 'ナウル',
      it: 'Nauru',
      zh: '瑙鲁',
      nl: 'Nauru',
      de: 'Nauru',
      fr: 'Nauru',
      es: 'Nauru',
      en: 'Nauru',
      pt_BR: 'Nauru',
      'sr-Cyrl': 'Науру',
      'sr-Latn': 'Nauru',
      zh_TW: '諾魯',
      tr: 'Nauru',
      ro: 'Nauru',
      ar: 'ناورو',
      fa: 'نائورو',
      yue: '瑙魯',
    },
  },
  {
    num_code: '524',
    alpha_2_code: 'NP',
    alpha_3_code: 'NPL',
    en_short_name: 'Nepal',
    nationality: 'Nepali, Nepalese',
    dial_code: '+977',
    nameTranslations: {
      sk: 'Nepál',
      se: 'Nepal',
      pl: 'Nepal',
      no: 'Nepal',
      ja: 'ネパール',
      it: 'Nepal',
      zh: '尼泊尔',
      nl: 'Nepal',
      de: 'Nepal',
      fr: 'Népal',
      es: 'Nepal',
      en: 'Nepal',
      pt_BR: 'Nepal',
      'sr-Cyrl': 'Непал',
      'sr-Latn': 'Nepal',
      zh_TW: '尼泊爾',
      tr: 'Nepal',
      ro: 'Nepal',
      ar: 'نيبال',
      fa: 'نپال',
      yue: '尼泊爾',
    },
  },
  {
    num_code: '528',
    alpha_2_code: 'NL',
    alpha_3_code: 'NLD',
    en_short_name: 'Netherlands',
    nationality: 'Dutch, Netherlandic',
    dial_code: '+31',
    nameTranslations: {
      sk: 'Holandsko',
      se: 'Vuolleeatnamat',
      pl: 'Holandia',
      no: 'Nederland',
      ja: 'オランダ',
      it: 'Paesi Bassi',
      zh: '荷兰',
      nl: 'Nederland',
      de: 'Niederlande',
      fr: 'Pays-Bas',
      es: 'Países Bajos',
      en: 'Netherlands',
      pt_BR: 'Países Baixos',
      'sr-Cyrl': 'Холандија',
      'sr-Latn': 'Holandija',
      zh_TW: '荷蘭',
      tr: 'Hollanda',
      ro: 'Olanda',
      ar: 'هولندا',
      fa: 'هلند',
      yue: '荷蘭',
    },
  },
  {
    num_code: '540',
    alpha_2_code: 'NC',
    alpha_3_code: 'NCL',
    en_short_name: 'New Caledonia',
    nationality: 'New Caledonian',
    dial_code: '+687',
    nameTranslations: {
      sk: 'Nová Kaledónia',
      se: 'Ođđa-Kaledonia',
      pl: 'Nowa Kaledonia',
      no: 'Ny-Caledonia',
      ja: 'ニューカレドニア',
      it: 'Nuova Caledonia',
      zh: '新喀里多尼亚',
      nl: 'Nieuw-Caledonië',
      de: 'Neukaledonien',
      fr: 'Nouvelle-Calédonie',
      es: 'Nueva Caledonia',
      en: 'New Caledonia',
      pt_BR: 'Nova Caledônia',
      'sr-Cyrl': 'Нова Каледонија',
      'sr-Latn': 'Nova Kaledonija',
      zh_TW: '新喀里多尼亞',
      tr: 'Yeni Kaledonya',
      ro: 'Noua Caledonie',
      ar: 'كاليدونيا الجديدة',
      fa: 'کالدونیای جدید',
      yue: '新喀里多尼亚',
    },
  },
  {
    num_code: '554',
    alpha_2_code: 'NZ',
    alpha_3_code: 'NZL',
    en_short_name: 'New Zealand',
    nationality: 'New Zealand, NZ',
    dial_code: '+64',
    nameTranslations: {
      sk: 'Nový Zéland',
      se: 'Ođđa-Selánda',
      pl: 'Nowa Zelandia',
      no: 'New Zealand',
      ja: 'ニュージーランド',
      it: 'Nuova Zelanda',
      zh: '新西兰',
      nl: 'Nieuw-Zeeland',
      de: 'Neuseeland',
      fr: 'Nouvelle-Zélande',
      es: 'Nueva Zelanda',
      en: 'New Zealand',
      pt_BR: 'Nova Zelândia',
      'sr-Cyrl': 'Нови Зеланд',
      'sr-Latn': 'Novi Zeland',
      zh_TW: '紐西蘭',
      tr: 'Yeni Zelanda',
      ro: 'Noua Zeelandă',
      ar: 'نيوزيلندا',
      fa: 'نیوزلند',
      yue: '紐西蘭',
    },
  },
  {
    num_code: '558',
    alpha_2_code: 'NI',
    alpha_3_code: 'NIC',
    en_short_name: 'Nicaragua',
    nationality: 'Nicaraguan',
    dial_code: '+505',
    nameTranslations: {
      sk: 'Nikaragua',
      se: 'Nicaragua',
      pl: 'Nikaragua',
      no: 'Nicaragua',
      ja: 'ニカラグア',
      it: 'Nicaragua',
      zh: '尼加拉瓜',
      nl: 'Nicaragua',
      de: 'Nicaragua',
      fr: 'Nicaragua',
      es: 'Nicaragua',
      en: 'Nicaragua',
      pt_BR: 'Nicarágua',
      'sr-Cyrl': 'Никарагва',
      'sr-Latn': 'Nikaragva',
      zh_TW: '尼加拉瓜',
      tr: 'Nikaragua',
      ro: 'Nicaragua',
      ar: 'نيكاراغوا',
      fa: 'نیکاراگوئه',
      yue: '尼加拉瓜',
    },
  },
  {
    num_code: '562',
    alpha_2_code: 'NE',
    alpha_3_code: 'NER',
    en_short_name: 'Niger',
    nationality: 'Nigerien',
    dial_code: '+227',
    nameTranslations: {
      sk: 'Niger',
      se: 'Niger',
      pl: 'Niger',
      no: 'Niger',
      ja: 'ニジェール',
      it: 'Niger',
      zh: '尼日尔',
      nl: 'Niger',
      de: 'Niger',
      fr: 'Niger',
      es: 'Níger',
      en: 'Niger',
      pt_BR: 'Níger',
      'sr-Cyrl': 'Нигер',
      'sr-Latn': 'Niger',
      zh_TW: '尼日爾',
      tr: 'Nijer',
      ro: 'Niger',
      ar: 'النيجر',
      fa: 'نیجر',
      yue: '尼日爾',
    },
  },
  {
    num_code: '566',
    alpha_2_code: 'NG',
    alpha_3_code: 'NGA',
    en_short_name: 'Nigeria',
    nationality: 'Nigerian',
    dial_code: '+234',
    nameTranslations: {
      sk: 'Nigéria',
      se: 'Nigeria',
      pl: 'Nigeria',
      no: 'Nigeria',
      ja: 'ナイジェリア',
      it: 'Nigeria',
      zh: '尼日利亚',
      nl: 'Nigeria',
      de: 'Nigeria',
      fr: 'Nigéria',
      es: 'Nigeria',
      en: 'Nigeria',
      pt_BR: 'Nigéria',
      'sr-Cyrl': 'Нигерија',
      'sr-Latn': 'Nigerija',
      zh_TW: '奈及利亞',
      tr: 'Nijerya',
      ro: 'Nigeria',
      ar: 'نيجيريا',
      fa: 'نیجریه',
      yue: '尼日利亞',
    },
  },
  {
    num_code: '570',
    alpha_2_code: 'NU',
    alpha_3_code: 'NIU',
    en_short_name: 'Niue',
    nationality: 'Niuean',
    dial_code: '+683',
    nameTranslations: {
      sk: 'Niue',
      se: 'Niue',
      pl: 'Niue',
      no: 'Niue',
      ja: 'ニウエ',
      it: 'Niue',
      zh: '纽埃',
      nl: 'Niue',
      de: 'Niue',
      fr: 'Niue',
      es: 'Niue',
      en: 'Niue',
      pt_BR: 'Niue',
      'sr-Cyrl': 'Нијуе',
      'sr-Latn': 'Nijue',
      zh_TW: '紐埃',
      tr: 'Niue',
      ro: 'Niue',
      ar: 'نييوي',
      fa: 'نیووی',
      yue: '紐埃',
    },
  },
  {
    num_code: '574',
    alpha_2_code: 'NF',
    alpha_3_code: 'NFK',
    en_short_name: 'Norfolk Island',
    nationality: 'Norfolk Island',
    dial_code: '+672',
    nameTranslations: {
      sk: 'Norfolk',
      se: 'Norfolksullot',
      pl: 'Norfolk',
      no: 'Norfolkøya',
      ja: 'ノーフォーク島',
      it: 'Isola Norfolk',
      zh: '诺福克岛',
      nl: 'Norfolk',
      de: 'Norfolkinsel',
      fr: 'Île Norfolk',
      es: 'Isla Norfolk',
      en: 'Norfolk Island',
      pt_BR: 'Ilha Norfolk',
      'sr-Cyrl': 'Острво Норфок',
      'sr-Latn': 'Ostrvo Norfok',
      zh_TW: '諾福克島',
      tr: 'Norfolk Adası',
      ro: 'Insulele Norfolk',
      ar: 'جزيرة نورفولك',
      fa: 'جزیره نورفک',
      yue: '诺福克岛',
    },
  },
  {
    num_code: '580',
    alpha_2_code: 'MP',
    alpha_3_code: 'MNP',
    en_short_name: 'Northern Mariana Islands',
    nationality: 'Northern Marianan',
    dial_code: '+1670',
    nameTranslations: {
      sk: 'Severné Mariány',
      se: 'Davvi-Mariánat',
      pl: 'Mariany Północne',
      no: 'Nord-Marianene',
      ja: '北マリアナ諸島',
      it: 'Isole Marianne settentrionali',
      zh: '北马里亚纳群岛',
      nl: 'Noordelijke Marianen',
      de: 'Nördliche Marianen',
      fr: 'Îles Mariannes du Nord',
      es: 'Islas Marianas del Norte',
      en: 'Northern Mariana Islands',
      pt_BR: 'Ilhas Marianas do Norte',
      'sr-Cyrl': 'Северна Маријанска Острва',
      'sr-Latn': 'Severna Marijanska Ostrva',
      zh_TW: '北馬利安納群島',
      tr: 'Kuzey Mariana Adaları',
      ro: 'Insulelor Mariane de Nord',
      ar: 'جزر ماريانا الشمالية',
      fa: 'جزایر ماریانای شمالی',
      yue: '北馬里亞納群島',
    },
  },
  {
    num_code: '578',
    alpha_2_code: 'NO',
    alpha_3_code: 'NOR',
    en_short_name: 'Norway',
    nationality: 'Norwegian',
    dial_code: '+47',
    nameTranslations: {
      sk: 'Nórsko',
      se: 'Norga',
      pl: 'Norwegia',
      no: 'Norge',
      ja: 'ノルウェー',
      it: 'Norvegia',
      zh: '挪威',
      nl: 'Noorwegen',
      de: 'Norwegen',
      fr: 'Norvège',
      es: 'Noruega',
      en: 'Norway',
      pt_BR: 'Noruega',
      'sr-Cyrl': 'Норвешка',
      'sr-Latn': 'Norveška',
      zh_TW: '挪威',
      tr: 'Norveç',
      ro: 'Norvegia',
      ar: 'النرويج',
      fa: 'نروژ',
      yue: '挪威',
    },
  },
  {
    num_code: '512',
    alpha_2_code: 'OM',
    alpha_3_code: 'OMN',
    en_short_name: 'Oman',
    nationality: 'Omani',
    dial_code: '+968',
    nameTranslations: {
      sk: 'Omán',
      se: 'Oman',
      pl: 'Oman',
      no: 'Oman',
      ja: 'オマーン',
      it: 'Oman',
      zh: '阿曼',
      nl: 'Oman',
      de: 'Oman',
      fr: 'Oman',
      es: 'Omán',
      en: 'Oman',
      pt_BR: 'Omã',
      'sr-Cyrl': 'Оман',
      'sr-Latn': 'Oman',
      zh_TW: '阿曼',
      tr: 'Umman',
      ro: 'Oman',
      ar: 'عمان',
      fa: 'عمان',
      yue: '阿曼',
    },
  },
  {
    num_code: '586',
    alpha_2_code: 'PK',
    alpha_3_code: 'PAK',
    en_short_name: 'Pakistan',
    nationality: 'Pakistani',
    dial_code: '+92',
    nameTranslations: {
      sk: 'Pakistan',
      se: 'Pakistan',
      pl: 'Pakistan',
      no: 'Pakistan',
      ja: 'パキスタン',
      it: 'Pakistan',
      zh: '巴基斯坦',
      nl: 'Pakistan',
      de: 'Pakistan',
      fr: 'Pakistan',
      es: 'Pakistán',
      en: 'Pakistan',
      pt_BR: 'Paquistão',
      'sr-Cyrl': 'Пакистан',
      'sr-Latn': 'Pakistan',
      zh_TW: '巴基斯坦',
      tr: 'Pakistan',
      ro: 'Pakistan',
      ar: 'باكستان',
      fa: 'پاکستان',
      yue: '巴基斯坦',
    },
  },
  {
    num_code: '585',
    alpha_2_code: 'PW',
    alpha_3_code: 'PLW',
    en_short_name: 'Palau',
    nationality: 'Palauan',
    dial_code: '+680',
    nameTranslations: {
      sk: 'Palau',
      se: 'Palau',
      pl: 'Palau',
      no: 'Palau',
      ja: 'パラオ',
      it: 'Palau',
      zh: '帕劳',
      nl: 'Palau',
      de: 'Palau',
      fr: 'Palaos',
      es: 'Palaos',
      en: 'Palau',
      pt_BR: 'Palau',
      'sr-Cyrl': 'Палау',
      'sr-Latn': 'Palau',
      zh_TW: '帛琉',
      tr: 'Palau',
      ro: 'Palau',
      ar: 'بالاو',
      fa: 'پالائو',
      yue: '帕劳',
    },
  },
  {
    num_code: '275',
    alpha_2_code: 'PS',
    alpha_3_code: 'PSE',
    en_short_name: 'Palestinian Territories',
    nationality: 'Palestinian',
    dial_code: '+970',
    nameTranslations: {
      sk: 'Palestínske územia',
      se: 'Palestina',
      pl: 'Terytoria Palestyńskie',
      no: 'Det palestinske området',
      ja: 'パレスチナ自治区',
      it: 'Territori palestinesi',
      zh: '巴勒斯坦领土',
      nl: 'Palestijnse gebieden',
      de: 'Palästinensische Autonomiegebiete',
      fr: 'Territoires palestiniens',
      es: 'Territorios Palestinos',
      en: 'Palestinian Territories',
      pt_BR: 'Territórios Palestinos',
      'sr-Cyrl': 'Палестина',
      'sr-Latn': 'Palestina',
      zh_TW: '巴勒斯坦',
      tr: 'Filistin',
      ro: 'Palestina',
      ar: 'فلسطين',
      fa: 'فلسطین',
      yue: '巴勒斯坦，国',
    },
  },
  {
    num_code: '591',
    alpha_2_code: 'PA',
    alpha_3_code: 'PAN',
    en_short_name: 'Panama',
    nationality: 'Panamanian',
    dial_code: '+507',
    nameTranslations: {
      sk: 'Panama',
      se: 'Panama',
      pl: 'Panama',
      no: 'Panama',
      ja: 'パナマ',
      it: 'Panamá',
      zh: '巴拿马',
      nl: 'Panama',
      de: 'Panama',
      fr: 'Panama',
      es: 'Panamá',
      en: 'Panama',
      pt_BR: 'Panamá',
      'sr-Cyrl': 'Панама',
      'sr-Latn': 'Panama',
      zh_TW: '巴拿馬',
      tr: 'Panama',
      ro: 'Panama',
      ar: 'بنما',
      fa: 'پاناما',
      yue: '巴拿馬',
    },
  },
  {
    num_code: '598',
    alpha_2_code: 'PG',
    alpha_3_code: 'PNG',
    en_short_name: 'Papua New Guinea',
    nationality: 'Papua New Guinean, Papuan',
    dial_code: '+675',
    nameTranslations: {
      sk: 'Papua-Nová Guinea',
      se: 'Papua-Ođđa-Guinea',
      pl: 'Papua-Nowa Gwinea',
      no: 'Papua Ny-Guinea',
      ja: 'パプアニューギニア',
      it: 'Papua Nuova Guinea',
      zh: '巴布亚新几内亚',
      nl: 'Papoea-Nieuw-Guinea',
      de: 'Papua-Neuguinea',
      fr: 'Papouasie-Nouvelle-Guinée',
      es: 'Papúa Nueva Guinea',
      en: 'Papua New Guinea',
      pt_BR: 'Papua Nova Guiné',
      'sr-Cyrl': 'Папуа Нова Гвинеја',
      'sr-Latn': 'Papua Nova Gvineja',
      zh_TW: '巴布亞新幾內亞',
      tr: 'Papua Yeni Gine',
      ro: 'Papua Noua Guinee',
      ar: 'بابوا غينيا الجديدة',
      fa: 'پاپوآ گینه نو',
      yue: '巴布亚新几内亚',
    },
  },
  {
    num_code: '600',
    alpha_2_code: 'PY',
    alpha_3_code: 'PRY',
    en_short_name: 'Paraguay',
    nationality: 'Paraguayan',
    dial_code: '+595',
    nameTranslations: {
      sk: 'Paraguaj',
      se: 'Paraguay',
      pl: 'Paragwaj',
      no: 'Paraguay',
      ja: 'パラグアイ',
      it: 'Paraguay',
      zh: '巴拉圭',
      nl: 'Paraguay',
      de: 'Paraguay',
      fr: 'Paraguay',
      es: 'Paraguay',
      en: 'Paraguay',
      pt_BR: 'Paraguai',
      'sr-Cyrl': 'Парагвај',
      'sr-Latn': 'Paragvaj',
      zh_TW: '巴拉圭',
      tr: 'Paraguay',
      ro: 'Paraguay',
      ar: 'باراغواي',
      fa: 'پاراگوئه',
      yue: '巴拉圭',
    },
  },
  {
    num_code: '604',
    alpha_2_code: 'PE',
    alpha_3_code: 'PER',
    en_short_name: 'Peru',
    nationality: 'Peruvian',
    dial_code: '+51',
    nameTranslations: {
      sk: 'Peru',
      se: 'Peru',
      pl: 'Peru',
      no: 'Peru',
      ja: 'ペルー',
      it: 'Perù',
      zh: '秘鲁',
      nl: 'Peru',
      de: 'Peru',
      fr: 'Pérou',
      es: 'Perú',
      en: 'Peru',
      pt_BR: 'Peru',
      'sr-Cyrl': 'Перу',
      'sr-Latn': 'Peru',
      zh_TW: '秘鲁',
      tr: 'Peru',
      ro: 'Peru',
      ar: 'بيرو',
      fa: 'پرو',
      yue: '秘魯',
    },
  },
  {
    num_code: '608',
    alpha_2_code: 'PH',
    alpha_3_code: 'PHL',
    en_short_name: 'Philippines',
    nationality: 'Philippine, Filipino',
    dial_code: '+63',
    nameTranslations: {
      sk: 'Filipíny',
      se: 'Filippiinnat',
      pl: 'Filipiny',
      no: 'Filippinene',
      ja: 'フィリピン',
      it: 'Filippine',
      zh: '菲律宾',
      nl: 'Filipijnen',
      de: 'Philippinen',
      fr: 'Philippines',
      es: 'Filipinas',
      en: 'Philippines',
      pt_BR: 'Filipinas',
      'sr-Cyrl': 'Филипини',
      'sr-Latn': 'Filipini',
      zh_TW: '菲律賓',
      tr: 'Filipinler',
      ro: 'Filipine',
      ar: 'الفلبين',
      fa: 'فیلیپین',
      yue: '菲律賓',
    },
  },
  {
    num_code: '612',
    alpha_2_code: 'PN',
    alpha_3_code: 'PCN',
    en_short_name: 'Pitcairn Islands',
    nationality: 'Pitcairn Island',
    dial_code: '+64',
    nameTranslations: {
      sk: 'Pitcairnove ostrovy',
      se: 'Pitcairn',
      pl: 'Pitcairn',
      no: 'Pitcairnøyene',
      ja: 'ピトケアン諸島',
      it: 'Isole Pitcairn',
      zh: '皮特凯恩群岛',
      nl: 'Pitcairneilanden',
      de: 'Pitcairninseln',
      fr: 'Îles Pitcairn',
      es: 'Islas Pitcairn',
      en: 'Pitcairn Islands',
      pt_BR: 'Ilhas Pitcairn',
      'sr-Cyrl': 'Острва Питкерн',
      'sr-Latn': 'Ostrva Pitkern',
      zh_TW: '皮特肯群島',
      tr: 'Pitcairn Adaları',
      ro: 'Insulele Pitcairn',
      ar: 'جزر بيتكيرن',
      fa: 'جزایر پیت‌کرن',
      yue: '皮特凱恩',
    },
  },
  {
    num_code: '616',
    alpha_2_code: 'PL',
    alpha_3_code: 'POL',
    en_short_name: 'Poland',
    nationality: 'Polish',
    dial_code: '+48',
    nameTranslations: {
      sk: 'Poľsko',
      se: 'Polen',
      pl: 'Polska',
      no: 'Polen',
      ja: 'ポーランド',
      it: 'Polonia',
      zh: '波兰',
      nl: 'Polen',
      de: 'Polen',
      fr: 'Pologne',
      es: 'Polonia',
      en: 'Poland',
      pt_BR: 'Polônia',
      'sr-Cyrl': 'Пољска',
      'sr-Latn': 'Poljska',
      zh_TW: '波蘭',
      tr: 'Polonya',
      ro: 'Polonia',
      ar: 'بولندا',
      fa: 'لهستان',
      yue: '波蘭',
    },
  },
  {
    num_code: '620',
    alpha_2_code: 'PT',
    alpha_3_code: 'PRT',
    en_short_name: 'Portugal',
    nationality: 'Portuguese',
    dial_code: '+351',
    nameTranslations: {
      sk: 'Portugalsko',
      se: 'Portugála',
      pl: 'Portugalia',
      no: 'Portugal',
      ja: 'ポルトガル',
      it: 'Portogallo',
      zh: '葡萄牙',
      nl: 'Portugal',
      de: 'Portugal',
      fr: 'Portugal',
      es: 'Portugal',
      en: 'Portugal',
      pt_BR: 'Portugal',
      'sr-Cyrl': 'Португалија',
      'sr-Latn': 'Portugalija',
      zh_TW: '葡萄牙',
      tr: 'Portekiz',
      ro: 'Portugalia',
      ar: 'البرتغال',
      fa: 'پرتغال',
      yue: '葡萄牙',
    },
  },
  {
    num_code: '630',
    alpha_2_code: 'PR',
    alpha_3_code: 'PRI',
    en_short_name: 'Puerto Rico',
    nationality: 'Puerto Rican',
    dial_code: '+1939',
    nameTranslations: {
      sk: 'Portoriko',
      se: 'Puerto Rico',
      pl: 'Portoryko',
      no: 'Puerto Rico',
      ja: 'プエルトリコ',
      it: 'Portorico',
      zh: '波多黎各',
      nl: 'Puerto Rico',
      de: 'Puerto Rico',
      fr: 'Porto Rico',
      es: 'Puerto Rico',
      en: 'Puerto Rico',
      pt_BR: 'Porto Rico',
      'sr-Cyrl': 'Порто Рико',
      'sr-Latn': 'Porto Riko',
      zh_TW: '波多黎各',
      tr: 'Porto Riko',
      ro: 'Puerto Rico',
      ar: 'بورتوريكو',
      fa: 'پورتوریکو',
      yue: '波多黎各',
    },
  },
  {
    num_code: '634',
    alpha_2_code: 'QA',
    alpha_3_code: 'QAT',
    en_short_name: 'Qatar',
    nationality: 'Qatari',
    dial_code: '+974',
    nameTranslations: {
      sk: 'Katar',
      se: 'Qatar',
      pl: 'Katar',
      no: 'Qatar',
      ja: 'カタール',
      it: 'Qatar',
      zh: '卡塔尔',
      nl: 'Qatar',
      de: 'Katar',
      fr: 'Qatar',
      es: 'Catar',
      en: 'Qatar',
      pt_BR: 'Catar',
      'sr-Cyrl': 'Катар',
      'sr-Latn': 'Katar',
      zh_TW: '卡達',
      tr: 'Katar',
      ro: 'Qatar',
      ar: 'قطر',
      fa: 'قطر',
      yue: '卡塔爾',
    },
  },
  {
    num_code: '638',
    alpha_2_code: 'RE',
    alpha_3_code: 'REU',
    en_short_name: 'Réunion',
    nationality: 'Réunionese, Réunionnais',
    dial_code: '+262',
    nameTranslations: {
      sk: 'Réunion',
      se: 'Réunion',
      pl: 'Reunion',
      no: 'Réunion',
      ja: 'レユニオン',
      it: 'Riunione',
      zh: '留尼汪',
      nl: 'Réunion',
      de: 'Réunion',
      fr: 'La Réunion',
      es: 'Reunión',
      en: 'Réunion',
      pt_BR: 'Reunião',
      'sr-Cyrl': 'Реинион',
      'sr-Latn': 'Reinion',
      zh_TW: '留尼旺',
      tr: 'La Réunion',
      ro: 'La Réunion',
      ar: 'لا ريونيون',
      fa: 'رئونیون',
      yue: '留尼汪',
    },
  },
  {
    num_code: '642',
    alpha_2_code: 'RO',
    alpha_3_code: 'ROU',
    en_short_name: 'Romania',
    nationality: 'Romanian',
    dial_code: '+40',
    nameTranslations: {
      sk: 'Rumunsko',
      se: 'Románia',
      pl: 'Rumunia',
      no: 'Romania',
      ja: 'ルーマニア',
      it: 'Romania',
      zh: '罗马尼亚',
      nl: 'Roemenië',
      de: 'Rumänien',
      fr: 'Roumanie',
      es: 'Rumanía',
      en: 'Romania',
      pt_BR: 'Romênia',
      'sr-Cyrl': 'Румунија',
      'sr-Latn': 'Rumunija',
      zh_TW: '羅馬尼亞',
      tr: 'Romanya',
      ro: 'România',
      ar: 'رومانيا',
      fa: 'رومانی',
      yue: '羅馬尼亞',
    },
  },
  {
    num_code: '643',
    alpha_2_code: 'RU',
    alpha_3_code: 'RUS',
    en_short_name: 'Russia',
    nationality: 'Russian',
    dial_code: '+7',
    nameTranslations: {
      sk: 'Rusko',
      se: 'Ruošša',
      pl: 'Rosja',
      no: 'Russland',
      ja: 'ロシア',
      it: 'Russia',
      zh: '俄罗斯',
      nl: 'Rusland',
      de: 'Russland',
      fr: 'Russie',
      es: 'Rusia',
      en: 'Russia',
      pt_BR: 'Rússia',
      'sr-Cyrl': 'Русија',
      'sr-Latn': 'Rusija',
      zh_TW: '俄羅斯',
      tr: 'Rusya',
      ro: 'Rusia',
      ar: 'روسيا',
      fa: 'روسیه',
      yue: '俄儸斯聯邦',
    },
  },
  {
    num_code: '646',
    alpha_2_code: 'RW',
    alpha_3_code: 'RWA',
    en_short_name: 'Rwanda',
    nationality: 'Rwandan',
    dial_code: '+250',
    nameTranslations: {
      sk: 'Rwanda',
      se: 'Rwanda',
      pl: 'Rwanda',
      no: 'Rwanda',
      ja: 'ルワンダ',
      it: 'Ruanda',
      zh: '卢旺达',
      nl: 'Rwanda',
      de: 'Ruanda',
      fr: 'Rwanda',
      es: 'Ruanda',
      en: 'Rwanda',
      pt_BR: 'Ruanda',
      'sr-Cyrl': 'Руанда',
      'sr-Latn': 'Ruanda',
      zh_TW: '盧安達',
      tr: 'Ruanda',
      ro: 'Rwanda',
      ar: 'رواندا',
      fa: 'رواندا',
      yue: '盧旺達',
    },
  },
  {
    num_code: '652',
    alpha_2_code: 'BL',
    alpha_3_code: 'BLM',
    en_short_name: 'St. Barthélemy',
    nationality: 'Barthélemois',
    dial_code: '+590',
    nameTranslations: {
      sk: 'Svätý Bartolomej',
      se: 'Saint Barthélemy',
      pl: 'Saint-Barthélemy',
      no: 'Saint-Barthélemy',
      ja: 'サン・バルテルミー',
      it: 'Saint-Barthélemy',
      zh: '圣巴泰勒米',
      nl: 'Saint-Barthélemy',
      de: 'St. Barthélemy',
      fr: 'Saint-Barthélemy',
      es: 'San Bartolomé',
      en: 'St. Barthélemy',
      pt_BR: 'São Bartolomeu',
      'sr-Cyrl': 'Сент Бартелеми',
      'sr-Latn': 'Sent Bartelemi',
      zh_TW: '聖巴瑟米',
      tr: 'Saint Barthélemy',
      ro: 'Saint Barthélemy',
      ar: 'سان بارتيلمي',
      fa: 'سن بارتلمی',
      yue: '聖巴泰勒米',
    },
  },
  {
    num_code: '654',
    alpha_2_code: 'SH',
    alpha_3_code: 'SHN',
    en_short_name: 'St. Helena',
    nationality: 'Saint Helenian',
    dial_code: '+290',
    nameTranslations: {
      sk: 'Svätá Helena',
      se: 'Saint Helena',
      pl: 'Wyspa Świętej Heleny',
      no: 'St. Helena',
      ja: 'セントヘレナ',
      it: "Sant'Elena",
      zh: '圣赫勒拿',
      nl: 'Sint-Helena',
      de: 'St. Helena',
      fr: 'Sainte-Hélène',
      es: 'Santa Elena',
      en: 'St. Helena',
      pt_BR: 'Santa Helena',
      'sr-Cyrl': 'Света Јелена, Асенсион и Тристан да Куња',
      'sr-Latn': 'Sveta Jelena, Asension i Tristan de Kunja',
      zh_TW: '聖凱倫拿島',
      tr: 'Saint Helena',
      ro: 'Sfânta Elena',
      ar: 'سانت هيلانة وأسينشين وتريستان دا كونا',
      fa: 'سنت هلن',
      yue: '圣赫勒拿、阿森松同特里斯坦·达库尼亚',
    },
  },
  {
    num_code: '659',
    alpha_2_code: 'KN',
    alpha_3_code: 'KNA',
    en_short_name: 'St. Kitts & Nevis',
    nationality: 'Kittitian or Nevisian',
    dial_code: '+1869',
    nameTranslations: {
      sk: 'Svätý Krištof a Nevis',
      se: 'Saint Kitts ja Nevis',
      pl: 'Saint Kitts i Nevis',
      no: 'Saint Kitts og Nevis',
      ja: 'セントクリストファー・ネーヴィス',
      it: 'Saint Kitts e Nevis',
      zh: '圣基茨和尼维斯',
      nl: 'Saint Kitts en Nevis',
      de: 'St. Kitts und Nevis',
      fr: 'Saint-Christophe-et-Niévès',
      es: 'San Cristóbal y Nieves',
      en: 'St. Kitts & Nevis',
      pt_BR: 'São Cristóvão e Nevis',
      'sr-Cyrl': 'Сент Китс и Невис',
      'sr-Latn': 'Sent Kits i Nevis',
      zh_TW: '聖克里斯多福及尼維斯',
      tr: 'Saint Kitts ve Nevis',
      ro: 'Sfântul Kitts și Nevis',
      ar: 'سانت كيتس ونيفيس',
      fa: 'سنت کیتس و نویس',
      yue: '圣基茨同尼维斯',
    },
  },
  {
    num_code: '662',
    alpha_2_code: 'LC',
    alpha_3_code: 'LCA',
    en_short_name: 'St. Lucia',
    nationality: 'Saint Lucian',
    dial_code: '+1758',
    nameTranslations: {
      sk: 'Svätá Lucia',
      se: 'Saint Lucia',
      pl: 'Saint Lucia',
      no: 'St. Lucia',
      ja: 'セントルシア',
      it: 'Saint Lucia',
      zh: '圣卢西亚',
      nl: 'Saint Lucia',
      de: 'St. Lucia',
      fr: 'Sainte-Lucie',
      es: 'Santa Lucía',
      en: 'St. Lucia',
      pt_BR: 'Santa Lúcia',
      'sr-Cyrl': 'Света Луција',
      'sr-Latn': 'Sveta Lucija',
      zh_TW: '聖露西亞',
      tr: 'Saint Lucia',
      ro: 'Sfânta Elena',
      ar: 'سانت لوسيا',
      fa: 'سنت لوسیا',
      yue: '聖盧西亞',
    },
  },
  {
    num_code: '663',
    alpha_2_code: 'MF',
    alpha_3_code: 'MAF',
    en_short_name: 'St. Martin',
    nationality: 'Saint-Martinoise',
    dial_code: '+590',
    nameTranslations: {
      sk: 'Svätý Martin (fr.)',
      se: 'Frankriikka Saint Martin',
      pl: 'Saint-Martin',
      no: 'Saint-Martin',
      ja: 'サン・マルタン',
      it: 'Saint Martin',
      zh: '法属圣马丁',
      nl: 'Saint-Martin',
      de: 'St. Martin',
      fr: 'Saint-Martin',
      es: 'San Martín',
      en: 'St. Martin',
      pt_BR: 'São Martinho',
      'sr-Cyrl': 'Свети Мартин',
      'sr-Latn': 'Sveti Martin',
      zh_TW: '聖馬丁',
      tr: 'Saint Martin',
      ro: 'Sfântul Martin',
      ar: 'تجمع سان مارتين',
      fa: 'سن مارتن',
      yue: '聖馬丁（法國部分）',
    },
  },
  {
    num_code: '666',
    alpha_2_code: 'PM',
    alpha_3_code: 'SPM',
    en_short_name: 'St. Pierre & Miquelon',
    nationality: 'Saint-Pierrais or Miquelonnais',
    dial_code: '+508',
    nameTranslations: {
      sk: 'Saint Pierre a Miquelon',
      se: 'Saint Pierre ja Miquelon',
      pl: 'Saint-Pierre i Miquelon',
      no: 'Saint-Pierre-et-Miquelon',
      ja: 'サンピエール島・ミクロン島',
      it: 'Saint-Pierre e Miquelon',
      zh: '圣皮埃尔和密克隆群岛',
      nl: 'Saint-Pierre en Miquelon',
      de: 'St. Pierre und Miquelon',
      fr: 'Saint-Pierre-et-Miquelon',
      es: 'San Pedro y Miquelón',
      en: 'St. Pierre & Miquelon',
      pt_BR: 'São Pedro e Miquelon',
      'sr-Cyrl': 'Сен Пјер и Микелон',
      'sr-Latn': 'Sen Pjer i Mikelon',
      zh_TW: '聖皮埃與密克隆群島',
      tr: 'Saint Pierre ve Miquelon',
      ro: 'Saint Pierre și Miquelon',
      ar: 'سان بيير وميكلون',
      fa: 'سن-پیر و میکلون',
      yue: '聖皮埃尔同米克隆',
    },
  },
  {
    num_code: '670',
    alpha_2_code: 'VC',
    alpha_3_code: 'VCT',
    en_short_name: 'St. Vincent & Grenadines',
    nationality: 'Saint Vincentian, Vincentian',
    dial_code: '+1784',
    nameTranslations: {
      sk: 'Svätý Vincent a Grenadíny',
      se: 'Saint Vincent ja Grenadine',
      pl: 'Saint Vincent i Grenadyny',
      no: 'St. Vincent og Grenadinene',
      ja: 'セントビンセント及びグレナディーン諸島',
      it: 'Saint Vincent e Grenadine',
      zh: '圣文森特和格林纳丁斯',
      nl: 'Saint Vincent en de Grenadines',
      de: 'St. Vincent und die Grenadinen',
      fr: 'Saint-Vincent-et-les-Grenadines',
      es: 'San Vicente y las Granadinas',
      en: 'St. Vincent & Grenadines',
      pt_BR: 'São Vicente e Granadinas',
      'sr-Cyrl': 'Свети Винсент и Гренадини',
      'sr-Latn': 'Sveti Vinsent i Grenadini',
      zh_TW: '聖文森及格瑞那丁',
      tr: 'Saint Vincent ve Grenadinler',
      ro: 'Sfântul Vincențiu și Grenadinele',
      ar: 'سانت فينسنت والغرينادين',
      fa: 'سنت وینسنت و گرنادین‌ها',
      yue: '聖文森特同格林纳丁斯',
    },
  },
  {
    num_code: '882',
    alpha_2_code: 'WS',
    alpha_3_code: 'WSM',
    en_short_name: 'Samoa',
    nationality: 'Samoan',
    dial_code: '+685',
    nameTranslations: {
      sk: 'Samoa',
      se: 'Samoa',
      pl: 'Samoa',
      no: 'Samoa',
      ja: 'サモア',
      it: 'Samoa',
      zh: '萨摩亚',
      nl: 'Samoa',
      de: 'Samoa',
      fr: 'Samoa',
      es: 'Samoa',
      en: 'Samoa',
      pt_BR: 'Samoa',
      'sr-Cyrl': 'Самоа',
      'sr-Latn': 'Samoa',
      zh_TW: '薩摩亞',
      tr: 'Samoa',
      ro: 'Samoa',
      ar: 'ساموا',
      fa: 'ساموآ',
      yue: '薩摩亞',
    },
  },
  {
    num_code: '674',
    alpha_2_code: 'SM',
    alpha_3_code: 'SMR',
    en_short_name: 'San Marino',
    nationality: 'Sammarinese',
    dial_code: '+378',
    nameTranslations: {
      sk: 'San Maríno',
      se: 'San Marino',
      pl: 'San Marino',
      no: 'San Marino',
      ja: 'サンマリノ',
      it: 'San Marino',
      zh: '圣马力诺',
      nl: 'San Marino',
      de: 'San Marino',
      fr: 'Saint-Marin',
      es: 'San Marino',
      en: 'San Marino',
      pt_BR: 'San Marino',
      'sr-Cyrl': 'Сан Марино',
      'sr-Latn': 'San Marino',
      zh_TW: '聖馬利諾',
      tr: 'San Marino',
      ro: 'San Marino',
      ar: 'سان مارينو',
      fa: 'سان مارینو',
      yue: '聖馬力諾',
    },
  },
  {
    num_code: '678',
    alpha_2_code: 'ST',
    alpha_3_code: 'STP',
    en_short_name: 'São Tomé & Príncipe',
    nationality: 'São Toméan',
    dial_code: '+239',
    nameTranslations: {
      sk: 'Svätý Tomáš a Princov ostrov',
      se: 'São Tomé ja Príncipe',
      pl: 'Wyspy Świętego Tomasza i Książęca',
      no: 'São Tomé og Príncipe',
      ja: 'サントメ・プリンシペ',
      it: 'São Tomé e Príncipe',
      zh: '圣多美和普林西比',
      nl: 'Sao Tomé en Principe',
      de: 'São Tomé und Príncipe',
      fr: 'Sao Tomé-et-Principe',
      es: 'Santo Tomé y Príncipe',
      en: 'São Tomé & Príncipe',
      pt_BR: 'São Tomé e Príncipe',
      'sr-Cyrl': 'Сао Томе и Принсипе',
      'sr-Latn': 'Sao Tome i Prinsipe',
      zh_TW: '聖多美普林西比',
      tr: 'São Tomé ve Príncipe',
      ro: 'Sao Tome şi Principe',
      ar: 'ساو تومي وبرينسيب',
      fa: 'سائوتومه و پرنسیپ',
      yue: '聖多美和普林西比',
    },
  },
  {
    num_code: '682',
    alpha_2_code: 'SA',
    alpha_3_code: 'SAU',
    en_short_name: 'Saudi Arabia',
    nationality: 'Saudi, Saudi Arabian',
    dial_code: '+966',
    nameTranslations: {
      sk: 'Saudská Arábia',
      se: 'Saudi-Arábia',
      pl: 'Arabia Saudyjska',
      no: 'Saudi-Arabia',
      ja: 'サウジアラビア',
      it: 'Arabia Saudita',
      zh: '沙特阿拉伯',
      nl: 'Saoedi-Arabië',
      de: 'Saudi-Arabien',
      fr: 'Arabie saoudite',
      es: 'Arabia Saudí',
      en: 'Saudi Arabia',
      pt_BR: 'Arábia Saudita',
      'sr-Cyrl': 'Саудијска Арабија',
      'sr-Latn': 'Saudijska Arabija',
      zh_TW: '沙烏地阿拉',
      tr: 'Suudi Arabistan',
      ro: 'Arabia Saudită',
      ar: 'السعودية',
      fa: 'عربستان سعودی',
      yue: '沙地阿拉伯',
    },
  },
  {
    num_code: '686',
    alpha_2_code: 'SN',
    alpha_3_code: 'SEN',
    en_short_name: 'Senegal',
    nationality: 'Senegalese',
    dial_code: '+221',
    nameTranslations: {
      sk: 'Senegal',
      se: 'Senegal',
      pl: 'Senegal',
      no: 'Senegal',
      ja: 'セネガル',
      it: 'Senegal',
      zh: '塞内加尔',
      nl: 'Senegal',
      de: 'Senegal',
      fr: 'Sénégal',
      es: 'Senegal',
      en: 'Senegal',
      pt_BR: 'Senegal',
      'sr-Cyrl': 'Сенегал',
      'sr-Latn': 'Senegal',
      zh_TW: '塞內加爾',
      tr: 'Senegal',
      ro: 'Senegal',
      ar: 'السنغال',
      fa: 'سنگال',
      yue: '塞內加爾',
    },
  },
  {
    num_code: '688',
    alpha_2_code: 'RS',
    alpha_3_code: 'SRB',
    en_short_name: 'Serbia',
    nationality: 'Serbian',
    dial_code: '+381',
    nameTranslations: {
      sk: 'Srbsko',
      se: 'Serbia',
      pl: 'Serbia',
      no: 'Serbia',
      ja: 'セルビア',
      it: 'Serbia',
      zh: '塞尔维亚',
      nl: 'Servië',
      de: 'Serbien',
      fr: 'Serbie',
      es: 'Serbia',
      en: 'Serbia',
      pt_BR: 'Sérvia',
      'sr-Cyrl': 'Србија',
      'sr-Latn': 'Srbija',
      zh_TW: '塞爾維亞',
      tr: 'Sırbistan',
      ro: 'Serbia',
      ar: 'صربيا',
      fa: 'صربستان',
      yue: '塞爾維亞',
    },
  },
  {
    num_code: '690',
    alpha_2_code: 'SC',
    alpha_3_code: 'SYC',
    en_short_name: 'Seychelles',
    nationality: 'Seychellois',
    dial_code: '+248',
    nameTranslations: {
      sk: 'Seychely',
      se: 'Seychellsullot',
      pl: 'Seszele',
      no: 'Seychellene',
      ja: 'セーシェル',
      it: 'Seychelles',
      zh: '塞舌尔',
      nl: 'Seychellen',
      de: 'Seychellen',
      fr: 'Seychelles',
      es: 'Seychelles',
      en: 'Seychelles',
      pt_BR: 'Seychelles',
      'sr-Cyrl': 'Сејшели',
      'sr-Latn': 'Sejšeli',
      zh_TW: '塞席爾',
      tr: 'Seyşeller',
      ro: 'Seychelles',
      ar: 'سيشل',
      fa: 'سیشل',
      yue: '塞舌爾',
    },
  },
  {
    num_code: '694',
    alpha_2_code: 'SL',
    alpha_3_code: 'SLE',
    en_short_name: 'Sierra Leone',
    nationality: 'Sierra Leonean',
    dial_code: '+232',
    nameTranslations: {
      sk: 'Sierra Leone',
      se: 'Sierra Leone',
      pl: 'Sierra Leone',
      no: 'Sierra Leone',
      ja: 'シエラレオネ',
      it: 'Sierra Leone',
      zh: '塞拉利昂',
      nl: 'Sierra Leone',
      de: 'Sierra Leone',
      fr: 'Sierra Leone',
      es: 'Sierra Leona',
      en: 'Sierra Leone',
      pt_BR: 'Serra Leoa',
      'sr-Cyrl': 'Сијера Леоне',
      'sr-Latn': 'Sijera Leone',
      zh_TW: '獅子山',
      tr: 'Sierra Leone',
      ro: 'Sierra Leone',
      ar: 'سيراليون',
      fa: 'سیرالئون',
      yue: '塞拉利昂',
    },
  },
  {
    num_code: '702',
    alpha_2_code: 'SG',
    alpha_3_code: 'SGP',
    en_short_name: 'Singapore',
    nationality: 'Singaporean',
    dial_code: '+65',
    nameTranslations: {
      sk: 'Singapur',
      se: 'Singapore',
      pl: 'Singapur',
      no: 'Singapore',
      ja: 'シンガポール',
      it: 'Singapore',
      zh: '新加坡',
      nl: 'Singapore',
      de: 'Singapur',
      fr: 'Singapour',
      es: 'Singapur',
      en: 'Singapore',
      pt_BR: 'Cingapura',
      'sr-Cyrl': 'Сингапур',
      'sr-Latn': 'Singapur',
      zh_TW: '新加坡',
      tr: 'Singapur',
      ro: 'Singapore',
      ar: 'سنغافورة',
      fa: 'سنگاپور',
      yue: '星架坡',
    },
  },
  {
    num_code: '703',
    alpha_2_code: 'SK',
    alpha_3_code: 'SVK',
    en_short_name: 'Slovakia',
    nationality: 'Slovak',
    dial_code: '+421',
    nameTranslations: {
      sk: 'Slovensko',
      se: 'Slovákia',
      pl: 'Słowacja',
      no: 'Slovakia',
      ja: 'スロバキア',
      it: 'Slovacchia',
      zh: '斯洛伐克',
      nl: 'Slowakije',
      de: 'Slowakei',
      fr: 'Slovaquie',
      es: 'Eslovaquia',
      en: 'Slovakia',
      pt_BR: 'Eslováquia',
      'sr-Cyrl': 'Словачка',
      'sr-Latn': 'Slovačka',
      zh_TW: '斯洛伐克',
      tr: 'Slovakya',
      ro: 'Slovacia',
      ar: 'سلوفاكيا',
      fa: 'اسلواکی',
      yue: '斯洛伐克',
    },
  },
  {
    num_code: '705',
    alpha_2_code: 'SI',
    alpha_3_code: 'SVN',
    en_short_name: 'Slovenia',
    nationality: 'Slovenian, Slovene',
    dial_code: '+386',
    nameTranslations: {
      sk: 'Slovinsko',
      se: 'Slovenia',
      pl: 'Słowenia',
      no: 'Slovenia',
      ja: 'スロベニア',
      it: 'Slovenia',
      zh: '斯洛文尼亚',
      nl: 'Slovenië',
      de: 'Slowenien',
      fr: 'Slovénie',
      es: 'Eslovenia',
      en: 'Slovenia',
      pt_BR: 'Eslovênia',
      'sr-Cyrl': 'Словеније',
      'sr-Latn': 'Slovenija',
      zh_TW: '斯洛維尼亞',
      tr: 'Slovenya',
      ro: 'Slovenia',
      ar: 'سلوفينيا',
      fa: 'اسلوونی',
      yue: '斯洛文尼亞',
    },
  },
  {
    num_code: '90',
    alpha_2_code: 'SB',
    alpha_3_code: 'SLB',
    en_short_name: 'Solomon Islands',
    nationality: 'Solomon Island',
    dial_code: '+677',
    nameTranslations: {
      sk: 'Šalamúnove ostrovy',
      se: 'Salomon-sullot',
      pl: 'Wyspy Salomona',
      no: 'Salomonøyene',
      ja: 'ソロモン諸島',
      it: 'Isole Salomone',
      zh: '所罗门群岛',
      nl: 'Salomonseilanden',
      de: 'Salomonen',
      fr: 'Îles Salomon',
      es: 'Islas Salomón',
      en: 'Solomon Islands',
      pt_BR: 'Ilhas Salomão',
      'sr-Cyrl': 'Соломонска Острва',
      'sr-Latn': 'Solomonska Ostrva',
      zh_TW: '所羅門群島',
      tr: 'Solomon Adaları',
      ro: 'Insulele Solomon',
      ar: 'جزر سليمان',
      fa: 'جزایر سلیمان',
      yue: '所羅門群島',
    },
  },
  {
    num_code: '706',
    alpha_2_code: 'SO',
    alpha_3_code: 'SOM',
    en_short_name: 'Somalia',
    nationality: 'Somali, Somalian',
    dial_code: '+252',
    nameTranslations: {
      sk: 'Somálsko',
      se: 'Somália',
      pl: 'Somalia',
      no: 'Somalia',
      ja: 'ソマリア',
      it: 'Somalia',
      zh: '索马里',
      nl: 'Somalië',
      de: 'Somalia',
      fr: 'Somalie',
      es: 'Somalia',
      en: 'Somalia',
      pt_BR: 'Somália',
      'sr-Cyrl': 'Сомалија',
      'sr-Latn': 'Somalija',
      zh_TW: '索馬利亞',
      tr: 'Somali',
      ro: 'Somalia',
      ar: 'الصومال',
      fa: 'سومالی',
      yue: '索馬里',
    },
  },
  {
    num_code: '710',
    alpha_2_code: 'ZA',
    alpha_3_code: 'ZAF',
    en_short_name: 'South Africa',
    nationality: 'South African',
    dial_code: '+27',
    nameTranslations: {
      sk: 'Južná Afrika',
      se: 'Mátta-Afrihká',
      pl: 'Republika Południowej Afryki',
      no: 'Sør-Afrika',
      ja: '南アフリカ',
      it: 'Sudafrica',
      zh: '南非',
      nl: 'Zuid-Afrika',
      de: 'Südafrika',
      fr: 'Afrique du Sud',
      es: 'Sudáfrica',
      en: 'South Africa',
      pt_BR: 'África do Sul',
      'sr-Cyrl': 'Јужноафричка Република',
      'sr-Latn': 'Južnoafrička Republika',
      zh_TW: '南非',
      tr: 'Güney Afrika',
      ro: 'Africa de Sud',
      ar: 'جنوب أفريقيا',
      fa: 'آفریقای جنوبی',
      yue: '南非',
    },
  },
  {
    num_code: '239',
    alpha_2_code: 'GS',
    alpha_3_code: 'SGS',
    en_short_name: 'South Georgia & South Sandwich Islands',
    nationality: 'South Georgia or South Sandwich Islands',
    dial_code: '+500',
    nameTranslations: {
      sk: 'Južná Georgia a Južné Sandwichove ostrovy',
      se: 'Lulli Georgia ja Lulli Sandwich-sullot',
      pl: 'Georgia Południowa i Sandwich Południowy',
      no: 'Sør-Georgia og Sør-Sandwichøyene',
      ja: 'サウスジョージア・サウスサンドウィッチ諸島',
      it: 'Georgia del Sud e Sandwich australi',
      zh: '南乔治亚和南桑威奇群岛',
      nl: 'Zuid-Georgia en Zuidelijke Sandwicheilanden',
      de: 'Südgeorgien und die Südlichen Sandwichinseln',
      fr: 'Géorgie du Sud et îles Sandwich du Sud',
      es: 'Islas Georgia del Sur y Sandwich del Sur',
      en: 'South Georgia & South Sandwich Islands',
      pt_BR: 'Geórgia do Sul e Ilhas Sandwich do Sul',
      'sr-Cyrl': 'Јужна Џорџија и Јужна Сендвичка Острва',
      'sr-Latn': 'Južna Džordžija i Južna Sendvička Ostrva',
      zh_TW: '南喬治亞與南三明治群島 ',
      tr: 'Güney Georgia ve Güney Sandwich Adaları',
      ro: 'Georgia de Sud și Insulele Sandwich de Sud',
      ar: 'جورجيا الجنوبية وجزر ساندويتش الجنوبية',
      fa: 'جزایر جورجیای جنوبی و ساندویچ جنوبی',
      yue: '南喬治亞州同南桑威奇群島',
    },
  },
  {
    num_code: '728',
    alpha_2_code: 'SS',
    alpha_3_code: 'SSD',
    en_short_name: 'South Sudan',
    nationality: 'South Sudanese',
    dial_code: '+211',
    nameTranslations: {
      sk: 'Južný Sudán',
      se: 'Máttasudan',
      pl: 'Sudan Południowy',
      no: 'Sør-Sudan',
      ja: '南スーダン',
      it: 'Sud Sudan',
      zh: '南苏丹',
      nl: 'Zuid-Soedan',
      de: 'Südsudan',
      fr: 'Soudan du Sud',
      es: 'Sudán del Sur',
      en: 'South Sudan',
      pt_BR: 'Sudão do Sul',
      'sr-Cyrl': 'Јужни Судан',
      'sr-Latn': 'Južni Sudan',
      zh_TW: '南蘇丹',
      tr: 'Güney Sudan',
      ro: 'Sudanul de Sud',
      ar: 'جنوب السودان',
      fa: 'سودان جنوبی',
      yue: '南蘇丹',
    },
  },
  {
    num_code: '724',
    alpha_2_code: 'ES',
    alpha_3_code: 'ESP',
    en_short_name: 'Spain',
    nationality: 'Spanish',
    dial_code: '+34',
    nameTranslations: {
      sk: 'Španielsko',
      se: 'Spánia',
      pl: 'Hiszpania',
      no: 'Spania',
      ja: 'スペイン',
      it: 'Spagna',
      zh: '西班牙',
      nl: 'Spanje',
      de: 'Spanien',
      fr: 'Espagne',
      es: 'España',
      en: 'Spain',
      pt_BR: 'Espanha',
      'sr-Cyrl': 'Шпанија',
      'sr-Latn': 'Španija',
      zh_TW: '西班牙',
      tr: 'İspanya',
      ro: 'Spania',
      ar: 'إسبانيا',
      fa: 'اسپانیا',
      yue: '西班牙',
    },
  },
  {
    num_code: '144',
    alpha_2_code: 'LK',
    alpha_3_code: 'LKA',
    en_short_name: 'Sri Lanka',
    nationality: 'Sri Lankan',
    dial_code: '+94',
    nameTranslations: {
      sk: 'Srí Lanka',
      se: 'Sri Lanka',
      pl: 'Sri Lanka',
      no: 'Sri Lanka',
      ja: 'スリランカ',
      it: 'Sri Lanka',
      zh: '斯里兰卡',
      nl: 'Sri Lanka',
      de: 'Sri Lanka',
      fr: 'Sri Lanka',
      es: 'Sri Lanka',
      en: 'Sri Lanka',
      pt_BR: 'Sri Lanka',
      'sr-Cyrl': 'Шри Ланка',
      'sr-Latn': 'Šri Lanka',
      zh_TW: '斯里蘭卡',
      tr: 'Sri Lanka',
      ro: 'Sri Lanka',
      ar: 'سريلانكا',
      fa: 'سریلانکا',
      yue: '斯里蘭卡',
    },
  },
  {
    num_code: '729',
    alpha_2_code: 'SD',
    alpha_3_code: 'SDN',
    en_short_name: 'Sudan',
    nationality: 'Sudanese',
    dial_code: '+249',
    nameTranslations: {
      sk: 'Sudán',
      se: 'Davvisudan',
      pl: 'Sudan',
      no: 'Sudan',
      ja: 'スーダン',
      it: 'Sudan',
      zh: '苏丹',
      nl: 'Soedan',
      de: 'Sudan',
      fr: 'Soudan',
      es: 'Sudán',
      en: 'Sudan',
      pt_BR: 'Sudão',
      'sr-Cyrl': 'Судан',
      'sr-Latn': 'Sudan',
      zh_TW: '蘇丹',
      tr: 'Sudan',
      ro: 'Sudan',
      ar: 'السودان',
      fa: 'سودان',
      yue: '蘇丹',
    },
  },
  {
    num_code: '740',
    alpha_2_code: 'SR',
    alpha_3_code: 'SUR',
    en_short_name: 'Suriname',
    nationality: 'Surinamese',
    dial_code: '+597',
    nameTranslations: {
      sk: 'Surinam',
      se: 'Surinam',
      pl: 'Surinam',
      no: 'Surinam',
      ja: 'スリナム',
      it: 'Suriname',
      zh: '苏里南',
      nl: 'Suriname',
      de: 'Suriname',
      fr: 'Suriname',
      es: 'Surinam',
      en: 'Suriname',
      pt_BR: 'Suriname',
      'sr-Cyrl': 'Суринам',
      'sr-Latn': 'Surinam',
      zh_TW: '蘇利南',
      tr: 'Surinam',
      ro: 'Surinam',
      ar: 'سورينام',
      fa: 'سورینام',
      yue: '蘇里南',
    },
  },
  {
    num_code: '744',
    alpha_2_code: 'SJ',
    alpha_3_code: 'SJM',
    en_short_name: 'Svalbard & Jan Mayen',
    nationality: 'Svalbard',
    dial_code: '+47',
    nameTranslations: {
      sk: 'Svalbard a Jan Mayen',
      se: 'Svalbárda ja Jan Mayen',
      pl: 'Svalbard i Jan Mayen',
      no: 'Svalbard og Jan Mayen',
      ja: 'スバールバル諸島・ヤンマイエン島',
      it: 'Svalbard e Jan Mayen',
      zh: '斯瓦尔巴和扬马延',
      nl: 'Spitsbergen en Jan Mayen',
      de: 'Spitzbergen und Jan Mayen',
      fr: 'Svalbard et Jan Mayen',
      es: 'Svalbard y Jan Mayen',
      en: 'Svalbard & Jan Mayen',
      pt_BR: 'Svalbard e Jan Mayen',
      'sr-Cyrl': 'Свалбард',
      'sr-Latn': 'Svalbard',
      zh_TW: '斯瓦巴及尖棉',
      tr: 'Svalbard ve Jan Mayen',
      ro: 'Svalbard și Jan Mayen',
      ar: 'سفالبارد ويان ماين',
      fa: 'سوالبارد و یان ماین',
      yue: '斯瓦尔巴德同扬·马延',
    },
  },
  {
    num_code: '748',
    alpha_2_code: 'SZ',
    alpha_3_code: 'SWZ',
    en_short_name: 'Eswatini',
    nationality: 'Swazi',
    dial_code: '+268',
    nameTranslations: {
      sk: 'Eswatini',
      se: 'Svazieana',
      pl: 'Eswatini',
      no: 'Eswatini',
      ja: 'エスワティニ',
      it: 'Swaziland',
      zh: '斯威士兰',
      nl: 'eSwatini',
      de: 'Eswatini',
      fr: 'Eswatini',
      es: 'Esuatini',
      en: 'Eswatini',
      pt_BR: 'Eswatini',
      'sr-Cyrl': 'Свазиланд',
      'sr-Latn': 'Svaziland',
      zh_TW: '史瓦帝尼',
      tr: 'Esvatini',
      ro: 'Eswatini',
      ar: 'إسواتيني',
      fa: 'اسواتینی',
      yue: '斯威士蘭',
    },
  },
  {
    num_code: '752',
    alpha_2_code: 'SE',
    alpha_3_code: 'SWE',
    en_short_name: 'Sweden',
    nationality: 'Swedish',
    dial_code: '+46',
    nameTranslations: {
      sk: 'Švédsko',
      se: 'Ruoŧŧa',
      pl: 'Szwecja',
      no: 'Sverige',
      ja: 'スウェーデン',
      it: 'Svezia',
      zh: '瑞典',
      nl: 'Zweden',
      de: 'Schweden',
      fr: 'Suède',
      es: 'Suecia',
      en: 'Sweden',
      pt_BR: 'Suécia',
      'sr-Cyrl': 'Шведска',
      'sr-Latn': 'Švedska',
      zh_TW: '瑞典',
      tr: 'İsveç',
      ro: 'Suedia',
      ar: 'السويد',
      fa: 'سوئد',
      yue: '瑞典',
    },
  },
  {
    num_code: '756',
    alpha_2_code: 'CH',
    alpha_3_code: 'CHE',
    en_short_name: 'Switzerland',
    nationality: 'Swiss',
    dial_code: '+41',
    nameTranslations: {
      sk: 'Švajčiarsko',
      se: 'Šveica',
      pl: 'Szwajcaria',
      no: 'Sveits',
      ja: 'スイス',
      it: 'Svizzera',
      zh: '瑞士',
      nl: 'Zwitserland',
      de: 'Schweiz',
      fr: 'Suisse',
      es: 'Suiza',
      en: 'Switzerland',
      pt_BR: 'Suíça',
      'sr-Cyrl': 'Швајцарска',
      'sr-Latn': 'Švajcarska',
      zh_TW: '瑞士',
      tr: 'İsviçre',
      ro: 'Elveţia',
      ar: 'سويسرا',
      fa: 'سوئیس',
      yue: '瑞士',
    },
  },
  {
    num_code: '760',
    alpha_2_code: 'SY',
    alpha_3_code: 'SYR',
    en_short_name: 'Syria',
    nationality: 'Syrian',
    dial_code: '+963',
    nameTranslations: {
      sk: 'Sýria',
      se: 'Syria',
      pl: 'Syria',
      no: 'Syria',
      ja: 'シリア',
      it: 'Siria',
      zh: '叙利亚',
      nl: 'Syrië',
      de: 'Syrien',
      fr: 'Syrie',
      es: 'Siria',
      en: 'Syria',
      pt_BR: 'Síria',
      'sr-Cyrl': 'Сирија',
      'sr-Latn': 'Sirija',
      zh_TW: '敘利亞',
      tr: 'Suriye',
      ro: 'Siria',
      ar: 'سوريا',
      fa: 'سوریه',
      yue: '阿拉伯敘利亞共和國',
    },
  },
  {
    num_code: '158',
    alpha_2_code: 'TW',
    alpha_3_code: 'TWN',
    en_short_name: 'Taiwan',
    nationality: 'Chinese, Taiwanese',
    dial_code: '+886',
    nameTranslations: {
      sk: 'Taiwan',
      se: 'Taiwan',
      pl: 'Tajwan',
      no: 'Taiwan',
      ja: '台湾',
      it: 'Taiwan',
      zh: '台湾',
      nl: 'Taiwan',
      de: 'Taiwan',
      fr: 'Taïwan',
      es: 'Taiwán',
      en: 'Taiwan',
      pt_BR: 'Taiwan',
      'sr-Cyrl': 'Тајван',
      'sr-Latn': 'Tajvan',
      zh_TW: '台灣',
      tr: 'Tayvan',
      ro: 'Taiwan',
      ar: 'تايوان',
      fa: 'تایوان',
      yue: '台灣',
    },
  },
  {
    num_code: '762',
    alpha_2_code: 'TJ',
    alpha_3_code: 'TJK',
    en_short_name: 'Tajikistan',
    nationality: 'Tajikistani',
    dial_code: '+992',
    nameTranslations: {
      sk: 'Tadžikistan',
      se: 'Tažikistan',
      pl: 'Tadżykistan',
      no: 'Tadsjikistan',
      ja: 'タジキスタン',
      it: 'Tagikistan',
      zh: '塔吉克斯坦',
      nl: 'Tadzjikistan',
      de: 'Tadschikistan',
      fr: 'Tadjikistan',
      es: 'Tayikistán',
      en: 'Tajikistan',
      pt_BR: 'Tajiquistão',
      'sr-Cyrl': 'Таџикистан',
      'sr-Latn': 'Tadžikistan',
      zh_TW: '塔吉克',
      tr: 'Tacikistan',
      ro: 'Tadiquistão',
      ar: 'طاجيكستان',
      fa: 'تاجیکستان',
      yue: '塔吉克斯坦',
    },
  },
  {
    num_code: '834',
    alpha_2_code: 'TZ',
    alpha_3_code: 'TZA',
    en_short_name: 'Tanzania',
    nationality: 'Tanzanian',
    dial_code: '+255',
    nameTranslations: {
      sk: 'Tanzánia',
      se: 'Tanzánia',
      pl: 'Tanzania',
      no: 'Tanzania',
      ja: 'タンザニア',
      it: 'Tanzania',
      zh: '坦桑尼亚',
      nl: 'Tanzania',
      de: 'Tansania',
      fr: 'Tanzanie',
      es: 'Tanzania',
      en: 'Tanzania',
      pt_BR: 'Tanzânia',
      'sr-Cyrl': 'Танзанија',
      'sr-Latn': 'Tanzanija',
      zh_TW: '坦尚尼亞',
      tr: 'Tanzanya',
      ro: 'Tanzania',
      ar: 'تنزانيا',
      fa: 'تانزانیا',
      yue: '坦桑尼亞，聯合共和國',
    },
  },
  {
    num_code: '764',
    alpha_2_code: 'TH',
    alpha_3_code: 'THA',
    en_short_name: 'Thailand',
    nationality: 'Thai',
    dial_code: '+66',
    nameTranslations: {
      sk: 'Thajsko',
      se: 'Thaieana',
      pl: 'Tajlandia',
      no: 'Thailand',
      ja: 'タイ',
      it: 'Thailandia',
      zh: '泰国',
      nl: 'Thailand',
      de: 'Thailand',
      fr: 'Thaïlande',
      es: 'Tailandia',
      en: 'Thailand',
      pt_BR: 'Tailândia',
      'sr-Cyrl': 'Тајланд',
      'sr-Latn': 'Tajland',
      zh_TW: '泰國',
      tr: 'Tayland',
      ro: 'Tailanda',
      ar: 'تايلاند',
      fa: 'تایلند',
      yue: '泰國',
    },
  },
  {
    num_code: '626',
    alpha_2_code: 'TL',
    alpha_3_code: 'TLS',
    en_short_name: 'Timor-Leste',
    nationality: 'Timorese',
    dial_code: '+670',
    nameTranslations: {
      sk: 'Východný Timor',
      se: 'Nuorta-Timor',
      pl: 'Timor Wschodni',
      no: 'Øst-Timor',
      ja: '東ティモール',
      it: 'Timor Est',
      zh: '东帝汶',
      nl: 'Oost-Timor',
      de: 'Timor-Leste',
      fr: 'Timor oriental',
      es: 'Timor-Leste',
      en: 'Timor-Leste',
      pt_BR: 'Timor-Leste',
      'sr-Cyrl': 'Источни Тимор',
      'sr-Latn': 'Istočni Timor',
      zh_TW: '東帝汶',
      tr: 'Doğu Timor',
      ro: 'Timorul de Est',
      ar: 'تيمور الشرقية',
      fa: 'تیمور شرقی',
      yue: '東帝汶',
    },
  },
  {
    num_code: '768',
    alpha_2_code: 'TG',
    alpha_3_code: 'TGO',
    en_short_name: 'Togo',
    nationality: 'Togolese',
    dial_code: '+228',
    nameTranslations: {
      sk: 'Togo',
      se: 'Togo',
      pl: 'Togo',
      no: 'Togo',
      ja: 'トーゴ',
      it: 'Togo',
      zh: '多哥',
      nl: 'Togo',
      de: 'Togo',
      fr: 'Togo',
      es: 'Togo',
      en: 'Togo',
      pt_BR: 'Ir',
      'sr-Cyrl': 'Того',
      'sr-Latn': 'Togo',
      zh_TW: '多哥',
      tr: 'Togo',
      ro: 'Togo',
      ar: 'توغو',
      fa: 'توگو',
      yue: '多哥',
    },
  },
  {
    num_code: '772',
    alpha_2_code: 'TK',
    alpha_3_code: 'TKL',
    en_short_name: 'Tokelau',
    nationality: 'Tokelauan',
    dial_code: '+690',
    nameTranslations: {
      sk: 'Tokelau',
      se: 'Tokelau',
      pl: 'Tokelau',
      no: 'Tokelau',
      ja: 'トケラウ',
      it: 'Tokelau',
      zh: '托克劳',
      nl: 'Tokelau',
      de: 'Tokelau',
      fr: 'Tokelau',
      es: 'Tokelau',
      en: 'Tokelau',
      pt_BR: 'Tokelau',
      'sr-Cyrl': 'Токелау',
      'sr-Latn': 'Tokelau',
      zh_TW: '托克勞',
      tr: 'Tokelau',
      ro: 'Tokelau',
      ar: 'توكيلاو',
      fa: 'توکلائو',
      yue: '托克劳',
    },
  },
  {
    num_code: '776',
    alpha_2_code: 'TO',
    alpha_3_code: 'TON',
    en_short_name: 'Tonga',
    nationality: 'Tongan',
    dial_code: '+676',
    nameTranslations: {
      sk: 'Tonga',
      se: 'Tonga',
      pl: 'Tonga',
      no: 'Tonga',
      ja: 'トンガ',
      it: 'Tonga',
      zh: '汤加',
      nl: 'Tonga',
      de: 'Tonga',
      fr: 'Tonga',
      es: 'Tonga',
      en: 'Tonga',
      pt_BR: 'Tonga',
      'sr-Cyrl': 'Тонга',
      'sr-Latn': 'Tonga',
      zh_TW: '東加',
      tr: 'Tonga',
      ro: 'Tonga',
      ar: 'تونغا',
      fa: 'تونگا',
      yue: '湯加',
    },
  },
  {
    num_code: '780',
    alpha_2_code: 'TT',
    alpha_3_code: 'TTO',
    en_short_name: 'Trinidad & Tobago',
    nationality: 'Trinidadian or Tobagonian',
    dial_code: '+1868',
    nameTranslations: {
      sk: 'Trinidad a Tobago',
      se: 'Trinidad ja Tobago',
      pl: 'Trynidad i Tobago',
      no: 'Trinidad og Tobago',
      ja: 'トリニダード・トバゴ',
      it: 'Trinidad e Tobago',
      zh: '特立尼达和多巴哥',
      nl: 'Trinidad en Tobago',
      de: 'Trinidad und Tobago',
      fr: 'Trinité-et-Tobago',
      es: 'Trinidad y Tobago',
      en: 'Trinidad & Tobago',
      pt_BR: 'Trinidad e Tobago',
      'sr-Cyrl': 'Тринидад и Тобаго',
      'sr-Latn': 'Trinidad i Tobago',
      zh_TW: '千里達及托巴哥',
      tr: 'Trinidad ve Tobago',
      ro: 'Trinidad şi Tobago',
      ar: 'ترينيداد وتوباغو',
      fa: 'ترینیداد و توباگو',
      yue: '特立尼達和多巴哥',
    },
  },
  {
    num_code: '788',
    alpha_2_code: 'TN',
    alpha_3_code: 'TUN',
    en_short_name: 'Tunisia',
    nationality: 'Tunisian',
    dial_code: '+216',
    nameTranslations: {
      sk: 'Tunisko',
      se: 'Tunisia',
      pl: 'Tunezja',
      no: 'Tunisia',
      ja: 'チュニジア',
      it: 'Tunisia',
      zh: '突尼斯',
      nl: 'Tunesië',
      de: 'Tunesien',
      fr: 'Tunisie',
      es: 'Túnez',
      en: 'Tunisia',
      pt_BR: 'Tunísia',
      'sr-Cyrl': 'Тунис',
      'sr-Latn': 'Tunis',
      zh_TW: '突尼西亞',
      tr: 'Tunus',
      ro: 'Tunisia',
      ar: 'تونس',
      fa: 'تونس',
      yue: '突尼斯',
    },
  },
  {
    num_code: '792',
    alpha_2_code: 'TR',
    alpha_3_code: 'TUR',
    en_short_name: 'Turkey',
    nationality: 'Turkish',
    dial_code: '+90',
    nameTranslations: {
      sk: 'Turecko',
      se: 'Durka',
      pl: 'Turcja',
      no: 'Tyrkia',
      ja: 'トルコ',
      it: 'Turchia',
      zh: '土耳其',
      nl: 'Turkije',
      de: 'Türkei',
      fr: 'Turquie',
      es: 'Turquía',
      en: 'Turkey',
      pt_BR: 'Peru',
      'sr-Cyrl': 'Турска',
      'sr-Latn': 'Turska',
      zh_TW: '土耳其',
      tr: 'Türkiye',
      ro: 'Turcia',
      ar: 'تركيا',
      fa: 'ترکیه',
      yue: '土耳其',
    },
  },
  {
    num_code: '795',
    alpha_2_code: 'TM',
    alpha_3_code: 'TKM',
    en_short_name: 'Turkmenistan',
    nationality: 'Turkmen',
    dial_code: '+993',
    nameTranslations: {
      sk: 'Turkménsko',
      se: 'Turkmenistan',
      pl: 'Turkmenistan',
      no: 'Turkmenistan',
      ja: 'トルクメニスタン',
      it: 'Turkmenistan',
      zh: '土库曼斯坦',
      nl: 'Turkmenistan',
      de: 'Turkmenistan',
      fr: 'Turkménistan',
      es: 'Turkmenistán',
      en: 'Turkmenistan',
      pt_BR: 'Turcomenistão',
      'sr-Cyrl': 'Туркменистан',
      'sr-Latn': 'Turkmenistan',
      zh_TW: '土庫曼',
      tr: 'Türkmenistan',
      ro: 'Turkmenistan',
      ar: 'تركمانستان',
      fa: 'ترکمنستان',
      yue: '土庫曼斯坦',
    },
  },
  {
    num_code: '796',
    alpha_2_code: 'TC',
    alpha_3_code: 'TCA',
    en_short_name: 'Turks & Caicos Islands',
    nationality: 'Turks and Caicos Island',
    dial_code: '+1649',
    nameTranslations: {
      sk: 'Turks a Caicos',
      se: 'Turks ja Caicos-sullot',
      pl: 'Turks i Caicos',
      no: 'Turks- og Caicosøyene',
      ja: 'タークス・カイコス諸島',
      it: 'Isole Turks e Caicos',
      zh: '特克斯和凯科斯群岛',
      nl: 'Turks- en Caicoseilanden',
      de: 'Turks- und Caicosinseln',
      fr: 'Îles Turques-et-Caïques',
      es: 'Islas Turcas y Caicos',
      en: 'Turks & Caicos Islands',
      pt_BR: 'Ilhas Turks e Caicos',
      'sr-Cyrl': 'Туркс и Кајкос',
      'sr-Latn': 'Turks i Kajkos',
      zh_TW: '土克斯及開科斯群島',
      tr: 'Turks ve Caicos Adaları',
      ro: 'Insulele Turks și Caicos',
      ar: 'جزر توركس وكايكوس',
      fa: 'جزایر تورکس و کایکوس',
      yue: '特克斯同凯科斯群岛',
    },
  },
  {
    num_code: '798',
    alpha_2_code: 'TV',
    alpha_3_code: 'TUV',
    en_short_name: 'Tuvalu',
    nationality: 'Tuvaluan',
    dial_code: '+688',
    nameTranslations: {
      sk: 'Tuvalu',
      se: 'Tuvalu',
      pl: 'Tuvalu',
      no: 'Tuvalu',
      ja: 'ツバル',
      it: 'Tuvalu',
      zh: '图瓦卢',
      nl: 'Tuvalu',
      de: 'Tuvalu',
      fr: 'Tuvalu',
      es: 'Tuvalu',
      en: 'Tuvalu',
      pt_BR: 'Tuvalu',
      'sr-Cyrl': 'Тувалу',
      'sr-Latn': 'Tuvalu',
      zh_TW: '圖瓦盧',
      tr: 'Tuvalu',
      ro: 'Tuvalu',
      ar: 'توفالو',
      fa: 'تووالو',
      yue: '圖瓦盧',
    },
  },
  {
    num_code: '800',
    alpha_2_code: 'UG',
    alpha_3_code: 'UGA',
    en_short_name: 'Uganda',
    nationality: 'Ugandan',
    dial_code: '+256',
    nameTranslations: {
      sk: 'Uganda',
      se: 'Uganda',
      pl: 'Uganda',
      no: 'Uganda',
      ja: 'ウガンダ',
      it: 'Uganda',
      zh: '乌干达',
      nl: 'Oeganda',
      de: 'Uganda',
      fr: 'Ouganda',
      es: 'Uganda',
      en: 'Uganda',
      pt_BR: 'Uganda',
      'sr-Cyrl': 'Уганда',
      'sr-Latn': 'Uganda',
      zh_TW: '烏干達',
      tr: 'Uganda',
      ro: 'Uganda',
      ar: 'أوغندا',
      fa: 'اوگاندا',
      yue: '烏干達',
    },
  },
  {
    num_code: '804',
    alpha_2_code: 'UA',
    alpha_3_code: 'UKR',
    en_short_name: 'Ukraine',
    nationality: 'Ukrainian',
    dial_code: '+380',
    nameTranslations: {
      sk: 'Ukrajina',
      se: 'Ukraina',
      pl: 'Ukraina',
      no: 'Ukraina',
      ja: 'ウクライナ',
      it: 'Ucraina',
      zh: '乌克兰',
      nl: 'Oekraïne',
      de: 'Ukraine',
      fr: 'Ukraine',
      es: 'Ucrania',
      en: 'Ukraine',
      pt_BR: 'Ucrânia',
      'sr-Cyrl': 'Украјина',
      'sr-Latn': 'Ukrajina',
      zh_TW: '烏克蘭',
      tr: 'Ukrayna',
      ro: 'Ucraína',
      ar: 'أوكرانيا',
      fa: 'اوکراین',
      yue: '烏克蘭',
    },
  },
  {
    num_code: '784',
    alpha_2_code: 'AE',
    alpha_3_code: 'ARE',
    en_short_name: 'United Arab Emirates',
    nationality: 'Emirati, Emirian, Emiri',
    dial_code: '+971',
    nameTranslations: {
      sk: 'Spojené arabské emiráty',
      se: 'Ovttastuvvan Arábaemiráhtat',
      pl: 'Zjednoczone Emiraty Arabskie',
      no: 'De forente arabiske emirater',
      ja: 'アラブ首長国連邦',
      it: 'Emirati Arabi Uniti',
      zh: '阿拉伯联合酋长国',
      nl: 'Verenigde Arabische Emiraten',
      de: 'Vereinigte Arabische Emirate',
      fr: 'Émirats arabes unis',
      es: 'Emiratos Árabes Unidos',
      en: 'United Arab Emirates',
      pt_BR: 'Emirados Árabes Unidos',
      'sr-Cyrl': 'Уједињени Арапски Емирати',
      'sr-Latn': 'Ujedinjeni Arapski Emirati',
      zh_TW: '阿拉伯聯合大公國',
      tr: 'Birleşik Arap Emirlikleri',
      ro: 'Emiratele Arabe Unite',
      ar: 'الإمارات العربية المتحدة',
      fa: 'امارات متحده عربی',
      yue: '阿拉伯聯合酋長國',
    },
  },
  {
    num_code: '826',
    alpha_2_code: 'GB',
    alpha_3_code: 'GBR',
    en_short_name: 'United Kingdom',
    nationality: 'British, UK',
    dial_code: '+44',
    nameTranslations: {
      sk: 'Spojené kráľovstvo',
      se: 'Stuorra-Británnia',
      pl: 'Wielka Brytania',
      no: 'Storbritannia',
      ja: 'イギリス',
      it: 'Regno Unito',
      zh: '英国',
      nl: 'Verenigd Koninkrijk',
      de: 'Vereinigtes Königreich',
      fr: 'Royaume-Uni',
      es: 'Reino Unido',
      en: 'United Kingdom',
      pt_BR: 'Reino Unido',
      'sr-Cyrl': 'Уједињено Краљевство',
      'sr-Latn': 'Ujedinjeno Kraljevstvo',
      zh_TW: '英國',
      tr: 'Büyük Britanya ve Kuzey İrlanda Birleşik Krallığ',
      ro: 'Regatul Unit al Marii Britanii și Irlandei de Nord',
      ar: 'المملكة المتحدة',
      fa: 'بریتانیا',
      yue: '大不列顛及北愛爾蘭聯合王國',
    },
  },
  {
    num_code: '840',
    alpha_2_code: 'US',
    alpha_3_code: 'USA',
    en_short_name: 'United States',
    nationality: 'American',
    dial_code: '+1',
    nameTranslations: {
      sk: 'Spojené štáty',
      se: 'Amerihká ovttastuvvan stáhtat',
      pl: 'Stany Zjednoczone',
      no: 'USA',
      ja: 'アメリカ合衆国',
      it: 'Stati Uniti',
      zh: '美国',
      nl: 'Verenigde Staten',
      de: 'Vereinigte Staaten',
      fr: 'États-Unis',
      es: 'Estados Unidos',
      en: 'United States',
      pt_BR: 'Estados Unidos',
      'sr-Cyrl': 'Сједињене Америчке Државе',
      'sr-Latn': 'Sjedinjene Američke Države',
      zh_TW: '美國',
      tr: 'Amerika Birleşik Devletleri',
      ro: 'Statele Unite ale Americii',
      ar: 'الولايات المتحدة',
      fa: 'ایالات متحده آمریکا',
      yue: '美利堅郃眾囯',
    },
  },
  {
    num_code: '858',
    alpha_2_code: 'UY',
    alpha_3_code: 'URY',
    en_short_name: 'Uruguay',
    nationality: 'Uruguayan',
    dial_code: '+598',
    nameTranslations: {
      sk: 'Uruguaj',
      se: 'Uruguay',
      pl: 'Urugwaj',
      no: 'Uruguay',
      ja: 'ウルグアイ',
      it: 'Uruguay',
      zh: '乌拉圭',
      nl: 'Uruguay',
      de: 'Uruguay',
      fr: 'Uruguay',
      es: 'Uruguay',
      en: 'Uruguay',
      pt_BR: 'Uruguai',
      'sr-Cyrl': 'Уругвај',
      'sr-Latn': 'Urugvaj',
      zh_TW: '烏拉圭',
      tr: 'Uruguay',
      ro: 'Uruguay',
      ar: 'الأوروغواي',
      fa: 'اروگوئه',
      yue: '烏拉圭',
    },
  },
  {
    num_code: '860',
    alpha_2_code: 'UZ',
    alpha_3_code: 'UZB',
    en_short_name: 'Uzbekistan',
    nationality: 'Uzbekistani, Uzbek',
    dial_code: '+998',
    nameTranslations: {
      sk: 'Uzbekistan',
      se: 'Usbekistan',
      pl: 'Uzbekistan',
      no: 'Usbekistan',
      ja: 'ウズベキスタン',
      it: 'Uzbekistan',
      zh: '乌兹别克斯坦',
      nl: 'Oezbekistan',
      de: 'Usbekistan',
      fr: 'Ouzbékistan',
      es: 'Uzbekistán',
      en: 'Uzbekistan',
      pt_BR: 'Uzbequistão',
      'sr-Cyrl': 'Узбекистан',
      'sr-Latn': 'Uzbekistan',
      zh_TW: '烏玆別克',
      tr: 'Özbekistan',
      ro: 'Uzbekistan',
      ar: 'أوزبكستان',
      fa: 'ازبکستان',
      yue: '月即別',
    },
  },
  {
    num_code: '548',
    alpha_2_code: 'VU',
    alpha_3_code: 'VUT',
    en_short_name: 'Vanuatu',
    nationality: 'Ni-Vanuatu, Vanuatuan',
    dial_code: '+678',
    nameTranslations: {
      sk: 'Vanuatu',
      se: 'Vanuatu',
      pl: 'Vanuatu',
      no: 'Vanuatu',
      ja: 'バヌアツ',
      it: 'Vanuatu',
      zh: '瓦努阿图',
      nl: 'Vanuatu',
      de: 'Vanuatu',
      fr: 'Vanuatu',
      es: 'Vanuatu',
      en: 'Vanuatu',
      pt_BR: 'Vanuatu',
      'sr-Cyrl': 'Вануату',
      'sr-Latn': 'Vanuatu',
      zh_TW: '瓦努阿圖',
      tr: 'Vanuatu',
      ro: 'Vanuatu',
      ar: 'فانواتو',
      fa: 'وانواتو',
      yue: '瓦努阿圖',
    },
  },
  {
    num_code: '862',
    alpha_2_code: 'VE',
    alpha_3_code: 'VEN',
    en_short_name: 'Venezuela',
    nationality: 'Venezuelan',
    dial_code: '+58',
    nameTranslations: {
      sk: 'Venezuela',
      se: 'Venezuela',
      pl: 'Wenezuela',
      no: 'Venezuela',
      ja: 'ベネズエラ',
      it: 'Venezuela',
      zh: '委内瑞拉',
      nl: 'Venezuela',
      de: 'Venezuela',
      fr: 'Venezuela',
      es: 'Venezuela',
      en: 'Venezuela',
      pt_BR: 'Venezuela',
      'sr-Cyrl': 'Венецуела',
      'sr-Latn': 'Venecuela',
      zh_TW: '委內瑞拉',
      tr: 'Venezuela',
      ro: 'Venezuela',
      ar: 'فنزويلا',
      fa: 'ونزوئلا',
      yue: '委內瑞拉（玻利瓦爾共和國）',
    },
  },
  {
    num_code: '704',
    alpha_2_code: 'VN',
    alpha_3_code: 'VNM',
    en_short_name: 'Vietnam',
    nationality: 'Vietnamese',
    dial_code: '+84',
    nameTranslations: {
      sk: 'Vietnam',
      se: 'Vietnam',
      pl: 'Wietnam',
      no: 'Vietnam',
      ja: 'ベトナム',
      it: 'Vietnam',
      zh: '越南',
      nl: 'Vietnam',
      de: 'Vietnam',
      fr: 'Vietnam',
      es: 'Vietnam',
      en: 'Vietnam',
      pt_BR: 'Vietnã',
      'sr-Cyrl': 'Вијетнам',
      'sr-Latn': 'Vijetnam',
      zh_TW: '越南',
      tr: 'Vietnam',
      ro: 'Vietnam',
      ar: 'فيتنام',
      fa: 'ویتنام',
      yue: '越南',
    },
  },
  {
    num_code: '92',
    alpha_2_code: 'VG',
    alpha_3_code: 'VGB',
    en_short_name: 'British Virgin Islands',
    nationality: 'British Virgin Island',
    dial_code: '+1284',
    nameTranslations: {
      sk: 'Britské Panenské ostrovy',
      se: 'Brittania Virgin-sullot',
      pl: 'Brytyjskie Wyspy Dziewicze',
      no: 'De britiske jomfruøyene',
      ja: '英領ヴァージン諸島',
      it: 'Isole Vergini Britanniche',
      zh: '英属维尔京群岛',
      nl: 'Britse Maagdeneilanden',
      de: 'Britische Jungferninseln',
      fr: 'Îles Vierges britanniques',
      es: 'Islas Vírgenes Británicas',
      en: 'British Virgin Islands',
      pt_BR: 'Ilhas Virgens Britânicas',
      'sr-Cyrl': 'Британска Девичанска Острва',
      'sr-Latn': 'Britanska Devičanska Ostrva',
      zh_TW: '英屬維京群島',
      tr: 'Britanya Virjin Adaları',
      ro: 'Insulele Virgine Britanice',
      ar: 'جزر العذراء البريطانية',
      fa: 'جزایر ویرجین بریتانیا',
      yue: '維爾京群島（英國）',
    },
  },
  {
    num_code: '850',
    alpha_2_code: 'VI',
    alpha_3_code: 'VIR',
    en_short_name: 'U.S. Virgin Islands',
    nationality: 'U.S. Virgin Island',
    dial_code: '+1340',
    nameTranslations: {
      sk: 'Americké Panenské ostrovy',
      se: 'AOS Virgin-sullot',
      pl: 'Wyspy Dziewicze Stanów Zjednoczonych',
      no: 'De amerikanske jomfruøyene',
      ja: '米領ヴァージン諸島',
      it: 'Isole Vergini Americane',
      zh: '美属维尔京群岛',
      nl: 'Amerikaanse Maagdeneilanden',
      de: 'Amerikanische Jungferninseln',
      fr: 'Îles Vierges des États-Unis',
      es: 'Islas Vírgenes de EE. UU.',
      en: 'U.S. Virgin Islands',
      pt_BR: 'Ilhas Virgens Americanas',
      'sr-Cyrl': 'Амепичка Девичанска Острва',
      'sr-Latn': 'Američka Devičanska Ostrva',
      zh_TW: '美屬維京群島',
      tr: 'Amerika Birleşik Devletleri Virjin Adaları',
      ro: 'Insulele Virgine Americane',
      ar: 'جزر العذراء الأمريكية',
      fa: 'جزایر ویرجین ایالات متحده آمریکا',
      yue: '維爾京群島（美國）',
    },
  },
  {
    num_code: '876',
    alpha_2_code: 'WF',
    alpha_3_code: 'WLF',
    en_short_name: 'Wallis & Futuna',
    nationality: 'Wallis and Futuna, Wallisian or Futunan',
    dial_code: '+681',
    nameTranslations: {
      sk: 'Wallis a Futuna',
      se: 'Wallis ja Futuna',
      pl: 'Wallis i Futuna',
      no: 'Wallis og Futuna',
      ja: 'ウォリス・フツナ',
      it: 'Wallis e Futuna',
      zh: '瓦利斯和富图纳',
      nl: 'Wallis en Futuna',
      de: 'Wallis und Futuna',
      fr: 'Wallis-et-Futuna',
      es: 'Wallis y Futuna',
      en: 'Wallis & Futuna',
      pt_BR: 'Wallis e Futuna',
      'sr-Cyrl': 'Валис и Футуна',
      'sr-Latn': 'Valis i Futuna',
      zh_TW: '瓦利斯和富圖那',
      tr: 'Wallis ve Futuna',
      ro: 'Wallis și Futuna',
      ar: 'والس وفوتونا',
      fa: 'والیس و فوتونا',
      yue: '瓦利斯同富图纳',
    },
  },
  {
    num_code: '887',
    alpha_2_code: 'YE',
    alpha_3_code: 'YEM',
    en_short_name: 'Yemen',
    nationality: 'Yemeni',
    dial_code: '+967',
    nameTranslations: {
      sk: 'Jemen',
      se: 'Jemen',
      pl: 'Jemen',
      no: 'Jemen',
      ja: 'イエメン',
      it: 'Yemen',
      zh: '也门',
      nl: 'Jemen',
      de: 'Jemen',
      fr: 'Yémen',
      es: 'Yemen',
      en: 'Yemen',
      pt_BR: 'Iémen',
      'sr-Cyrl': 'Јемен',
      'sr-Latn': 'Jemen',
      zh_TW: '葉門',
      tr: 'Yemen',
      ro: 'Yemen',
      ar: 'اليمن',
      fa: 'یمن',
      yue: '也門',
    },
  },
  {
    num_code: '894',
    alpha_2_code: 'ZM',
    alpha_3_code: 'ZMB',
    en_short_name: 'Zambia',
    nationality: 'Zambian',
    dial_code: '+260',
    nameTranslations: {
      sk: 'Zambia',
      se: 'Zambia',
      pl: 'Zambia',
      no: 'Zambia',
      ja: 'ザンビア',
      it: 'Zambia',
      zh: '赞比亚',
      nl: 'Zambia',
      de: 'Sambia',
      fr: 'Zambie',
      es: 'Zambia',
      en: 'Zambia',
      pt_BR: 'Zâmbia',
      'sr-Cyrl': 'Замбија',
      'sr-Latn': 'Zambija',
      zh_TW: '贊比亞',
      tr: 'Zambiya',
      ro: 'Zambia',
      ar: 'زامبيا',
      fa: 'زامبیا',
      yue: '贊比亞',
    },
  },
  {
    num_code: '716',
    alpha_2_code: 'ZW',
    alpha_3_code: 'ZWE',
    en_short_name: 'Zimbabwe',
    nationality: 'Zimbabwean',
    dial_code: '+263',
    nameTranslations: {
      sk: 'Zimbabwe',
      se: 'Zimbabwe',
      pl: 'Zimbabwe',
      no: 'Zimbabwe',
      ja: 'ジンバブエ',
      it: 'Zimbabwe',
      zh: '津巴布韦',
      nl: 'Zimbabwe',
      de: 'Simbabwe',
      fr: 'Zimbabwe',
      es: 'Zimbabue',
      en: 'Zimbabwe',
      pt_BR: 'Zimbábue',
      'sr-Cyrl': 'Зимбабве',
      'sr-Latn': 'Zimbabve',
      zh_TW: '辛巴威',
      tr: 'Zimbabve',
      ro: 'Zimbabwe',
      ar: 'زيمبابوي',
      fa: 'زیمبابوه',
      yue: '津巴布韋',
    },
  },
];
